/* eslint-disable operator-assignment */
/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
/* eslint-disable semi */
/* eslint-disable prettier/prettier */
/* eslint-disable default-param-last */
/* eslint-disable no-use-before-define */

import Icon, {
  CheckOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Checkbox,
  Collapse,
  Drawer,
  Form,
  Popover,
  Radio,
  Spin,
  Tooltip,
  message,
} from "antd";
import dayjs from "dayjs";
import { isEmpty, isEqual, isUndefined, sumBy, uniq, uniqBy } from "lodash";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "@reach/router";
import styled from "styled-components";
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import {
  getDefaultTabId,
  getMostRecentPermittedRootOppTypeId,
  getMostRecentPermittedRootOppTypeIdInFilter,
  getRootOppTypeId,
  oppMatchesTab,
} from "../../../library/oppTypeScoping";
import { UserContext } from "../../../amplify/authenticator-provider";
import {
  BROADCAST_UNREAD_COUNT,
  CREATE_EMAIL,
  CREATE_LEAD,
  CREATE_LEAD_EMAIL,
  CREATE_LEAD_PHONE,
  CREATE_MESSAGE,
  CREATE_MMS,
  RETRY_MESSAGE_SEND,
  TRANSLATE_MESSAGE,
  UPDATE_LEAD,
  UPDATE_LEAD_CONSENT,
  UPDATE_LEAD_CONVERSATION_STATUS,
  UPDATE_LEAD_EMAIL,
  UPDATE_LEAD_PHONE,
  UPDATE_TRANSLATION_SETTINGS,
} from "../../../graphql/mutation";
import {
  EDIT_LEAD,
  GET_ALL_TEAMS,
  GET_ALL_USERS_ACTIVITY_CENTER,
  GET_OPPORTUNITY_USER_TYPE,
  GET_CAMPAIGN_LIST_FILTERS,
  GET_COMPANY_AFTER_MESSAGE_CONSENT_TEMPLATE,
  GET_COMPANY_CONSENT,
  GET_COMPANY_CONSENT_TEMPLATES,
  GET_CONSENT_TEMPLATE,
  GET_CRM_LEAD_STATUS,
  GET_EXTENSION_LEAD_SOURCES,
  GET_EXTENSION_LIST_ACTIVITY_CENTER,
  GET_LEAD_DETAIL_ACTIVITY_CENTER_V2,
  GET_MESSAGES_V2,
  GET_POTENTIAL_LEADS_BY_ID,
  GET_SCHEDULED_MESSAGES_FOR_LEAD,
  GET_TRANSLATION_SETTINGS,
  GET_WEB_CHAT_WIDGET_CONNECTION,
  GET_SOCIAL_REVIEW_SETTINGS,
  GET_SUPPORTED_LANGUAGES_BY_LOCATION,
} from "../../../graphql/query";
import { useInterval } from "../../../hooks";
import useLang from "../../../hooks/useLang";
import useCrm from "../../../hooks/useCrm";
import useMessageForwardOptions from "../../../hooks/useMessageForwardOptions";
import usePrevious from "../../../hooks/usePrevious";
import RightBlackIcon from "../../../icons/js/RightBlackIcon";
import { colorConfig } from "../../../library/colorConfig";
import {
  AccessPermissionAction,
  HIDDEN_MESSAGE_CONTENT_TYPES,
  MESSAGE_CONTAINER_CLASSNAME,
  MESSAGE_CONTENT_TYPES,
  URL_PARAM_MESSAGE_ID,
  QUERY_VAR_TARGET_MESSAGE_ID,
} from "../../../library/constants";
import {
  checkAccessPermission,
  closeDialog,
  isAllLocationSelected,
  openDialog,
  showConfirmationModal,
} from "../../../library/helpers";
import { formatBytes, groupMessagesByDate } from "../../../library/utils";
import {
  getCacheApi,
  resetApiCacheStore,
  setAfterMessageText,
  setAllCampaigns,
  setCompanyConsentTemplate,
  setConsentTemplateSlice,
  setCrmLeadStatus,
  setIsuserTeamLeader,
  setLeadSources,
  setUserList,
} from "../../../redux/slices/apiCacheSlice";
import { getMobileView } from "../../../redux/slices/isMobile";
import {
  addMessage,
  addQuickFilter,
  getUpdatedCountInfo,
  setLeadsRedux,
  setScheduledMessages,
  setSearchRedux,
  setSelectedLeadIdRedux,
  setSelectedLeadRedux,
  mergeLeadDetail,
  updateLeadInList,
  resetTranlatedContent,
  setUserFilters,
  setCampaignFilters,
  changeMessageOpportunity,
  resetSelectedLeadMessages,
  QUICK_FILTERS,
} from "../../../redux/slices/leadSlice";
import { getLocationId, setLocationIdSlice } from "../../../redux/slices/locationSlice";
import {
  setTextAiResponseHistoryId,
  setEmailAiResponseHistoryId,
  getTextAiResponseHistoryId,
  getEmailAiResponseHistoryId,
} from "../../../redux/slices/aiSlice";
import { AttachmentSource } from "../../../library/messageSourceEnums";
import { heicToJpg, toTitleCase } from "../../../utils";
import AntdIconV4 from "../../../utils/antdIcon";
import { s3uploader } from "../../../utils/awsS3MediaUploader";
import { generateImageThumbnail } from "../../../utils/mediaUtilities";
import { getLeadToPhone } from "../../../utils/phoneHelpers";
import { generateVideoThumbnails } from "../../../utils/videoThumbnailGenerator";
import { buildVideoDurationField } from "../../../utils/videoDuration";
import CustomDivider from "../../commonComponents/divider";
import CustomLabel from "../../commonComponents/label";
import ResizableContainer from "../../commonComponents/ResizableContainer";
import { CUSTOM as CUSTOM_DATE_FILTER } from "../../commonComponents/DateRangeFilter";
import MergeLeadOpportunityModal from "../mergeLeadOpportunityModal";
import TemplateDrawer from "../schedual/templateDrawer";
import { BottomActions } from "./BottomActions";
import { AllOpportunityReplyAlert } from "./AllOpportunityReplyAlert";
import { InputAreaWrapper as InputArea } from "./InputArea";
import MessagesGroup from "./MessagesGroup";
import EmptyConversationState, { EMPTY_CONVERSATION_VARIANT } from "./EmptyConversationState";
import ChatSkeleton from "./ChatSkeleton";
import PaginationLoader from "./PaginationLoader";
import TopToolbarJsx from "./TopToolbarJsx";
import AppointmentModal from "./appointments/appointmentModal";
import Attachments from "./attachments";
import ConversationSummary from "./conversationSummary";
import "./editor.css";
import {
  INPUT_TAB_HEIGHT,
  LeadStatus,
  ShowConsent,
  isConsentStatusEnable,
  leadOwners,
  vehicles,
  EMAIL_ATTACHMENT_LIMITS,
  buildEmailAttachmentsPayload,
  SCROLL_TOP_FETCH_THRESHOLD,
  resolveReviewInfoByOppType,
} from "./engagementHelpers";
import LeadListContainer, { LEAD_TABS } from "./leadListContainer";
import LeadProfile from "./leadProfile";
import ViewScheduledMessagesPopup from "./viewScheduledMessagesPopup";
import { resetEmail } from "../../../redux/slices/userSlice";
import { useChatScroll } from "../../../hooks/useChatScroll";
import { getActiveSupportedLanguages } from "../../../utils/languages";
import {
  prepareOpportunityList,
  resolveLeadOpportunityId,
  ALL_OPPORTUNITY_TYPES_ID,
} from "../../../helpers/opportunityHelper";
import {
  resolveSignerByRole,
  buildReplyAsUsers,
  getMostRecentPoster,
  REPLY_RULE,
  REPLY_RULE_TYPE,
} from "./replyAsUsers";
import useReplyAsPreferences from "../../../hooks/useReplyAsPreferences";

// Lead engagement statuses surfaced as quick-filter options in the Activity
// Center. Ids come from the single QUICK_FILTERS constant so dashboard
// drill-ins, this list, and the BE all share the same string keys (1:1).
// Display order per product spec — drives the Quick Filters tab list and
// the lead-list quick-filter dropdown. `RESPONDED` is kept at the end so
// it stays available (it was in the older enum) without disturbing the
// requested top-8 ordering.
export const leadStatus = [
  { id: QUICK_FILTERS.MY_CONVERSATIONS, name: "My Conversations" },
  { id: QUICK_FILTERS.WAITING_FOR_REPLY, name: "Waiting For Lead Reply" },
  { id: QUICK_FILTERS.NEEDS_YOUR_REPLY, name: "Needs Your Reply" },
  { id: QUICK_FILTERS.UNCONTACTED, name: "Uncontacted" },
  { id: QUICK_FILTERS.ENGAGED, name: "Engaged" },
  { id: QUICK_FILTERS.NOT_ENGAGED, name: "Not Engaged" },
  { id: QUICK_FILTERS.NOT_RESPONDED, name: "No Response From Initial Contact" },
  { id: QUICK_FILTERS.NO_RESPONSE_NEEDED, name: "No Response Needed" },
  { id: QUICK_FILTERS.RESPONDED, name: "Responded" },
];

export const ConversationPopover = styled(Popover)`
  display: flex;
`;
export const InputTextWrap = styled.input`
  background: rgb(245, 245, 245) !important;
  border: none !important;
  color: #000000;
  width: 95%;

  ::placeholder {
    color: ${props => props?.placeholderStyle?.color};
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: ${props => props?.placeholderStyle?.color};
  }

  ::-ms-input-placeholder {
    color: ${props => props?.placeholderStyle?.color};
  }

  &:hover {
    outline: none !important;
    border: none !important;
  }
  &:focus {
    outline: none !important;
    border: none !important;
    border-right-width: 0 !important;
    background: rgb(245, 245, 245) !important;
  }
  &:selected {
    background: rgb(245, 245, 245) !important;
  }
`;

export const InputTextAreaWrap = styled.textarea`
  background: ${props => {
    if (props.styling.background === "#EF4444") {
      return "white";
    }
    return "white !important";
  }};
  cursor: ${props => {
    if (props.styling.background === "#EF4444") {
      return "not-allowed ";
    }
  }};
  border-radius: 4px;
  border: ${`1px solid ${colorConfig.greyLight}`};
  color: #000000;
  min-height: 64px;
  resize: vertical;
  width: 100%;
`;

export const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1120px) {
    flex-direction: column;
  }
`;
export const IconMobile = styled(Icon)`
  font-size: 24px;
  margin: 0 5px;
`;

export const pageSize = 20;
let page = 1;
let lastLead = "";

export const handleFiles = async (
  attachments,
  user,
  selectedLead,
  fetchData,
  setMediaUploadLoader
) => {
  try {
    const urlObj = [];
    const handleFilesURL = async (file, index) => {
      if (file) {
        const isVideo = file.file.type.includes("video");
        const isImage = file.file.type.includes("image");
        const thumbnailTask =
          isVideo || isImage
            ? fetchData(file.file, file.file.type).catch(() => "")
            : Promise.resolve("");
        // Shared across every send path (activity center, browser-extension-v4)
        // so all clients put the identical field on the wire. Resolves to {}
        // for non-videos and for videos whose duration can't be read.
        const durationTask = buildVideoDurationField(file.file).catch(() => ({}));
        const [thumbnailResult, durationField] = await Promise.all([thumbnailTask, durationTask]);
        const thumbnailUrl = thumbnailResult || "";
        let media = { url: file.preview };
        if (file.generateLink) {
          try {
            media = await s3uploader(
              file.file,
              process.env.GATSBY_S3_BUCKET,
              state => {
                setMediaUploadLoader(state);
              },
              false,
              sessionStorage.getItem("currentLocationId")?.includes(",")
                ? "all"
                : sessionStorage.getItem("currentLocationId"),
              user,
              selectedLead,
              index + 1
            );
          } catch (uploadError) {
            console.error("S3 upload failed:", uploadError);
            // Use preview URL as fallback
            media = { url: file.preview };
          }
        }
        // console.log("UPloaded image===========", file, media);
        urlObj.push({
          // compressedMediaUrl: media.url,
          size: file.file.size || 0,
          mediaType: file.file.type,
          mediaUrl: heicToJpg(media.url),
          thumbnail: heicToJpg(thumbnailUrl),
          // compressedThumbnail: thumbnailUrl,
          // filename is local-only (used for the link-fallback HTML); it is
          // stripped before the GraphQL attachments payload is sent.
          filename: file.file.name,
          // { videoDurationSeconds } for videos, {} otherwise — see videoDuration util.
          ...durationField,
        });
      }
    };

    for (let k = 0; k < attachments.length; k++) {
      // eslint-disable-next-line no-await-in-loop
      await handleFilesURL(attachments[k], k);
    }
    return urlObj;
  } catch (err) {
    console.log(err);
  }
};
// Allowed mime-type prefixes for pasted / dropped media. Pasted plain-text
// content has kind === "string" and won't reach this list, but a defensive
// filter keeps us from accidentally attaching odd binary blobs the OS may
// expose via the clipboard / drag transfer.
const ALLOWED_ATTACHMENT_MIME_PREFIXES = ["image/", "video/", "application/", "text/", "audio/"];

const isAttachableFile = file => {
  if (!file) return false;
  const type = file.type || "";
  if (!type) {
    // Some browsers expose dragged documents without a mime type (.docx etc.).
    // Accept those when a filename is present so users aren't silently blocked.
    return !!file.name;
  }
  return ALLOWED_ATTACHMENT_MIME_PREFIXES.some(prefix => type.startsWith(prefix));
};

// Shared appender used by both the file-picker flow (handleMediaEvent) and the
// new paste / drag-and-drop flow in the SMS textarea + email editor. Uses the
// functional setState updater so it's safe to call from event handlers that
// don't have an up-to-date `attachments` closure.
export const addFilesToAttachments = (files, setAttachments, setMediaProcessingLoader) => {
  const filesArr = Array.from(files || []).filter(isAttachableFile);
  if (filesArr.length === 0) return;

  if (setMediaProcessingLoader) {
    setMediaProcessingLoader(true);
  }

  try {
    const newAttachments = filesArr
      .map(fileItem => {
        try {
          return {
            file: fileItem,
            preview: URL.createObjectURL(fileItem),
            generateLink: true,
          };
        } catch (error) {
          console.error(`Error creating preview for file ${fileItem.name}:`, error);
          return null;
        }
      })
      .filter(Boolean);

    if (newAttachments.length > 0) {
      setAttachments(prev => [...(prev || []), ...newAttachments]);
    }
  } finally {
    if (setMediaProcessingLoader) {
      setMediaProcessingLoader(false);
    }
  }
};

export const handleMediaEvent = async (
  e,
  attachments,
  setAttachments,
  setMediaProcessingLoader
) => {
  const { files } = e.target;
  if (files.length === 0) return;

  // Show loading state when processing files
  if (setMediaProcessingLoader) {
    setMediaProcessingLoader(true);
  }

  try {
    const filesArr = Array.from(files);

    // Use URL.createObjectURL for fast preview generation instead of readAsDataURL
    // This is much faster as it doesn't read the entire file into memory
    const newAttachments = filesArr.map(fileItem => {
      try {
        const preview = URL.createObjectURL(fileItem);
        return {
          file: fileItem,
          preview,
          generateLink: true,
        };
      } catch (error) {
        console.error(`Error creating preview for file ${fileItem.name}:`, error);
        return null;
      }
    });

    const validAttachments = newAttachments.filter(attachment => attachment !== null);

    setAttachments([...attachments, ...validAttachments]);
  } finally {
    // Hide loading state
    if (setMediaProcessingLoader) {
      setMediaProcessingLoader(false);
    }
  }
};

const parseUserList = async (users, userIdMap, setUserIdMap) => {
  let obj = userIdMap;
  if (users.length > 0) {
    users.forEach(el => {
      const id = el?.id;
      obj = {
        ...obj,
        [id]: el?.fullName || "Otto",
      };
    });
    setUserIdMap({ ...obj });
  }
};

const EngagementActivity = props => {
  const {
    queryString,
    lead,
    campaignFilters,
    leadPresetFilter = {},
    isFromCampaignToActivity = false,
    onFullScreen,
    onSetfull,
    isFirstLeadSet,
    isLeadCenterApply = false,
    onLeadCenterApplyConsumed = () => {},
    onUnpinLead = () => {},
  } = props;
  const [lang] = useLang();
  const { getOpprDetails } = useCrm();
  const dispatch = useDispatch();
  const {
    user,
    setMaximizeScreen,
    notificationData,
    socketMsgSelectedLead,
    modal,
    setrefetchAppointments,
    refetchAppointments,
  } = useContext(UserContext);

  const { users, isUserTeamLeader } = useSelector(state => getCacheApi(state, "userList"));
  const textAiResponseHistoryId = useSelector(getTextAiResponseHistoryId);
  const emailAiResponseHistoryId = useSelector(getEmailAiResponseHistoryId);
  // EAI-1762: flushes any thumbs-up/down the user gave on the AI draft before
  // sending — the feedback API needs the message id the send returns.

  // Get message forward options to determine if UserHoverCard should be shown
  const { hasAnyForwardOption } = useMessageForwardOptions();

  const [isReview, setisReview] = useState(false);
  const [summaryVisible, setSummaryVisible] = useState({ visible: false, count: 0 });
  const [scheduledMessageDrawer, setscheduledMessageDrawer] = useState({
    open: false,
    messages: null,
  });
  const text = useRef(null);
  const emailTextRef = useRef("");
  const [emailForm] = Form.useForm();
  // Last lead we told the server was read. `selectedLead` is rebuilt on every
  // list update, so the effect below re-runs for the same lead; without this
  // it would fire the mutation repeatedly.
  const reportedReadLeadRef = useRef(null);
  const messagesEndRef = useRef(null);
  const msgContainerRef = useRef(null);
  const mediaRef = useRef(null);
  const videoRef = useRef(null);
  const documentRef = useRef(null);
  // Synchronous re-entry guard for MMS send. State-based mmsLoader is racy
  // across the Enter-key path and the Send-button click path because each
  // captures its own closure of mmsLoader at render time. The ref is checked
  // and set synchronously in handleMMS so a second call is rejected even if
  // React hasn't yet committed setmmsLoader(true) from the first call.
  const sendingMMSRef = useRef(false);
  // Synchronous re-entry guard for older-message pagination. Apollo flips
  // `loading` back to false BEFORE onCompleted commits the new page to state,
  // so two scroll events near the top can otherwise fire duplicate page
  // requests in that window. This ref is set the moment we trigger a fetch and
  // cleared once onCompleted/onError settles (or the lead switches).
  const isFetchingOlderRef = useRef(false);

  const routerLocation = useLocation();
  const urlParams = new URLSearchParams(window.location.search);
  const [paramLeadId, setParamLeadId] = useState(() =>
    new URLSearchParams(window.location.search).get("leadId")
  );
  const [hasLeadIdInUrl] = useState(() => window.location.search.includes("leadId"));
  const presetLeadFilter = urlParams.get("presetFilter");
  // --- Target Message Navigation (scroll-to-message feature) ---
  // When a user clicks a notification with a message_id, we need to fetch all messages
  // up to that ID and auto-scroll to it. sessionStorage("targetMessageId") is the
  // communication channel between layoutHelpers.js (sets it) and here (reads it).
  //
  // Why sessionStorage instead of URL or navigate state:
  // - URL params get cleaned up by getLeads onCompleted (replaceState)
  // - Navigate state doesn't survive component remounts on location switch
  // - sessionStorage persists across remounts and is cleaned up explicitly
  //
  // Lifecycle:
  // 1. Set: layoutHelpers.js stores messageId in sessionStorage on notification click
  // 2. Read: useState initializer (on mount) or useEffect (on location/route change)
  // 3. Used: fetchMessages() passes it to messagesV2 API query
  // 4. Cleanup: sessionStorage cleared in onCompleted; state cleared on "View all messages" click
  //    or when user switches location from dropdown (mainLayout.js)
  const [targetMessageId, setTargetMessageId] = useState(() => {
    const fromUrl = new URLSearchParams(window.location.search).get(URL_PARAM_MESSAGE_ID);
    const fromSession = sessionStorage.getItem("targetMessageId");
    // Sync URL param to sessionStorage so it survives URL cleanup (replaceState in getLeads onCompleted)
    if (fromUrl && !fromSession) {
      sessionStorage.setItem("targetMessageId", fromUrl);
    }
    return fromUrl || fromSession || null;
  });

  /**
   * Clears targetMessageId from both React state and sessionStorage.
   * - Resets state: hides "View all messages" button, removes messageId from future API calls
   * - Clears sessionStorage: prevents stale messageId from being picked up on next mount/re-render
   * Used by: handleBackButtonClick ("View all messages"), location dropdown switch
   */
  const clearTargetMessageId = () => {
    setTargetMessageId(null);
    sessionStorage.removeItem("targetMessageId");
  };

  const locaitonLocalId = localStorage.getItem("changedLocationLeadId");
  const isUserBDC = user?.companyRole?.name?.toLowerCase().includes("bdc");

  let concentTime;
  let timeReference;
  const prevSortOrderRef = useRef();
  const prevStatusRef = useRef();
  const shouldScrollOnMessagesLoadRef = useRef(false);
  const hasSkippedInitialLocEffectRef = useRef(false);
  const locationIdslice = useSelector(state => getLocationId(state));
  const leadSourcesReduxData = useSelector(state => getCacheApi(state, "leadSources"));
  const crmLeadStatusReduxData = useSelector(state => getCacheApi(state, "crmLeadStatus"));
  const userListReduxData = useSelector(state => getCacheApi(state, "userList"));
  const actionDispatchTime = useSelector(state => getCacheApi(state, "expiryTime"));
  const leadCountUpdatedData = useSelector(state => getUpdatedCountInfo(state));
  const companyConsentReduxData = useSelector(state =>
    getCacheApi(state, "companyConsentTemplateEvent")
  );
  const { selectedLead, leads: leadList, messageOpportunity } = useSelector(state => state.lead);

  // Live mirror of the lead list. Async callbacks (the updateUnreadCount
  // response) land after the request that fired them, so a captured `leadList`
  // closure can be a list ago by then — read through the ref instead.
  // `setLeadList` writes it eagerly too, so a response arriving before the
  // dispatch has re-rendered still sees the row we just wrote.
  const leadListRef = useRef(leadList);
  useEffect(() => {
    leadListRef.current = leadList;
  }, [leadList]);

  // Active getLeads opp-type filter — read here separately from the
  // larger ``state.lead.filters`` destructure below because the
  // default-tab effect needs it (and that destructure happens after
  // this effect in source order).
  const filterOppTypeIdsForDefault = useSelector(
    state => state.lead?.filters?.opportunityTypeFilters
  );

  // Collapse the active getLeads opp-type filter to its set of ROOT
  // ids. Filter values may be leaf ids (e.g., "Vehicle Purchase" →
  // walks up to root "Sales"); normalize via the lead's
  // ``opportunityType`` chain when available. Computed inline so the
  // useMemo cost stays bounded by the filter length (typically <5).
  const listFilterRootOppTypeIds = useMemo(() => {
    const raw = filterOppTypeIdsForDefault;
    if (!Array.isArray(raw) || raw.length === 0) return [];
    // Build an opp_type id → opp_type object map from the visible
    // leadList so we can walk parent chains without an extra query.
    // When a filter id isn't in the map we keep it as-is (defensive —
    // the BE will have already validated it).
    const lookup = new Map();
    (leadList || []).forEach(lead => {
      (lead?.leadOpportunities || []).forEach(opp => {
        if (opp?.opportunityType?.id) {
          lookup.set(Number(opp.opportunityType.id), opp.opportunityType);
        }
      });
    });
    const roots = new Set();
    raw.forEach(v => {
      const num = Number(v);
      if (Number.isNaN(num)) return;
      const node = lookup.get(num);
      const rootId = node ? getRootOppTypeId(node) : num;
      if (rootId) roots.add(Number(rootId));
    });
    return [...roots];
  }, [filterOppTypeIdsForDefault, leadList]);

  // Recompute the default Sales / Service / Parts tab when the lead
  // changes. Default = root opp_type of the most recent permitted opp
  // on the lead (sorted by ``updatedDate`` desc), matching the same
  // helper the lead-list card uses. Returns null when no permitted
  // opps exist (legacy / unscoped users → no tab strip, falls through
  // to unfiltered behavior).
  //
  // When the lead list itself is filtered to one or more opp-types,
  // prefer the most-recent opp WITHIN that filter — a multi-tab lead
  // shouldn't open on its Sales tab just because the latest opp is
  // Sales when the user filtered the list to Service.
  //
  // Previously called ``getDefaultTabId``, which walked opps in BE
  // return order (not necessarily recency) and could pick a different
  // root than the card. That mismatch caused the card to flip tabs
  // post-click. Aligning both call sites on the same helper keeps
  // pre-click and post-click state consistent.
  React.useEffect(() => {
    // Deep-link flow: when navigating to a specific message, leave the tab
    // UNSET (null) so messagesV2 fetches unscoped and the BE returns the
    // target message even if it lives on a different opp tab (common for
    // merged leads). onCompleted then resolves the message's opp and sets
    // the correct tab. Defaulting the tab here would scope the fetch and the
    // BE would filter the target out entirely.
    if (targetMessageId) return;
    const nextTab = getMostRecentPermittedRootOppTypeIdInFilter(
      selectedLead,
      user,
      listFilterRootOppTypeIds
    );
    setSelectedOppTypeId(nextTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedLead?.id,
    selectedLead?.leadOpportunities?.length,
    user?.id,
    // Re-run when the list filter changes so existing selection
    // re-aligns to the new constraint without a lead switch.
    listFilterRootOppTypeIds.join(","),
  ]);
  const { leadScheduledMessages: scheduledMessages } = useSelector(state => state?.lead);
  const afterMessageFromRedux = useSelector(state => getCacheApi(state, "afterMessageText"));
  const consentTemplateFromRedux = useSelector(state => getCacheApi(state, "consentTemplate"));
  const allCampaignsReduxData = useSelector(state => getCacheApi(state, "allCampaigns"));

  const [entityId, setEntityId] = useState(
    urlParams.get("entityId")?.split("?")[0] !== "remove"
      ? urlParams.get("entityId")?.split("?")[0]
      : ""
  );
  const [textMode, settextMode] = useState(0);
  const [eventId, setEventId] = useState(
    urlParams.get("eventId")?.split("?")[0] !== "remove"
      ? urlParams.get("eventId")?.split("?")[0]
      : ""
  );

  const [leadIdClick, setLeadIdClick] = useState("");
  const [showSidebar, setShowSideBar] = useState(true);
  const [showDetails, setShowDetails] = useState(true);
  const [richTextValue, setrichTextValue] = useState("");
  const [fullScreen, setFullScreen] = useState(false);

  // const [setSelectedLead] = useState(lead || null);

  // const [selectedLeadId, setSelectedLeadId] = useState(lead?.id || "");
  const [showReviewRequestButton, setShowReviewRequestButton] = useState(true);
  const location = window.location.pathname;
  const [searchKey, setSearchKey] = useState(queryString !== "remove" ? queryString : ""); // location.split("/")[3]
  const [activeOpp, setActiveOpp] = useState("#DEFAULTOPPID");
  const [activeOppName, setActiveOppName] = useState("");
  // Opp-type-scoped activity center — root opp_type id of the active
  // Sales / Service / Parts tab. Lifted here so LeadProfile (right
  // panel) and the message thread / send box share the same value.
  // `null` ⇒ no tab selected yet (lead with no opps or user with no
  // permitted intersection — falls back to legacy "show everything").
  // See ``library/oppTypeScoping.js`` for derivation helpers.
  const [selectedOppTypeId, setSelectedOppTypeId] = useState(null);
  // Per-root unread counter for messages that arrived via SocketIO but
  // were dropped because they belong to a tab the user isn't currently
  // viewing. Surfaces a red dot on the off-tab in ``OppTypeRootTabs``
  // so the user knows there's activity in the other tab without us
  // having to fold the off-tab content into the active timeline.
  //
  // Shape: ``{ [rootOppTypeId: number]: count: number }``. Cleared on
  // lead switch and on selecting a tab that previously had unreads.
  const [unreadByRoot, setUnreadByRoot] = useState({});

  // Clear all per-root unread dots when the user opens a different
  // lead — the counter is contextual to "which other tabs of THIS lead
  // got activity while I was looking elsewhere," and that resets when
  // the lead context changes. Declared AFTER the state above so React
  // can read the setter at effect-setup time (const TDZ-safe).
  useEffect(() => {
    setUnreadByRoot({});
  }, [selectedLead?.id]);

  // Clear the dot for whatever tab the user just switched to. Mirrors
  // the standard "viewing → marked-read" semantic so the user doesn't
  // have to dismiss the indicator manually.
  useEffect(() => {
    if (selectedOppTypeId == null) return;
    setUnreadByRoot(prev => {
      if (!prev[selectedOppTypeId]) return prev;
      const next = { ...prev };
      delete next[selectedOppTypeId];
      return next;
    });
  }, [selectedOppTypeId]);

  const [originalText, setOriginalText] = useState("");
  const [callingScreen, setCallingScreen] = useState({
    visible: false,
    lead: {},
    recording: false,
  });
  const [opportunityList, setOpportunityList] = useState([
    { filterId: null, id: "#DEFAULTOPPID", name: "All" },
  ]);
  // Unfiltered, enriched companion to ``opportunityList``. Same shape
  // (id, name, prefix, eventId, opportunityStatus, ...) but built from
  // the lead's FULL opp set with NO tab filter applied. The Top toolbar
  // dropdown uses this to render every opp under every root with the
  // full "Service OPP: ... (EAI 1234 / Active - Open)" label — without
  // it, Sales-tab labels for Service opps fall back to the short
  // ``opp.name`` and the cross-tab selection check loses track of the
  // opp during the tab switch.
  const [fullOpportunityList, setFullOpportunityList] = useState([]);
  const [filterLastId, setFilterLastId] = useState("");
  const [isEmojiOpen, setIsEmojiOpen] = useState(false);
  const { leadSort } = useSelector(state => state.lead);
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);
  const [showLeadSection, setShowLeadSection] = useState(window.innerWidth > 1024);
  const [showProfileSection, setShowProfileSection] = useState(window.innerWidth > 1024);
  const [activeLeadId, setActiveLeadId] = useState(localStorage.getItem("changedLocationLeadId"));
  const [changeState, setChangeState] = useState(true);
  const [leadCount, setLeadCount] = useState(0);
  // `getLeads.unreadLeadsCount` per tab. The aggregate answers only for the
  // scope its request ran with, so one response can't fill both badges; each
  // tab keeps the value from the last response that was actually its own.
  const [unreadLeadsCount, setUnreadLeadsCount] = useState({});

  // A pin/unpin moves a lead in and out of the PINNED scope, so that badge's
  // remembered value is now stale. The All scope is untouched — pinning reads
  // nothing, so the set of leads carrying unread is the same — and clearing it
  // too would blank a badge that is still correct, then leave it blank, since
  // a pin from the All tab no longer refetches anything to refill it.
  const handlePinsChanged = () =>
    setUnreadLeadsCount(prev => {
      if (prev[LEAD_TABS.PINNED] == null) return prev;
      const next = { ...prev };
      delete next[LEAD_TABS.PINNED];
      return next;
    });

  // `unreadLeadsCount` is a server aggregate, so it would otherwise only move
  // on the next getLeads response — a lead read now would keep its badge until
  // a tab switch or refetch. Nudge it on the two transitions that change which
  // LEADS carry unread: a lead going 0 -> unread, and a lead being read.
  //
  // Optimistic, but bounded: every getLeads response overwrites the scope it
  // ran with, so a drifted value survives at most until the next request. Only
  // scopes we actually hold a number for are touched — an untouched scope has
  // no badge yet and must not gain one from a guess.
  //
  // A lead only counts in the Pinned scope when it is pinned, so read its flag
  // off the list row rather than `selectedLead`, which is rebuilt by the lead
  // detail query and does not carry `isPinned`.
  const adjustUnreadLeadsCount = (leadId, delta) => {
    const row = (leadListRef.current || []).find(item => +item?.id === +leadId);
    const scopes = [LEAD_TABS.ALL, ...(row?.isPinned ? [LEAD_TABS.PINNED] : [])];
    setUnreadLeadsCount(prev => {
      const next = { ...prev };
      scopes.forEach(scope => {
        if (typeof next[scope] === "number") {
          next[scope] = Math.max(0, next[scope] + delta);
        }
      });
      return next;
    });
  };
  const [openCRMModal, setPushToCrmModalVisible] = useState(false);
  const [openAppointmentDrawer, setOpenAppointmentDrawer] = useState(false);
  const [openAddModal, setAddPhoneModalVisible] = useState(false);
  const [openSendReviewModal, setSendReviewVisible] = useState(false);
  // const crmIntegration = useCrmIntegration();
  const crmIntegration = user?.company?.crmIntegrationType;
  const [crmIntegrationData, setcrmIntegrationData] = useState("");
  const [openSetReviewTemplateUploadModal, setReviewTemplateUploadVisible] = useState(false);
  const [openTemplateModal, setTemplateModal] = useState({ visible: false });
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [refetchAppointment, setRefetchAppointment] = useState(false);
  const [inlineField, setInlineEditField] = useState("");
  const [openEditUserPhone, setOpenEditUserPhone] = useState(false);
  const [targetLangForCustomer, setTargetLangForCustomer] = useState("");
  const [targetLangForEmployee, setTargetLangForEmployee] = useState("");
  const [languages, setLanguages] = useState();
  const [isAutoTranslate, setIsAutoTranslate] = useState(false);
  const [isIncludeOriginalMessage, setIsIncludeOriginalMessage] = useState(false);
  const [isTranslatePreviewShow, setIsTranslatePreviewShow] = useState(false);
  const activeLeadFilterReduxData = useSelector(state => getCacheApi(state, "activeLeadFilter"));
  const [messageFilters, setMessageFilters] = useState({
    campaignIds: [],
    leadId: +selectedLead?.id,
    lastId: lastLead,
    page: 1,
    pageSize,
  });
  const prevStateData = usePrevious({ messageFilters });
  const [messageText, setmessageText] = useState("");
  const [globalMessageData, setGlobalMessageData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const {
    quickFilters: selectedQuickFilters,
    addMyConversation,
    userFilters,
    campaignFilters: reduxCampaignFilters = [],
    opportunityTypeFilters = [],
    opportunityStatusFilters = [],
    opportunitySourceFilters = [],
    teamFilters: leadTeamFilters = [],
    dateFilterType: leadDateFilterType = null,
    dateRange: leadDateRange = [],
    dateType: leadDateType = null,
  } = useSelector(state => state.lead.filters);
  const [isMsgScroll, setIsMsgScroll] = useState(false);
  const [disableConcentClick, setDisableConcentClick] = useState(true);
  const [isMsgApi, setIsMsgApi] = useState(false);
  const [hideBottom, setHideBottom] = useState(true);
  const [isTranslateClick, setIsTranslateClick] = useState(false);
  const [stopLoaderForReceivedMessage, setStopLoaderForReceivedMessage] = useState(true);
  const { search } = useSelector(state => state.lead);
  // Search scope (Activity Center search box → user icon dropdown). true =
  // "All Leads" (skipFilter:true, ignore active filters). false = "Within
  // Filtered Lead" (skipFilter:false, search within the filtered result set).
  const searchAllLeads = useSelector(state => state.lead.searchAllLeads);
  const [variables, setVariables] = useState({
    source: [],
    sourceOriginal: [],
    combinedSource: [],
    voi: [],
    page: 1,
    pageSize: 25,
    orderBy: "latest_chat",
    orderDirection: "desc",
    status: uniq([...selectedQuickFilters, ...selectedStatus]),
    campaignIds: reduxCampaignFilters?.length ? reduxCampaignFilters : campaignFilters || [],
    dsEntityId: entityId,
    dsEventId: eventId,
    leadId: isEmpty(search) && hasLeadIdInUrl && paramLeadId,
  });
  const [isSingleLeadView, setIsSingleLeadView] = useState(!!variables?.leadId);
  const [apiCheck, setApiCheck] = useState(false);
  const [sourcesData, setSourcesData] = useState({});
  const [company, setCompany] = useState(null);
  const [reviewInfo, setReviewInfo] = useState(null);
  const [consent, setConsent] = useState([]);
  const [isClickonPotentialDuplicate, setIsClickonPotentialDuplicate] = useState(false);
  const [consentTemplate, setConsentTemplate] = useState("");
  const [afterMessageConsent, setAfterMessageConsent] = useState("");
  const [onlyFirstMessage, setonlyFirstMessage] = useState("");
  const [isActive, setisActive] = useState(null);
  const [selectedLeadID, setSelectedLeadID] = useState("");
  const [connection, setConnection] = useState({});
  const [callConsentMessage, setCallConsentMessage] = useState(false);
  const [openAppointmentPopup, setAppointmentPopupVisible] = useState(false);
  const { socket, isFullScreen } = useContext(UserContext);
  const [isPopupNeedToOpen, setIsPopupNeedToOpen] = useState(false);
  const [statusList, setstatusList] = useState([]);
  const [isAppointmentChangeFromLead, setIsAppointmentChangeFromLead] = useState(false);
  const [appintmentLead, setAppointmentLead] = useState({});
  const [visibleMergeLeadModal, setVisibleMergeLeadModal] = useState(false);
  const [duplicateRecord, setDuplicateRecord] = useState([]);
  const [implicit, setimplicit] = useState(
    consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF")?.isActive
  );
  const [explicit, setexplicit] = useState(
    consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON")?.isActive
  );
  const [cosentAtEnd, setcosentAtEnd] = useState(isActive);
  const [btnClicked, setbtnClicked] = useState(false);
  const [mediaUploadLoader, setMediaUploadLoader] = useState(false);
  const [hideToolbar, sethideToolbar] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [consentData, setconsentData] = useState(false);
  const [consentMessage, setConsentMessage] = useState("");
  const [recording, setRecording] = useState({ visible: false, lead: {} });
  const [userIdMap, setUserIdMap] = useState({});
  // "Reply As" feature (EAI-1530), gated by the ACTIVITY_CENTER_REPLY_AS_ENABLE
  // access permission. When enabled: the selector is shown, the saved reply-as
  // preference is applied by default, and the send is attributed to the resolved
  // signer (``userId`` = signer/display identity, ``replyAsUserId`` = actual
  // sender when on-behalf). When disabled: sends go as the logged-in user only —
  // no selector, no preference, no signer.
  const isReplyAsManager =
    checkAccessPermission(AccessPermissionAction.ACTIVITY_CENTER_REPLY_AS_ENABLE) || false;
  const {
    getDefaultRule: getReplyAsDefaultRule,
    saveDefaultRule: saveReplyAsDefaultRule,
    getOverride: getReplyAsOverride,
    setOverride: setReplyAsOverride,
    clearOverride: clearReplyAsOverride,
  } = useReplyAsPreferences();
  const replyAsOverrideUserId = getReplyAsOverride(selectedLead?.id);

  // Saved default rule for the active opportunity type (SELF / MOST_RECENT /
  // OPPORTUNITY_USER_TYPE + id) — EAI-1530 saveReplyAsPreference.
  const replyAsSavedRule = getReplyAsDefaultRule(selectedOppTypeId);
  const replyAsSavedRuleType = replyAsSavedRule?.rule_type || REPLY_RULE_TYPE.SELF;
  const replyAsSavedUserTypeId = replyAsSavedRule?.opportunity_user_type_id ?? null;

  // "Select default" options — Me + Most Recent, then the opportunity user types
  // for the active Sales/Service/Parts tab (role option value = user-type id).
  const replyAsLocationId = +(
    (sessionStorage.getItem("currentLocationId") || "").split(",")[0] || 0
  );
  const { data: oppUserTypesData, loading: replyAsRoleLoading } = useQuery(
    GET_OPPORTUNITY_USER_TYPE,
    {
      skip: !isReplyAsManager || !user?.company?.id || !replyAsLocationId,
      variables: {
        locationId: replyAsLocationId,
        companyId: user?.company?.id ? +user.company.id : undefined,
        opportunityTypeId: selectedOppTypeId ? +selectedOppTypeId : undefined,
      },
      fetchPolicy: "cache-and-network",
    }
  );
  const replyAsRoleOptions = useMemo(
    () => [
      { value: REPLY_RULE.ME, label: `${user?.fullName || "Me"} ${lang.replyAsMeTag || "(Me)"}` },
      { value: REPLY_RULE.RECENT, label: lang.replyAsMostRecent || "Most Recent" },
      ...(oppUserTypesData?.getOpportunityUserTypes || [])
        .filter(t => t?.name && t?.isActive !== false)
        // Value stringified so it matches the saved id regardless of whether the
        // API returns id as an Int or an ID (string) — otherwise antd can't find
        // the option and renders the raw id instead of the role name.
        .map(t => ({ value: String(t.id), label: t.name })),
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [oppUserTypesData, user?.fullName, lang]
  );

  // Select value reflecting the saved rule: SELF→ME, MOST_RECENT→RECENT,
  // OPPORTUNITY_USER_TYPE→the user-type id (stringified to match the options).
  const replyAsSelectedValue =
    replyAsSavedRuleType === REPLY_RULE_TYPE.MOST_RECENT
      ? REPLY_RULE.RECENT
      : replyAsSavedRuleType === REPLY_RULE_TYPE.OPPORTUNITY_USER_TYPE &&
        replyAsSavedUserTypeId != null
      ? String(replyAsSavedUserTypeId)
      : REPLY_RULE.ME;

  // Saved user-type NAME (from the option list) — used to match assigned users
  // when the id spaces differ between getOpportunityUserTypes and leadOpportunityUsers.
  const replyAsSavedUserTypeName =
    replyAsSavedRuleType === REPLY_RULE_TYPE.OPPORTUNITY_USER_TYPE && replyAsSavedUserTypeId != null
      ? replyAsRoleOptions.find(o => o.value === String(replyAsSavedUserTypeId))?.label || ""
      : "";

  // Current signer: per-lead override → saved rule → most recent → self.
  const { entry: resolvedReplyAsSigner } = useMemo(
    () =>
      resolveSignerByRole({
        ruleType: replyAsSavedRuleType,
        opportunityUserTypeId: replyAsSavedUserTypeId,
        opportunityUserTypeName: replyAsSavedUserTypeName,
        overrideUserId: replyAsOverrideUserId,
        loggedInUser: user,
        messages: selectedLead?.messages,
        leadOpportunities: selectedLead?.leadOpportunities,
        candidates: users,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      replyAsSavedRuleType,
      replyAsSavedUserTypeId,
      replyAsSavedUserTypeName,
      replyAsOverrideUserId,
      user?.id,
      selectedLead?.id,
      selectedLead?.messages,
      selectedLead?.leadOpportunities,
      users,
    ]
  );

  // Permission gate: when Reply-As is disabled, force the signer to null so the
  // send falls back to the logged-in user only (no preference applied).
  const replyAsSigner = isReplyAsManager ? resolvedReplyAsSigner : null;

  // "THIS LEAD ONLY" rows — reply-as candidates for this lead (Me → most recent
  // → assigned users), enriched with a display subtitle + Me/Most-Recent flags.
  const replyAsLeadRows = useMemo(
    () => {
      const currentLocationId = (sessionStorage.getItem("currentLocationId") || "").split(",")[0];
      const locationName =
        (user?.locations || []).find(l => String(l.locationId) === String(currentLocationId))
          ?.location?.title ||
        user?.locations?.[0]?.location?.title ||
        "";
      // userList cache resolves the most-recent message's attributed userId to a
      // real record (its nested user object may be the login sender).
      const recentPool = [user, ...(users || [])].filter(Boolean);
      const recent = getMostRecentPoster(selectedLead?.messages, recentPool);
      return buildReplyAsUsers({
        loggedInUser: user,
        messages: selectedLead?.messages,
        leadOpportunities: selectedLead?.leadOpportunities,
        candidates: users,
      }).map(entry => {
        const isMe = +entry.id === +user?.id;
        const parts = [entry.roleName, entry.assignmentType].filter(Boolean);
        if (isMe && locationName) parts.push(locationName);
        return {
          id: entry.id,
          fullName: entry.fullName,
          profilePic: entry.profilePic,
          subtitle: parts.join(" - "),
          isMe,
          // Badge the user who sent the last message — including when that's
          // the logged-in user (the row then shows both "(Me)" and this).
          isRecent: !!recent && +recent.id === +entry.id,
        };
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      user?.id,
      user?.locations,
      selectedLead?.id,
      selectedLead?.messages,
      selectedLead?.leadOpportunities,
      users,
    ]
  );

  // Frame 2748 saves directly (no confirmation): the default is persisted per
  // opportunity type; row click → per-lead override; Clear → restore the default.
  const onReplyAsSelectRole = value => {
    if (selectedOppTypeId == null) return;
    let ruleType = REPLY_RULE_TYPE.SELF;
    let opportunityUserTypeId = null;
    if (value === REPLY_RULE.RECENT) {
      ruleType = REPLY_RULE_TYPE.MOST_RECENT;
    } else if (value !== REPLY_RULE.ME) {
      ruleType = REPLY_RULE_TYPE.OPPORTUNITY_USER_TYPE;
      opportunityUserTypeId = value;
    }
    saveReplyAsDefaultRule({
      opportunityTypeId: selectedOppTypeId,
      ruleType,
      opportunityUserTypeId,
    });
  };
  const onReplyAsSelectUser = row => setReplyAsOverride(selectedLead?.id, row?.id);
  const onReplyAsClear = () => clearReplyAsOverride(selectedLead?.id);
  const [leadListDrawer, setLeadListDrawer] = useState(false);
  const [leadProfileDrawer, setLeadProfileDrawer] = useState(false);
  const isMobileView = useSelector(state => getMobileView(state));
  const [mmsLoader, setmmsLoader] = useState(false);
  const [visibleTranslationSettings, setVisibleTranslationSetting] = useState(false);
  const canEdit = checkAccessPermission(AccessPermissionAction.LEAD_ADD_EDIT);
  const canViewTranslation = checkAccessPermission(
    AccessPermissionAction.TRANSLATION_MANAGEMENT_VIEW
  );
  const restrictRemoveDefaultFilter = checkAccessPermission(
    AccessPermissionAction.ACTIVITY_CENTER_RESTRICT_REMOVE_DEFAULT_FILTER
  );

  const [records, setRecords] = useState([]);

  const [doNotMerge, setDoNotMerge] = useState({
    merged: false,
  });

  const handleCheckboxChange = key => {
    setDoNotMerge(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleRadioChange = (field, recordIndex) => {
    setRecords(prevRecords =>
      prevRecords.map((record, index) => ({
        ...record,
        [field]: {
          ...record[field],
          selected: index === recordIndex - 1,
        },
      }))
    );
  };

  // eslint-disable-next-line react/display-name
  const RadioField = ({ field, record, recordIndex, onRadioChange }) => {
    const [seeMore, setSeeMore] = useState(false);
    const value = record[field]?.value;
    const icon = <CheckOutlined className="text-green-500" />;

    const handleToggleSeeMore = e => {
      e.stopPropagation(); // Prevent the Radio event from triggering
      setSeeMore(prev => !prev); // Toggle See More state
    };

    const renderValues = () => {
      const values = value
        .split(",")
        .map(val => val.trim())
        .filter(val => val !== "");

      const displayedValues = seeMore ? values : values.slice(0, 3);

      return (
        <>
          {displayedValues.map((val, index) => (
            <div key={index} className="flex items-center gap-1">
              {val}
              {record[field]?.phoneNumbers?.length > index && (
                <span className="text-gray-500">
                  ({record[field]?.phoneNumbers[index]?.phoneType})
                </span>
              )}
              {record[field]?.Owners?.length > index && (
                <span className="text-gray-500">
                  ({record[field]?.Owners[index]?.userType?.name})
                </span>
              )}
              {index === 0 && !record[field]?.Owners && icon}
            </div>
          ))}
          {values.length > 3 && (
            <span className="text-blue-500 cursor-pointer" onClick={handleToggleSeeMore}>
              {seeMore ? "See Less" : "See More"}
            </span>
          )}
        </>
      );
    };

    return (
      <div className="flex items-start gap-2">
        <Radio
          onChange={() => onRadioChange(field, recordIndex)} // Trigger only on radio change
          checked={record[field]?.selected}
          className="mt-1"
          disabled={record[field]?.disabled}
        />
        <div>{value && value.includes(",") ? renderValues() : value || "N/A"}</div>
      </div>
    );
  };

  const fields = (records?.length > 0 ? Object.keys(records[0]) : []).filter(key => key !== "id");

  // Render dynamic checkboxes aligned with the dynamic records
  const renderCheckboxes = index => (
    <Checkbox
      checked={doNotMerge[`record${index + 1}`]}
      onChange={() => handleCheckboxChange(`record${index + 1}`)}
      className="relative bottom-[120%] left-[1%]"
      // className="relative"
    >
      <span className="text-[#334155] text-xs">Do Not Merge</span>
    </Checkbox>
  );

  const selectFieldsAtIndex = i => {
    setRecords(prevRecords => {
      // Create a new array with updated records
      return prevRecords.map((record, index) => {
        if (index === i) {
          // Set selected: true for the specified index
          return {
            ...record,
            Name: { ...record.Name, selected: true },
            "Phone number": { ...record["Phone number"], selected: true },
            Address: { ...record.Address, selected: true },
            Location: { ...record.Location, selected: true },
            Owners: { ...record.Owners, selected: true },
            Email: { ...record.Email, selected: true },
            "Lead status": { ...record["Lead status"], selected: true },
            Source: { ...record.Source, selected: true },
            Vehicle: { ...record.Vehicle, selected: true },
          };
        } else {
          // Set selected: false for all other indices
          return {
            ...record,
            Name: { ...record.Name, selected: false },
            "Phone number": { ...record["Phone number"], selected: false },
            Address: { ...record.Address, selected: false },
            Location: { ...record.Location, selected: false },
            Owners: { ...record.Owners, selected: false },
            Email: { ...record.Email, selected: false },
            "Lead status": { ...record["Lead status"], selected: false },
            Source: { ...record.Source, selected: false },
            Vehicle: { ...record.Vehicle, selected: false },
          };
        }
      });
    });
  };

  const columns = [
    {
      title: "Field",
      dataIndex: "field",
      key: "field",
      fixed: "left",
      className: "highlight-column",
      width: "200px",
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    {
      title: "Merged Record",
      dataIndex: "merged",
      key: "merged",
      className: "highlight-column",
      width: "200px",
      fixed: "left",
      render: (text, record) => {
        const mergedValue = record.merged
          ?.split(",")
          .map(val => val.trim())
          .filter(val => val !== "")
          .join(", ");
        if (!mergedValue) {
          return "N/A";
        }

        // Check if the value is a comma-separated string
        if (mergedValue.includes(",")) {
          const values = mergedValue.split(",").map(val => val.trim());
          const displayValues = values.slice(0, 3); // Show only the first three

          return (
            <span>
              {displayValues.join(", ")}
              {/* {moreCount > 0 && <span className="text-blue-500 cursor-pointer"> and more</span>} */}
            </span>
          );
        }

        // If not comma-separated, show the value as it is
        return mergedValue;
      },
      onCell: () => ({
        style: { backgroundColor: "#E2E8F0" }, // Background for cells
      }),
    },
    ...records.map((_, index) => ({
      title: (
        <div style={{ textAlign: "center" }}>
          <div>{renderCheckboxes(index)}</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span className="text-[14px]">Record {index + 1}</span>
            <span
              className={`text-[#3B82F6] ml-2 text-[14px] cursor-pointer ${
                doNotMerge[`record${index + 1}`] ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={() => !doNotMerge[`record${index + 1}`] && selectFieldsAtIndex(index)}
            >
              Select All
            </span>
          </div>
        </div>
      ),
      dataIndex: `record${index}`,
      key: `record${index}`,
      render: (text, record) => {
        const fieldName = record.field; // Field like name, address, city
        return (
          <RadioField
            key={index}
            field={fieldName}
            record={records[index]}
            recordIndex={index + 1}
            onRadioChange={handleRadioChange}
          />
        );
      },
      onCell: () => ({
        style: { backgroundColor: "#FFFFFF" }, // Background for cells
      }),
    })),
  ];

  const tableData = fields.map(field => {
    const row = { field };

    // Find the first record where the field has `selected: true`
    const selectedRecord = records.find(record => record[field]?.selected === true);

    // Use the selected record's value, or fallback to the first record if no selected record
    row.merged = selectedRecord ? selectedRecord[field]?.value : records[0][field]?.value || "N/A";

    // Fill data for other records (record1, record2, etc.)
    records.forEach((record, index) => {
      row[`record${index}`] = record[field]?.value || "N/A";
    });

    return row;
  });

  const handleEditLead = lead => {
    if (!isEmpty(lead)) {
      editLeadDetails({
        variables: { leadId: lead.id },
      });
    }
  };
  const setSearch = search => {
    dispatch(setSearchRedux(search));
  };
  const handleToasterSelectedLead = () => {
    handleLeadDetailProfile(socketMsgSelectedLead);
  };
  const setSelectedLead = lead => {
    if (!isEmpty(lead)) {
      dispatch(setSelectedLeadRedux({ ...selectedLead, ...lead }));
    } else {
      dispatch(setSelectedLeadRedux({}));
    }
  };
  const setSelectedLeadId = id => {
    dispatch(setSelectedLeadIdRedux(id));
  };
  const setLeadList = list => {
    leadListRef.current = list;
    dispatch(setLeadsRedux(list));
  };

  // Reconcile one lead's unread count against a value the SERVER just gave us —
  // the `updateUnreadCount` mutation response or its `update_count` socket echo
  // — and move the tab badges with it. No refetch: the row in Redux and the
  // All/Pinned badges are written in place.
  //
  // The mutation is not a guaranteed "mark read": the API only zeroes
  // `unread_count` when the caller is the last user to have messaged the lead,
  // so opening someone else's lead legitimately answers with the count still
  // set (e.g. 3). Taking the response at face value is what stops the
  // optimistic zero below from leaving a read-looking row and a decremented
  // badge that the next getLeads response contradicts.
  const applyLeadUnreadCount = (leadId, serverUnreadCount) => {
    if (serverUnreadCount === null || serverUnreadCount === undefined) return;
    const nextUnread = Math.max(0, +serverUnreadCount || 0);
    const list = leadListRef.current || [];
    const index = list.findIndex(item => +item?.id === +leadId);
    // Badges count leads within the loaded result set, so a lead that isn't in
    // it contributes to neither — nothing to update, and guessing would drift.
    if (index < 0) return;
    const prevUnread = list[index]?.unreadCount || 0;
    if (prevUnread === nextUnread) return;
    // Only a 0 <-> unread crossing changes how many LEADS carry unread; a count
    // moving 3 -> 1 is the same one lead. `adjustUnreadLeadsCount` handles both
    // tabs (All always, Pinned when the row is pinned).
    if (prevUnread > 0 && nextUnread === 0) {
      adjustUnreadLeadsCount(leadId, -1);
    } else if (prevUnread === 0 && nextUnread > 0) {
      adjustUnreadLeadsCount(leadId, 1);
    }
    const newState = structuredClone(list);
    newState[index] = { ...newState[index], unreadCount: nextUnread };
    setLeadList(newState);
  };

  // Leaving the single-lead (?leadId=) view. Shared by "Show all leads" and by
  // both "Clear all" actions — clearing filters while the list is still pinned
  // to one lead left the "Show all leads" button on screen with nothing to
  // clear. The filter reset itself is handled by the caller.
  const exitSingleLeadView = () => {
    setIsSingleLeadView(false);
    setParamLeadId(null);
    hasSkippedInitialLocEffectRef.current = false;
    clearTargetMessageId();
  };

  const updateLeadMessagesRedux = async (laedId, messages) => {
    dispatch(addMessage({ id: laedId, messages: messages }));
  };

  useEffect(() => {
    const currentUrlParams = new URLSearchParams(window.location.search);
    const urlLeadId = currentUrlParams.get("leadId");
    // If navigating via leadId URL, don't set the queryString as search
    if (urlLeadId) {
      setSearch("");
      setSearchKey("");
      setParamLeadId(urlLeadId);
      // A ?leadId= deep link hides the tabs and must return that lead whether
      // or not it is pinned — dropping the narrowing also drops the tab back
      // to All, which is derived from it.
      setVariables(prev => ({ ...prev, page: 1, leadId: urlLeadId, isPinned: undefined }));
    } else {
      setSearch(queryString !== "undefined" && queryString !== "remove" ? queryString : "");
      setParamLeadId(null);
    }
  }, [queryString]);

  // Sync targetMessageId state with sessionStorage on location switch or route change.
  // Handles two scenarios:
  // - Notification click (sessionStorage has value): set targetMessageId → triggers messagesV2 with messageId
  // - Location dropdown switch (sessionStorage cleared by mainLayout.js): clear targetMessageId → hides "View all messages" button
  useEffect(() => {
    const fromSession = sessionStorage.getItem("targetMessageId");
    if (fromSession) {
      setTargetMessageId(fromSession);
      // If a lead is already selected (e.g., notification click while on activity center),
      // fetch messages immediately so we don't depend on selectedLead?.id changing
      if (selectedLead?.id) {
        getMessages({
          variables: {
            ...messageFilters,
            leadId: selectedLead?.id,
            campaignIds: (messageFilters.campaignIds || []).map(el => parseInt(el)),
            [QUERY_VAR_TARGET_MESSAGE_ID]: fromSession,
          },
        });
      }
    } else if (targetMessageId) {
      setTargetMessageId(null);
    }
  }, [routerLocation?.search, locationIdslice]);

  // Mirror the active opp-type tab to a window global so the
  // SocketIO handlers in ``layout.js`` (which live outside this
  // component's React tree) can drop ``sent_message`` /
  // ``received_message`` events whose ``root_opp_type_id`` belongs
  // to a different tab. Without this filter, a Service-tab user
  // would see Sales messages pop into their activity center the
  // moment they arrive. Reset to null on unmount so a route change
  // away from the activity center doesn't leave a stale tab id
  // governing the filter. See ``layout.js::shouldDropForActiveTab``.
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    // eslint-disable-next-line no-underscore-dangle
    window.__ACTIVE_OPP_TYPE_ID__ = selectedOppTypeId || null;
    return () => {
      // eslint-disable-next-line no-underscore-dangle
      window.__ACTIVE_OPP_TYPE_ID__ = null;
    };
  }, [selectedOppTypeId]);

  // Expose a setter so ``layout.js``'s socket handlers (which live
  // outside this component's React tree) can bump the per-root unread
  // counter when they drop a ``received_message`` / ``sent_message``
  // event that belongs to a different tab. Without this bridge,
  // out-of-tab events were silently dropped — user got no red-dot
  // indicator that there was activity in the other tab.
  //
  // Args: ``rootId`` (number) the off-tab's root opp_type id.
  // No-op when ``rootId`` is falsy or matches the currently-selected
  // tab (the active tab never gets its own dot).
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    // eslint-disable-next-line no-underscore-dangle
    window.__BUMP_UNREAD_BY_ROOT__ = rootId => {
      if (!rootId) return;
      const numRoot = Number(rootId);
      if (Number.isNaN(numRoot)) return;
      if (selectedOppTypeId && Number(selectedOppTypeId) === numRoot) return;
      setUnreadByRoot(prev => ({
        ...prev,
        [numRoot]: (prev[numRoot] || 0) + 1,
      }));
    };
    return () => {
      // eslint-disable-next-line no-underscore-dangle
      window.__BUMP_UNREAD_BY_ROOT__ = null;
    };
  }, [selectedOppTypeId]);

  useEffect(() => {
    const updatedRecords = (records || []).map((record, index) => {
      const recordKey = `record${index + 1}`;

      if (doNotMerge[recordKey]) {
        return {
          ...record,
          Name: { ...record.Name, disabled: true, selected: false },
          "Phone number": { ...record["Phone number"], disabled: true, selected: false },
          Address: { ...record.Address, disabled: true, selected: false },
          Location: { ...record.Location, disabled: true, selected: false },
          Owners: { ...record.Owners, disabled: true, selected: false },
          Email: { ...record.Email, disabled: true, selected: false },
          "Lead status": { ...record["Lead status"], disabled: true, selected: false },
          Source: { ...record.Source, disabled: true, selected: false },
          Vehicle: { ...record.Vehicle, disabled: true, selected: false },
        };
      } else if (Object.hasOwn(doNotMerge, recordKey)) {
        return {
          ...record,
          Name: { ...record.Name, disabled: false, selected: false },
          "Phone number": { ...record["Phone number"], disabled: false, selected: false },
          Address: { ...record.Address, disabled: false, selected: false },
          Location: { ...record.Location, disabled: false, selected: false },
          Owners: { ...record.Owners, disabled: false, selected: false },
          Email: { ...record.Email, disabled: false, selected: false },
          "Lead status": { ...record["Lead status"], disabled: false, selected: false },
          Source: { ...record.Source, disabled: false, selected: false },
          Vehicle: { ...record.Vehicle, disabled: false, selected: false },
        };
      }
      return record;
    });

    setRecords(updatedRecords);
  }, [doNotMerge]);

  const handleMediaSharing = mediaType => {
    if (mediaType === "image") {
      mediaRef.current.click();
    } else if (mediaType === "video") {
      videoRef.current.click();
    } else {
      documentRef.current.click();
    }
  };

  const checkLocation = locationId => {
    let locations = [];
    if (sessionStorage.getItem("currentLocationId")?.includes(",")) {
      locations = sessionStorage
        .getItem("currentLocationId")
        .split(",")
        .map(loc => +loc);
    } else {
      locations = [+sessionStorage.getItem("currentLocationId")];
    }
    return locations.includes(+locationId);
  };
  const { textMode: textModeRedux } = useSelector(state => state.lead);
  const addSignature = signature => {
    if (textModeRedux === "Email") {
      emailTextRef.current.innerHTML = `${emailTextRef.current.innerHTML} <br/> ${signature}`;
    }
  };

  const fetchData = async (files, fileType) => {
    if (fileType.includes("video" || "quicktime")) {
      try {
        const response = await generateVideoThumbnails(files, 2);

        // Validate response before proceeding
        if (!response || !Array.isArray(response) || response.length === 0) {
          return null;
        }
        setVideoThumbnails(response[0]);
        const thumbnailUrl = await s3uploader(
          response,
          process.env.GATSBY_S3_BUCKET,
          state => {},
          true,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          selectedLead,
          null,
          true
        );
        return thumbnailUrl.url;
      } catch (e) {
        console.log("error in generateVideoThumbnails", e);
        return null;
      }
    }
    if (fileType.includes("image")) {
      try {
        const thumbFile = await generateImageThumbnail(files, 256);
        const uploaded = await s3uploader(
          thumbFile,
          process.env.GATSBY_S3_BUCKET,
          () => {},
          false,
          sessionStorage.getItem("currentLocationId")?.includes(",")
            ? "all"
            : sessionStorage.getItem("currentLocationId"),
          user,
          selectedLead,
          null
        );
        return uploaded?.url || null;
      } catch (e) {
        console.log("error in generateImageThumbnail", e);
        return null;
      }
    }
    return null; // Other types (docs, etc.) — no thumbnail
  };

  const handleOppFilter = oppValue => {
    setActiveOpp(oppValue);
  };

  const setOppDropdown = () => {
    // Filter the lead's opportunities by the active Sales / Service /
    // Parts tab before building the dropdown. The dropdown drives both
    // the visible options AND the ``activeOpp`` "scope this thread to
    // one opp" mode, so trimming it here keeps the rest of the page
    // consistent with the right-panel tab toggle.
    const allOpps = selectedLead?.leadOpportunities;
    // Build the unfiltered companion FIRST — the Top toolbar nested
    // dropdown needs the full enriched set (every root, every opp) to
    // render full labels and to keep the cross-tab pick from being
    // clobbered by the tab-scoped opportunityList during the brief
    // tab-switch render window.
    setFullOpportunityList(prepareOpportunityList(allOpps, crmIntegration) || []);

    let sourceOpps = allOpps;
    if (selectedOppTypeId && Array.isArray(sourceOpps)) {
      sourceOpps = sourceOpps.filter(opp => oppMatchesTab(opp, selectedOppTypeId));
    }
    const oppoDropdown = prepareOpportunityList(sourceOpps, crmIntegration);
    // Add "All" option at the end (scoped to the current tab when one
    // is selected — "All" means "all of THIS tab", not all opps).
    if (oppoDropdown && oppoDropdown.length > 0) {
      oppoDropdown.push({
        id: "#DEFAULTOPPID",
        name: "All",
      });
    }

    setOpportunityList(oppoDropdown || []);
  };

  const updateMobileResponsive = () => {
    setShowLeadSection(window.innerWidth > 1024);
    setShowProfileSection(window.innerWidth > 1024);
  };

  const onClickHandler = (content, lead, userId, button = false) => {
    // Bail if the session is gone — prevents firing createMessage with userId: null
    // (which the server rejects with "Signature has expired" anyway). Prefer the
    // "Reply as" selection (EAI-1530), then the current context user, then the
    // userId arg the caller passed in. The recipient is always the lead — this
    // only changes who the reply is attributed to.
    const currentUserId = user?.id ?? userId;
    if (!currentUserId) {
      message.error("Your session has expired. Please refresh the page and sign in again.");
      return;
    }

    // Capture current isReview state and reset immediately
    const currentIsReview = isReview;
    if (currentIsReview) {
      setisReview(false);
    }

    if (!isEmpty(content) && !isEmpty(lead)) {
      if (
        !isEmpty(lead?.phoneNumbers) ||
        selectedLead?.leadSource?.name === "EngagedAi - Webchat"
      ) {
        const messagePayload = {
          leadId: +lead?.id,
          userId: +currentUserId,
          // Reply-as (EAI-1530): actual sender when signing on behalf of another.
          replyAsUserId: replyAsSigner?.id || null,
          user: {
            id: replyAsSigner?.id || currentUserId || null,
            firstName: replyAsSigner?.firstName || user?.firstName || "",
            lastName: replyAsSigner?.lastName || user?.lastName || "",
            fullName: replyAsSigner?.fullName || user?.fullName,
            profilePic: replyAsSigner?.profilePic ?? user?.profilePic,
          },
          direction: "TO_LEAD",
          content: content,
          toPhone: getLeadToPhone(lead),
          dateSent: dayjs().utc().toISOString(),
          messageType: currentIsReview ? "REVIEW" : "NORMAL",
          contentType: currentIsReview
            ? MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT
            : "Sent Message to Lead",
          leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
          ...(eventId ? { dsEventId: eventId } : {}),
          // Active Sales / Service / Parts tab — BE uses this to pick
          // the right opportunity to attach the message to (instead of
          // the most-recent opp default) when no explicit
          // leadOpportunityId is supplied. Falls back to legacy when
          // null (no tab selected / no permitted opps).
          selectedOppTypeId: selectedOppTypeId || null,
          aiResponseHistoryId: textAiResponseHistoryId ?? null,
        };
        let selectedLeadDetails = {
          ...selectedLead,
          textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
        };
        if ((selectedLead?.messages || []).length <= 0) {
          selectedLeadDetails = { ...selectedLeadDetails, messages: [] };
        }
        const temp = structuredClone(selectedLeadDetails);
        // Phase 3a: insert an optimistic queued bubble for ALL message types
        // (including REVIEW) so the lambda-cutover SocketIO replace flow can
        // find and update it, and the user sees the "Sending…" indicator.
        temp.messages.push({
          ...messagePayload,
          // Optimistic bubble mirrors the SERVER response shape (not the mutation
          // vars): userId = the DISPLAYED reply-as user so the header name resolves
          // via userIdMap immediately, and originalUserId = the actual sender (login
          // user) so the "on behalf of" second avatar shows while sending. The
          // mutation vars above keep userId = login + replyAsUserId = signer.
          userId: +(replyAsSigner?.id || currentUserId),
          originalUserId:
            replyAsSigner?.id && +replyAsSigner.id !== +currentUserId ? +currentUserId : null,
          type: "new",
        });
        selectedLeadDetails = structuredClone(temp);
        selectedLeadDetails = {
          ...selectedLeadDetails,
          messages: selectedLeadDetails.messages.filter(item => item !== undefined),
        };
        page = 1;
        // Optimistic render: show the message bubble immediately so the
        // user gets instant feedback. Mutation runs in parallel; .then
        // below either replaces the bubble (200), flips to queued (202),
        // or flips to error.
        setSelectedLead(selectedLeadDetails);
        updateLeadMessagesRedux(selectedLeadDetails?.id, selectedLeadDetails.messages);
        setrichTextValue("");
        createMessage({
          variables: {
            ...messagePayload,
          },
        }).then(res => {
          if (text.current) {
            text.current.value = "";
            text.current.style.height = "0px";
            text.current.placeholder = placeholder();
            setmessageText("");
          }
          if (textMode !== 0) {
            setrichTextValue("");
          }
          setCallConsentMessage(false);
          if (res?.data?.createMessage?.statusCode === 202) {
            // Phase 3a (lambda cutover): mutation returned 202 Accepted —
            // the lambda will create the Message row asynchronously and
            // emit a SocketIO ``sent_message`` event when done. Leave the
            // optimistic bubble in place but flip its type so the
            // SocketIO handler in layout.js can find and replace it.
            const leadInfo = structuredClone(selectedLeadDetails);
            const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
            if (findIndex > -1) {
              leadInfo.messages[findIndex] = {
                ...leadInfo.messages[findIndex],
                type: "queued",
              };
            }
            setSelectedLead({ ...leadInfo });
            updateLeadMessagesRedux(leadInfo.id, leadInfo.messages);
            setChangeState(!changeState);
            setbtnClicked(true);
            dispatch(setTextAiResponseHistoryId(null));
          } else if (res?.data?.createMessage?.statusCode === 200) {
            const resMessage = res?.data?.createMessage?.leadMessage || {};
            // Replying reads the lead. Route it through the shared helper so the
            // All/Pinned badge follows the row — zeroing the row alone left the
            // tab pill counting a lead that no longer shows as unread.
            applyLeadUnreadCount(selectedLead?.id, 0);

            if (
              !isConsentStatusEnable(
                selectedLead?.textConsentStatus,
                user?.company?.isOptinConsentMethod
              )
            ) {
              updateLeadConsent({
                variables: { leadId: selectedLead?.id },
              });
            }

            const leadInfo = structuredClone(selectedLeadDetails);
            const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
            if (findIndex > -1) {
              leadInfo.messages[findIndex] = {
                ...resMessage,
                leadOpportunity: resMessage?.leadOpportunity || { name: "", id: "" },
              };
            } else {
              leadInfo.messages.push(resMessage);
            }

            setSelectedLead({ ...leadInfo });
            updateLeadMessagesRedux(leadInfo.id, leadInfo.messages);
            setChangeState(!changeState);
            setbtnClicked(true);
            dispatch(setTextAiResponseHistoryId(null));
          } else {
            message.error(res?.data?.createMessage?.message || lang.msgSendFail);
            const leadInfo = structuredClone({ ...selectedLeadDetails });
            const findIndex = leadInfo.messages.findIndex(el => el?.type === "new");
            if (findIndex > -1) {
              leadInfo.messages[findIndex].type = "error";
            }
            setSelectedLead({ ...leadInfo });
            setChangeState(!changeState);
            // Restore isReview state if message failed to send
            if (currentIsReview) {
              setisReview(true);
            }
          }
          if (!selectedLead?.textConsentStatus) {
            // console.log("🚀 ~ onClickHandler ~ selectedLead?.textConsentStatus", selectedLead?.textConsentStatus, "| calling getLeadDetail");
            getLeadDetail({ variables: { leadId: selectedLead?.id } });
          }
        });
      } else {
        message.error("No phone number registered for this lead");
        text.current.style.height = "0px";
      }
    } else {
      message.error("Please enter a message");
      text.current.value = "";
      text.current.style.height = "0px";
    }
  };

  useQuery(GET_SCHEDULED_MESSAGES_FOR_LEAD, {
    fetchPolicy: "network-only",
    variables: {
      leadId: selectedLead?.id,
    },
    skip: !selectedLead?.id || +selectedLead?.id === +selectedLeadID,
    onCompleted: res => {
      dispatch(setScheduledMessages([...res?.getScheduledMessagesForLead]));
    },
  });
  useEffect(() => {
    if (!isEmpty(lead) && !Array.isArray(lead)) {
      setSelectedLead(lead);
      setSelectedLeadId(lead.id);
    }
    if (Array.isArray(lead) && lead?.length > 0) {
      setSelectedLead(lead[0]);
      setSelectedLeadId(lead[0].id);
    }
  }, [lead]);

  useEffect(() => {
    dispatch(resetTranlatedContent());
    dispatch(changeMessageOpportunity("#DEFAULTOPPID"));
    setSummaryVisible({ visible: false, count: 0 });
    // Clear the pagination guard so a fetch left in flight on the previous lead
    // doesn't block loading older messages for the newly selected lead.
    isFetchingOlderRef.current = false;
  }, [selectedLead?.id]);

  useEffect(() => {
    if (leadCountUpdatedData?.lead_id) {
      // Authoritative: the server just told us this lead's real count, which may
      // be another session of ours reading or replying to it. Idempotent with
      // the mutation-response path — whichever lands second sees the row
      // already at the server's value and does nothing.
      applyLeadUnreadCount(leadCountUpdatedData.lead_id, leadCountUpdatedData.unread_count || 0);
    }
  }, [leadCountUpdatedData]);

  const onClickReviewHandler = (content, reviewLink, lead, userId, messageType = "NORMAL") => {
    if (!isEmpty(content)) {
      let messagePayload = {
        leadId: lead?.id,
        userId: userId,
        direction: "TO_LEAD",
        content: content,
        toPhone: getLeadToPhone(lead),
        reviewLink,
        dateSent: dayjs().toISOString(),
        messageType,
        // Active tab — see other messagePayload site for full doc.
        selectedOppTypeId: selectedOppTypeId || null,
        aiResponseHistoryId: textAiResponseHistoryId ?? null,
      };
      let selectedLeadDetails = {
        ...selectedLead,
        textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
      };
      if ((selectedLead?.messages || []).length <= 0) {
        selectedLeadDetails = { ...selectedLeadDetails, messages: [] };
      }

      page = 1;
      setSelectedLead(selectedLeadDetails);
      textMode === 0 ? (text.current.value = "") : setrichTextValue("");
      if (eventId) {
        messagePayload = { ...messagePayload, dsEventId: eventId };
      } else {
        delete messagePayload.dsEventId;
      }
      const res = createMessage({
        variables: {
          ...messagePayload,
        },
      }).then(res => {
        if (res?.data?.createMessage?.statusCode === 202) {
          // Phase 3a: lambda cutover — leave optimistic bubble in queued state.
          // SocketIO sent_message will replace it via replaceQueuedMessage.
          selectedLeadDetails.messages.push({
            ...messagePayload,
            type: "queued",
            messageType: "Review",
            contentType: MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT,
          });
          setSelectedLead({ ...selectedLeadDetails });
          setChangeState(!changeState);
          dispatch(setTextAiResponseHistoryId(null));
        } else if (res?.data?.createMessage?.statusCode === 200) {
          // Replying reads the lead. Route it through the shared helper so the
          // All/Pinned badge follows the row — zeroing the row alone left the
          // tab pill counting a lead that no longer shows as unread.
          applyLeadUnreadCount(selectedLead?.id, 0);
          const resMessage = res?.data?.createMessage?.leadMessage || {};
          const id = parseInt(resMessage?.id);
          messagePayload.content = resMessage?.content;
          selectedLeadDetails.messages.push({
            ...messagePayload,
            ...resMessage,
            type: "new",
            messageType: "Review",
            contentType: MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT,
          });
          setSelectedLead(selectedLeadDetails);
          //

          const leadDetails = structuredClone({ ...selectedLeadDetails });
          const findIndex = leadDetails.messages.findIndex(el => el?.type === "new");
          if (findIndex > -1) {
            leadDetails.messages[findIndex] = { ...resMessage };
            // leadDetails.messages[findIndex].type = "";
            // leadDetails.messages[findIndex].id = resMessage?.id;
            // leadDetails.messages[findIndex].dateSent = resMessage?.dateSent;
            // leadDetails.messages[findIndex].messageStatus = resMessage?.messageStatus;
            // leadDetails.messages[findIndex].messageType = resMessage?.messageType;
            // leadDetails.messages[findIndex].errorMessage = resMessage?.errorMessage;
            // leadDetails.messages[findIndex].errorCode = resMessage?.errorCode;
            // leadDetails.messages[findIndex].leadOpportunity = resMessage?.leadOpportunity ||
            //   resMessage?.lead_opportunity || { name: "", id: "" };
          }
          setSelectedLead({ ...leadDetails });

          setChangeState(!changeState);
          dispatch(setTextAiResponseHistoryId(null));
        } else {
          message.error(res?.data?.createMessage?.message);
        }
      });
    }
  };

  const handleBackClick = () => {
    // redirect to previous slug value
    window.history.back();
  };

  const { scrollToBottom: scrollToBottomHook, onLoadOlderStart } = useChatScroll({
    containerRef: msgContainerRef,
    items: selectedLead?.messages || [],
    // Reset on opp-type switch too: switching tabs reloads the thread's
    // messages without changing selectedLead.id, so without this the hook
    // wouldn't re-run its initial scroll-to-bottom and the new opp's thread
    // would open slightly above the bottom (esp. if the prior opp was
    // scrolled up). Switching lead already worked because the id changes.
    resetDeps: [selectedLead?.id, selectedOppTypeId],
    bottomThreshold: 80,
    initialScroll: true,
    // Deep-link flow: when a target message is active, let useScrollToMessage
    // own the scroll position instead of this hook pinning to the bottom.
    disableAutoScroll: !!targetMessageId,
    anchorSelector: `.${MESSAGE_CONTAINER_CLASSNAME}`,
  });

  const scrollToBottom = (behavior = "smooth") => {
    scrollToBottomHook(behavior);
  };

  const updateDimensions = () => {
    setShowLeadSection(window.innerWidth > 1024);
    setShowProfileSection(window.innerWidth > 1024);
  };

  const handleSendConsentClick = (e, status) => {
    status !== "PENDING" && setDisableConcentClick(prev => !prev);
    if (e) {
      e.preventDefault();
      if (status === "PENDING") {
        showConfirmationModal(lang.resendConsent, "", () => {
          sendContentMessage();
        });
      } else {
        sendContentMessage();
      }
    }

    concentTime = setTimeout(() => {
      setDisableConcentClick(true);
    }, 10000);
  };

  const sendContentMessage = async () => {
    let content =
      consentTemplate ||
      `${user?.company?.name || lang.theDelear} ${lang.wantsToReplayYou}. ${lang.stopToOptout}.`;
    if (user?.company?.isOptinConsentMethod) {
      content = `${user?.company?.name || lang.theDelear} ${lang.wantsToReplayYou}. ${
        lang.optInOptOut
      }.`;
    }
    await updateLeadConsent({ variables: { leadId: selectedLead?.id } })
      .then(resp => {
        if (resp?.data?.updateLeadConsentStatus?.ok) {
          const respLead = resp?.data?.updateLeadConsentStatus?.lead || {};
          setSelectedLead({
            ...selectedLead,
            textConsentStatus: respLead?.textConsentStatus || "PENDING",
            textConsentDate: respLead?.textConsentDate || dayjs(),
          });
          const arrayFn = () => {
            const newState = structuredClone(leadList);
            const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
            if (findIndex > -1) {
              newState[findIndex].textConsentStatus = respLead?.textConsentStatus;
              newState[findIndex].textConsentDate = respLead?.textConsentDate;
            }
            return newState;
          };
          setLeadList(arrayFn());
          message.success(lang.consentSent);
          // The status change is recorded as a CONSENT_UPDATE message, which
          // is separate from the consent SMS `onClickHandler` sends below.
          getMessages();

          setTimeout(() => {
            clearTimeout(concentTime);
            setDisableConcentClick(true);
          }, 3000);
        }
      })
      .catch(() => {
        clearTimeout(concentTime);
        setDisableConcentClick(true);
      });
    onClickHandler(content, { ...selectedLead, textConsentStatus: "PENDING" }, user?.id);
  };

  const handleSendReviewInviteClick = () => {
    openDialog("sendReviewInvite", {
      dialogHeader: lang.sendReviewInvite,
      phoneNumber: queryString,
      openModal: openAddModal && modal && apiCheck,
      statusList: statusList,
      setModalVisible: setAddPhoneModalVisible,
      variables: variables,
      data: leadList,
      sources: sourcesData || [],
      user: user,
      oncancel: () => {
        closeDialog("sendReviewInvite");
      },
      // dialogHeader: "Send review invite link",
      sendSendReview: payload => {
        onClickReviewHandler(`${payload.body}`, payload.reviewLink, payload.selectedLead, user?.id);
      },
      onSetLead: (item, mode, phoneLead = "") => {
        if (phoneLead === "phoneLead") {
          const newLead = { ...item, messages: [] };
          setSelectedLead(newLead);
          // Keep redux-based consumers (e.g. InputArea) pointed at the same lead.
          setSelectedLeadId(item.id);

          page = 1;
          setMessageFilters({
            ...messageFilters,
            leadId: item.id,
            lastId: lastLead,
            page: 1,
          });
          if (mode === "new") {
            const tempLeads = structuredClone(leadList);
            tempLeads.unshift(newLead);
            setLeadList(structuredClone([...tempLeads]));
          }
        } else {
          if (+selectedLead?.id === +item?.id) {
            setAddPhoneModalVisible(false);
            return;
          }

          if (sessionStorage.getItem("currentLocationId") !== +item?.location?.id) {
            localStorage.setItem("changedLocationLeadId", item?.id);
            sessionStorage.setItem("currentLocationId", item?.location?.id);
            window.location.reload();
            return;
          }

          handleLeadDetailProfile(item?.id);
          handleScrollOnMovement();
        }
      },
      onLeadStatus: LeadStatus,
      onLeadOwners: leadOwners,
      onVehicles: vehicles,
      crmIntegration: crmIntegration,
    });
  };

  const handleAddPhoneClick = () => {
    // setAddPhoneModalVisible(true);
    openDialog("addLeadViaPhone", {
      dialogHeader: lang.addPhone,
      phoneNumber: queryString,
      openModal: openAddModal && modal && apiCheck,
      statusList: statusList,
      setModalVisible: setAddPhoneModalVisible,
      variables: variables,
      data: leadList,
      sources: sourcesData || [],
      user: user,
      onSetLead: (item, mode, phoneLead = "") => {
        if (phoneLead === "phoneLead") {
          const newLead = { ...item, messages: [] };
          setSelectedLead(newLead);
          // Keep redux-based consumers (e.g. InputArea) pointed at the same lead.
          setSelectedLeadId(item.id);

          page = 1;
          setMessageFilters({
            ...messageFilters,
            leadId: item.id,
            lastId: lastLead,
            page: 1,
          });
          const newLeadList = structuredClone(leadList);
          if (mode === "new") {
            newLeadList.unshift(newLead);
            setLeadList(newLeadList);
          }
        } else {
          if (+selectedLead?.id === +item?.id) {
            setAddPhoneModalVisible(false);
            return;
          }

          if (sessionStorage.getItem("currentLocationId") !== +item?.location?.id) {
            localStorage.setItem("changedLocationLeadId", item?.id);
            sessionStorage.setItem("currentLocationId", item?.location?.id);
            window.location.reload();
            return;
          }

          handleLeadDetailProfile(item?.id);
          handleScrollOnMovement();
        }
      },
      onLeadStatus: LeadStatus,
      onLeadOwners: leadOwners,
      onVehicles: vehicles,
      crmIntegration: crmIntegration,
      refetchLeads: refetchLeads,
    });
  };

  const handleSendReviewClick = () => {
    openDialog("reviewDialog", {
      handleConfirm: () => {
        closeDialog("reviewDialog");
      },
      oncancel: () => {
        closeDialog("reviewDialog");
      },
      lead: selectedLead,
      dialogHeader: "Send review invite link",
      confirmBtnText: "Send",
      sendSendReview: payload => {
        onClickReviewHandler(
          `${payload.body}`,
          payload.reviewLink,
          selectedLead,
          user?.id,
          "REVIEW"
        );
      },
    });
  };

  const handleReviewTemplateUploadClick = () => {
    setReviewTemplateUploadVisible(true);
  };

  const handleStatusFilter = status => {
    setSelectedStatus(status);
    setFilterApplied(true);
    setVariables({ ...variables, page: 1, status, leadId: null });
  };

  const handleSetDefinedTemplate = msg => {
    // console.log("MSG", msg);
    text.current.value = msg;
    textMode === 0 ? (text.current.value = msg) : setrichTextValue(richTextValue + msg);
    // setmessageText(msg);
  };

  const handleAddAppointment = () => {
    setOpenAppointmentDrawer(true);
    setRefetchAppointment(false);
  };

  const handleActiveToggle = async e => {
    await updateLeadConversionStatus({
      variables: { leadId: selectedLead?.id, disableConversation: !e },
    }).then(resp => {
      if (resp?.data?.enableDisableLeadConversation?.statusCode === 200) {
        const respLead = resp?.data?.enableDisableLeadConversation?.lead || {};
        setSelectedLead({
          ...selectedLead,
          ...(selectedLead.conversationStatus
            ? { conversationStatus: !e }
            : { conversationStatus: respLead.conversationStatus || {} }),
        });
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            if (newState[findIndex].conversationStatus) {
              newState[findIndex].conversationStatus.disableConversation = !e;
            } else {
              newState[findIndex] = {
                ...newState[findIndex],
                conversationStatus: respLead?.conversationStatus || {},
              };
            }
          }
          return newState;
        };
        setLeadList(arrayFn());
        e
          ? message.success(`${lang.leadAutoMsgFeatureUpdatedturnedon} ${selectedLead?.fullName}`)
          : message.success(`${lang.leadAutoMsgFeatureUpdatedturnedoff} ${selectedLead?.fullName}`);
      }
    });
  };

  const onMsgScroll = () => {
    // const scrollTop = filterApplied
    //   ? msgContainerRef.current.scrollTop + 10
    //   : msgContainerRef.current.scrollTop;
    // scrollTop === 10 ? setFilterApplied(true) : setFilterApplied(false);
    // scrollTop === 10 && setIsMsgScroll(true);
    // setFilterApplied(false);
    const { scrollTop } = msgContainerRef.current;
    // Ensure the previously requested page has actually been committed to state.
    // Apollo flips `loading` to false before onCompleted runs, so without this
    // check a scroll in that tiny window could fire an extra page (e.g. page 3
    // when only 2 pages exist). If messages.length hasn't caught up to the last
    // requested page, skip — state will settle on the next render.
    // const expectedCommittedMessages = Math.min(
    //   (+messageFilters?.page || 1) * pageSize,
    //   messageCount
    // );
    if (
      selectedLead?.messages?.length < messageCount &&
      // selectedLead?.messages?.length >= expectedCommittedMessages &&
      // Use a small top threshold instead of an exact `scrollTop === 0` match.
      // Browsers report fractional scrollTop on high-DPI/zoomed displays and
      // momentum/smooth scrolling rarely settles at exactly 0, so the strict
      // check would silently skip fetching even when older pages remain.
      scrollTop <= SCROLL_TOP_FETCH_THRESHOLD &&
      !isEmpty(selectedLead?.messages) &&
      !loading &&
      !isFetchingOlderRef.current &&
      !targetMessageId // prevent pagination when searching for a specific message (Right now its only for internal note messages functionality)
    ) {
      // page = filterApplied ? 1 : page + 1;
      // setScrollBottom(scrollTop);
      // Mark a fetch in flight synchronously so a second scroll event in the
      // brief window before onCompleted commits can't fire a duplicate page.
      isFetchingOlderRef.current = true;
      page =
        selectedLead?.messages?.length > pageSize - 1 ? (+messageFilters?.page || page) + 1 : page;
      // Notify hook we're about to prepend older messages so it can preserve anchor
      onLoadOlderStart();
      setMessageFilters({
        ...messageFilters,
        leadId: selectedLead?.id,
        lastId: filterApplied ? filterLastId : lastLead,
        page: page,
      });
    }
    timeReference = setTimeout(() => {
      if (selectedLead?.id && leadList?.length) {
        // TODO : come here for final code review
        // setLeadList(prev => {
        //   const dummySelectedLead = { ...selectedLead };
        //   dummySelectedLead.unreadCount = 0;
        //   const selectedleadIndex =
        //     leadList?.length > 0 &&
        //     leadList.findIndex(lead => +lead?.id === +dummySelectedLead?.id);
        //   const dummyLeadList = [...leadList];
        //   dummyLeadList[selectedleadIndex] = dummySelectedLead;
        //   return dummyLeadList;
        // });
      }
    }, 1000);
  };
  let currentScrollTop;
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    // Function to calculate and set the container width
    const updateContainerWidth = () => {
      if (msgContainerRef.current) {
        const { width } = msgContainerRef.current.getBoundingClientRect();
        setContainerWidth(width);
      }
    };

    // Call the function on component mount
    updateContainerWidth();

    // Attach a resize event listener to update the width if the window is resized
    window.addEventListener("resize", updateContainerWidth);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", updateContainerWidth);
    };
  }, []);

  const handleLeadDetailProfile = async leadId => {
    setLeadIdClick(leadId);
    localStorage.setItem("clickLeadId", leadId);
  };

  const handleScrollOnMovement = () => {
    document.querySelector(".antdList").scrollTop = 0;
  };

  const handleUpdate = async payload => {
    if (payload) {
      let lead = structuredClone(selectedLead);
      if (payload?.key === "fullName") {
        const leadResp = await updateLead({
          variables: {
            leadId: selectedLead?.id,
            fullName: payload?.value?.replace(/\s{2,}/g, " ")?.trim() || "",
            isSyncCheck: true,
            isPushCrm: true,
          },
        });
        if (leadResp?.data?.updateLead?.statusCode !== 200) {
          message.error(leadResp?.data?.updateLead?.message);
          return;
        }

        lead = {
          ...lead,
          fullName: leadResp?.data?.updateLead?.lead?.fullName,
        };
        // console.log("🚀 ~ handleUpdate ~ payload?.key === fullName | calling getLeadDetail...");
        getLeadDetail({ variables: { leadId: lead?.id } });
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            newState[findIndex].fullName = lead.fullName;
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      if (payload?.key === "phone") {
        let phoneResp = null;
        if (payload.id) {
          phoneResp = await updateLeadPhone({
            variables: {
              id: payload.id,
              phone: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
              phoneType: toTitleCase(payload.phoneType),
              leadId: selectedLead?.id,
            },
          });
          if (phoneResp?.data?.updateLeadPhone?.statusCode !== 200) {
            message.error(phoneResp?.data?.updateLeadPhone?.message);
            return;
          }
          const index = lead.phoneNumbers.findIndex(
            item => toTitleCase(item.phoneType || item.lookupType) === payload.phoneType
          );
          lead.phoneNumbers[index] = {
            ...phoneResp?.data?.updateLeadPhone?.leadPhone,
          };
          // console.log("🚀 ~ handleUpdate ~ payload?.key === phone | calling getLeadDetail...");
          getLeadDetail({ variables: { leadId: lead?.id } });
        } else {
          phoneResp = await createLeadPhone({
            variables: {
              leadId: parseInt(selectedLead?.id),
              phone: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
              phoneType: toTitleCase(payload.phoneType),
            },
          });
          if (phoneResp?.data?.createLeadPhone?.statusCode !== 200) {
            message.error(phoneResp?.data?.createLeadPhone?.message);
            return;
          }
          lead = {
            ...lead,
            phoneNumbers: [{ ...phoneResp?.data?.createLeadPhone?.leadPhone }],
          };
        }
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            const [phone] = lead.phoneNumbers;
            newState[findIndex].phoneNumbers[0] = phone;
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      if (payload?.key === "email") {
        // eslint-disable-next-line no-useless-escape
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!payload?.value.match(emailRegex)) {
          message.error(lang.enterValidEmail);
          return;
        }
        let emailResp = null;
        if ((lead?.emails || []).length > 0 && lead?.emails[0] != null) {
          emailResp = await updateLeadEmail({
            variables: {
              id: parseInt(parseInt(lead?.emails[0].id)),
              email: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
            },
          });
          if (emailResp?.data?.updateLeadEmail?.statusCode !== 200) {
            message.error(emailResp?.data?.updateLeadEmail?.message);
            return;
          }
          lead.emails[0] = {
            ...emailResp?.data?.updateLeadEmail?.leadEmail,
          };
          // console.log("🚀 ~ handleUpdate ~ payload?.key === email | calling getLeadDetail...");
          getLeadDetail({ variables: { leadId: lead?.id } });
        } else {
          emailResp = await createLeadEmail({
            variables: {
              leadId: parseInt(selectedLead?.id),
              email: payload?.value || "",
              isSyncCheck: true,
              isPushCrm: true,
            },
          });
          if (emailResp?.data?.createLeadEmail?.statusCode !== 200) {
            message.error(emailResp?.data?.createLeadEmail?.message);
            return;
          }
          lead = {
            ...lead,
            emails: [{ ...emailResp?.data?.createLeadEmail?.leadEmail }],
          };
        }
        const arrayFn = () => {
          const newState = structuredClone(leadList);
          const findIndex = newState.findIndex(el => +el.id === +selectedLead?.id);
          if (findIndex > -1) {
            const [email] = lead.emails;
            if (newState[findIndex]?.emails && newState[findIndex].emails[0]) {
              newState[findIndex].emails[0] = email;
            }
          }
          return newState;
        };
        setLeadList(arrayFn());
      }
      // Merge the edited fields through the reducer so it runs against the
      // LATEST Redux state and keeps ``messages`` intact. ``lead`` is a clone
      // of a (possibly stale) ``selectedLead`` closure whose messages could be
      // empty — spreading that via setSelectedLead blanked the live thread
      // (e.g. after adding a new phone). mergeLeadDetail preserves messages.
      dispatch(mergeLeadDetail(lead));

      setInlineEditField(null);
    }
  };

  const handleRetry = (e, c) => {
    if (c?.id) {
      const leadDetails = structuredClone(selectedLead);
      const findIndex = leadDetails.messages.findIndex(el => +el?.id === +c?.id);
      if (findIndex > -1) {
        leadDetails.messages[findIndex] = {
          ...leadDetails.messages[findIndex],
          type: "new",
          messageStatus: "",
        };
        setSelectedLead({ ...leadDetails });
      }
      retryMessageSend({
        variables: {
          messageId: c.id,
        },
      }).then(resp => {
        if (resp?.data?.retryMessage?.statusCode === 200) {
          getMessages();
        } else {
          message.error(resp?.data?.retryMessage?.message);
        }
      });
    }
  };

  const handleOpportunityId = selectedLead => {
    if (
      selectedLead?.leadOpportunity?.dsOpportunityEvents?.length > 0 &&
      selectedLead?.leadOpportunity?.dsOpportunityEvents[0]?.dsEventId
    ) {
      return `#${String(selectedLead?.leadOpportunity?.dsOpportunityEvents[0]?.dsEventId).padStart(
        4,
        "0"
      )}`;
    }
    if (
      selectedLead?.leadOpportunity?.sfLeadOpportunities?.length > 0 &&
      selectedLead?.leadOpportunity?.sfLeadOpportunities[0]?.sfOpportunityId
    ) {
      return `#${String(
        selectedLead?.leadOpportunity?.sfLeadOpportunities[0]?.sfOpportunityId
      ).padStart(4, "0")}`;
    }
    // VIN
    if (
      selectedLead?.leadOpportunity?.vsLeadOpportunities?.length > 0 &&
      selectedLead?.leadOpportunity?.vsLeadOpportunities[0]?.vsLeadId
    ) {
      return `#${String(selectedLead?.leadOpportunity?.vsLeadOpportunities[0]?.vsLeadId).padStart(
        4,
        "0"
      )}`;
    }

    return getOpprDetails({ opportunity: selectedLead?.leadOpportunity }).label;
  };

  const handleAppointmentModalClose = async (event, lead, isAPINeedTocall = false) => {
    event && event.stopPropagation && event.stopPropagation();
    setAppointmentLead({});
    try {
      let appointmentDetails;
      if (isAPINeedTocall) {
        setAppointmentPopupVisible(!openAppointmentPopup);
        setAppointmentLead(prev => {
          const newState = { ...prev, ...appointmentDetails?.data?.lead };
          !isAPINeedTocall && setAppointmentPopupVisible(!openAppointmentPopup);
          openDialog("appointmentForm", {
            dialogHeader:
              lead?.activeAppointment?.appointmentStatus === "CANCELLED"
                ? lang.appointmentCancelled
                : lang.editAppointment,
            lead: lead,
            visibleModal: openAppointmentPopup,
            appointment: lead?.activeAppointment,
            defaultDate: null,
            eventId: eventId,
            selectedLead,
            isFromCard: true,
            refreshLeadListData: refetchAfterAppointmentSave,
            refetchLeads: refetchAfterAppointmentSave,
            setrefetchAppointments,
            refetchAppointments,
            setAppointmentModelVisible: handleAppointmentModalClose,
            leadOpportunities: lead?.leadOpportunities,
            // Active root opp_type tab — filters the appointment form's
            // opp dropdown and defaults to a tab-matching opp.
            selectedOppTypeId,
            redirect: async (e, updateDate, needToRedirect = true, leadId, isClickOnName) => {
              // Read live selectedLead via ref — this redirect is captured into the
              // appointmentForm dialog payload, so closure values can be stale.
              const liveSelectedLeadId = selectedLeadRef.current?.id;
              if (+liveSelectedLeadId === +leadId && isClickOnName) {
                closeDialog("appointmentForm");
                return;
              }
              setIsAppointmentChangeFromLead(prev => !prev);
              // Any branch that calls handleLeadDetailProfile writes to localStorage
              // ("clickLeadId"), which the engagements.js useEffect picks up and uses
              // to refetch lead detail + call onRowClick → setLeadDetail([lead]) →
              // changes the `lead` prop on this component → variables change →
              // getLeads refetches → onCompleted unshifts → pin.
              // For a save-and-close flow, selectedLead is already the saved lead
              // (set when the user clicked the card / calendar label that opened
              // this dialog), and the lead's data was already updated in the list
              // via refetchAfterAppointmentSave. So skip the cascade entirely.
              if (leadId) {
                return;
              }
              if (!(isEmpty(appintmentLead) && e)) {
                setIsMsgApi(true);
                handleLeadDetailProfile(liveSelectedLeadId);
                handleScrollOnMovement();
                setShowLeadSection(false);
              }
            },
          });
          return lead;
        });
        setAppointmentPopupVisible(!openAppointmentPopup);
      }
    } catch (err) {
      console.log("Error in getLeadActiveAppointment", err);
    }
  };
  const buttonStyle = () => {
    if (textModeRedux === "Email") {
      return { background: "blue" };
    }
    if (selectedLead?.leadSource?.name === "EngagedAi - Webchat") {
      if (selectedLead?.phoneNumbers?.length > 0)
        if (!connection?.connected && !(selectedLead?.phoneNumbers?.length > 0))
          return {
            background: "#EF4444",
          };
      return {
        background: "#3B82F6",
      };
    }
    const style = {
      background:
        selectedLead?.textConsentStatus === "DECLINED"
          ? "#EF4444"
          : selectedLead?.textConsentStatus === "ACCEPTED"
          ? "#52c41a"
          : "blue",
    };
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      if ((implicit || explicit) && selectedLead?.textConsentStatus !== "DECLINED") {
        if (selectedLead?.textConsentStatus === "ACCEPTED") {
          style.background = "#52c41a";
        } else {
          style.background = "#F59E0B";
        }
      }
      return style;
    }
    if (canDisabledConversation) {
      style.background = "#EBEBE4";
    }

    return style;
  };
  const tooltipTitle = () => {
    if (textModeRedux === "Email") {
      return "Send Email";
    }
    if (selectedLead?.leadSource?.name === "EngagedAi - Webchat") {
      if (connection?.connected) return "Send message to Widget";
      if (selectedLead?.phoneNumbers?.length > 0) return "Send message to Widget";
      return "User Disconnected";
    }
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      const hasOptedOut = selectedLead?.textConsentStatus === "DECLINED";

      if (implicit || explicit) {
        return hasOptedOut ? "Lead has opted out" : "Send consent request";
      } else {
        return hasOptedOut ? "Lead has opted out" : "Send message";
      }
    } else {
      return "Send Message";
    }
  };
  const textDisabled = () => {
    if (selectedLead?.leadSource?.name === "EngagedAi - Webchat") {
      if (connection?.connected) return false;
      return false;
    }
    if (
      !isConsentStatusEnable(selectedLead?.textConsentStatus, user?.company?.isOptinConsentMethod)
    ) {
      if (implicit || explicit) {
        return true;
      }
      return false;
      // eslint-disable-next-line no-else-return
    } else {
      return false;
    }
  };
  const buttonDisabled = () => {
    if (textModeRedux === "Email") {
      return false;
    }
    if (selectedLead?.leadSource?.name === "EngagedAi - Webchat") {
      if (connection?.connected) return false;
      if (selectedLead?.phoneNumbers?.length > 0) return false;
      return true;
    }
    return selectedLead?.textConsentStatus === "DECLINED";
  };

  const handleSearch = e => {
    page = 0;
    lastLead = "";
    setSearchKey(e);
    setSelectedLead({});

    if (e) {
      setVariables({ ...variables, page: 1, dsEventId: "", dsEntityId: "", leadId: null });
      setSearch(e);
      setEventId("");
      setEntityId("");
    } else {
      setVariables({ ...variables, page: 1, dsEventId: "", dsEntityId: "", leadId: null });
      setSearch(e);
      setEventId("");
      setEntityId("");
    }
    if (e === "" || e === undefined || e === null) {
      window.history.pushState("", "", `/engagements/activity-center`);
    }
  };

  const sendConsentMessage = () => {
    if (implicit) {
      const { templatetext } = consent.find(
        item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF"
      );
      getEngagementTemplateText({
        variables: {
          leadId: selectedLead?.id,
          content: templatetext,
        },
      });
    }
    if (explicit) {
      const { templatetext } = consent.find(
        item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON"
      );
      getEngagementTemplateText({
        variables: {
          leadId: selectedLead?.id,
          content: templatetext,
        },
      });
    }
  };

  const [getTranslationSettings] = useLazyQuery(GET_TRANSLATION_SETTINGS, {
    variables: { leadId: selectedLead?.id },
    skip: !selectedLead?.id,
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      if (res?.getTranslationSettings) {
        setTargetLangForCustomer(res?.getTranslationSettings?.customerLanguage);
        setTargetLangForEmployee(res?.getTranslationSettings?.userLanguage);
        setIsAutoTranslate(res?.getTranslationSettings?.isAutomaticTranslation);
        setIsIncludeOriginalMessage(res?.getTranslationSettings?.isIncludeOriginalMessage);
        setIsTranslatePreviewShow(res?.getTranslationSettings?.isTranslationPreview);
      } else {
        setIsAutoTranslate(false);
        setIsIncludeOriginalMessage(false);
        setIsTranslatePreviewShow(false);
      }
    },
  });

  const [getLeadsById, { loading: potentialLeadLoader }] = useLazyQuery(GET_POTENTIAL_LEADS_BY_ID);

  useQuery(GET_SUPPORTED_LANGUAGES_BY_LOCATION, {
    fetchPolicy: "cache-first",
    variables: {
      locationId: isAllLocationSelected() ? null : sessionStorage.getItem("currentLocationId"),
    },
    onCompleted: res => {
      const languages = structuredClone(getActiveSupportedLanguages(res?.getSupportedLanguages));
      setLanguages(languages);
    },
  });

  // Refetch only when this actually CHANGED the filter state. This runs again
  // on every location change (the `[user]` effect re-fires because `setUser`
  // hands it a new object), and when the default filter is already applied
  // there is nothing to re-apply — the old unconditional refetch re-ran
  // getLeads for identical variables.
  const setFilterStatusForTeamLeader = async isTeamLeader => {
    if (restrictRemoveDefaultFilter) {
      const hasMyConversation = selectedQuickFilters?.includes(QUICK_FILTERS.MY_CONVERSATIONS);
      if (!hasMyConversation) {
        dispatch(addQuickFilter(QUICK_FILTERS.MY_CONVERSATIONS));
        refetchLeads();
      }
      return;
    }
    if (addMyConversation) {
      const status = uniq([...selectedQuickFilters, ...selectedStatus]);
      const hasMyConversation = status?.find(item => item === QUICK_FILTERS.MY_CONVERSATIONS);
      if (!isTeamLeader && !hasMyConversation) {
        status.push(QUICK_FILTERS.MY_CONVERSATIONS);
        dispatch(addQuickFilter(QUICK_FILTERS.MY_CONVERSATIONS));
        refetchLeads();
      } else if (isTeamLeader && hasMyConversation) {
        const newStatusList = status.filter(item => item !== QUICK_FILTERS.MY_CONVERSATIONS);
        setSelectedStatus(newStatusList);
        refetchLeads();
      }
    }
  };

  const [getReviewInfo] = useLazyQuery(GET_SOCIAL_REVIEW_SETTINGS, {
    variables: {
      companyId: user?.company?.id,
      locationIds: [+(selectedLead?.location?.id || lead?.location?.id)],
    },
    onCompleted: res => {
      const reviewInfos = res?.getSocialReviewSettings || [];
      // Pick the setting for the active opp-type tab instead of blindly taking
      // the first record (see resolveReviewInfoByOppType for the rules).
      const resolved = resolveReviewInfoByOppType(reviewInfos, selectedOppTypeId);
      if (resolved) {
        setReviewInfo(resolved);
      }
    },
  });

  const [getTeamsByCompany] = useLazyQuery(GET_ALL_TEAMS, {
    variables: {
      companyId: user?.company?.id,
    },
    skip: !user?.company?.id,
    fetchPolicy: "cache-first",
    onCompleted: async res => {
      const teamData = res?.getTeams?.data || [];
      if (res && teamData.length > 0) {
        const isTeamLeader = teamData.filter(item => +item?.leaderId === +user?.id)?.length > 0;
        dispatch(setIsuserTeamLeader({ isUserTeamLeader: isTeamLeader }));
        await setFilterStatusForTeamLeader(isTeamLeader);
      }
    },
  });
  const [isRefetching, setRefetching] = useState(false);

  const [refreshLeadList, { loading: refreshLeadsLoader }] = useLazyQuery(
    GET_EXTENSION_LIST_ACTIVITY_CENTER,
    {
      fetchPolicy: "network-only",
    }
  );
  const presetFilterJson = isEmpty(activeLeadFilterReduxData?.genericFilterJson?.filterJson)
    ? {}
    : JSON.parse(activeLeadFilterReduxData?.genericFilterJson?.filterJson);

  // A user locked to "My Conversations" opened a lead via ?leadId= (notification,
  // redirect, pasted link).
  //
  // That path normally sends skipFilter:true, which makes the BE ignore every
  // filter — so a restricted user could open ANY lead by editing the URL.
  // Instead we send only the ownership filter and clear the rest, so their own
  // lead always opens and someone else's never does.
  //
  // UI guard only — the BE must enforce ownership too.
  const isRestrictedDeepLink = !!(hasLeadIdInUrl && paramLeadId) && restrictRemoveDefaultFilter;

  const {
    data: leadData,
    loading: leadsLoading,
    error: leadsError,
    refetch: refetchLeads,
  } = useQuery(GET_EXTENSION_LIST_ACTIVITY_CENTER, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    skip:
      sessionStorage.getItem("currentLocationId") === null ||
      !sessionStorage.getItem("currentLocationId") ||
      // Custom-date guard: when the user has picked "Custom Date" but
      // hasn't committed BOTH endpoints yet, hold the query. Firing with
      // an incomplete range would return unrelated results and confuse
      // the list. Presets and "no filter" fall through normally.
      (leadDateFilterType === CUSTOM_DATE_FILTER &&
        (!Array.isArray(leadDateRange) ||
          leadDateRange.length !== 2 ||
          !leadDateRange[0] ||
          !leadDateRange[1])),
    variables: {
      ...variables,
      search: search ? search?.trim() : "",
      ...(!isEmpty(search) ? { leadId: null } : {}),
      // Restricted deep link: ownership filter only. Otherwise the original
      // rule — a URL leadId clears the status filters so the linked lead is
      // returned regardless of them.
      status: isRestrictedDeepLink
        ? [QUICK_FILTERS.MY_CONVERSATIONS]
        : (isEmpty(search) || !searchAllLeads) && !variables?.leadId
        ? uniq([...selectedQuickFilters, ...selectedStatus])
        : [],
      campaignIds: isRestrictedDeepLink ? [] : variables?.campaignIds?.map(el => parseInt(el)),
      excludeDuplicate: true,
      userIds: isRestrictedDeepLink ? [] : [...userFilters],
      // Team scope — independent of users (AND), omit when empty so the BE
      // treats it as "no team filter". See ActivityCenterFilter → Team tab.
      teamIds:
        !isRestrictedDeepLink && leadTeamFilters.length > 0
          ? leadTeamFilters.map(Number)
          : undefined,
      // Date scope — three modes (Preset / Custom / None) from the Date
      // range tab. CUSTOM sends `filterType: null` + populated `dateRange`
      // (BE contract — the explicit range overrides any preset). Presets
      // send only `filterType`. "No filter" sends neither.
      filterType: isRestrictedDeepLink
        ? undefined
        : leadDateFilterType === CUSTOM_DATE_FILTER
        ? null
        : leadDateFilterType && leadDateFilterType !== ""
        ? leadDateFilterType
        : undefined,
      dateRange:
        !isRestrictedDeepLink &&
        leadDateFilterType === CUSTOM_DATE_FILTER &&
        leadDateRange.length === 2
          ? leadDateRange
          : undefined,
      // Created on / Updated on basis — only sent when a date scope is
      // actually applied (preset filterType or committed CUSTOM range).
      // With no date scope, omit the arg entirely so the BE default
      // ("updated_on") kicks in.
      dateType:
        leadDateFilterType && leadDateFilterType !== "" ? leadDateType || undefined : undefined,
      opportunityTypeIds:
        !isRestrictedDeepLink && opportunityTypeFilters.length > 0
          ? opportunityTypeFilters.map(Number)
          : undefined,
      opportunityStatusIds:
        !isRestrictedDeepLink && opportunityStatusFilters.length > 0
          ? opportunityStatusFilters.map(Number)
          : undefined,
      opportunitySourceIds:
        !isRestrictedDeepLink && opportunitySourceFilters.length > 0
          ? opportunitySourceFilters.map(Number)
          : undefined,
      prioritySortOrder: leadSort,
      // Skip the active filters only when searching with "All Leads" scope (or
      // when deep-linking to a specific lead via URL). "Within Filtered Lead"
      // keeps the filters applied (skipFilter:false).
      //
      // The deep-link bypass is withheld from users restricted to their own
      // conversations: skipFilter:true tells the BE to ignore every filter,
      // which let a restricted user open ANY lead by editing the URL. With it
      // off, the lead only comes back when it genuinely passes their scope.
      // NOTE: this is a UI-level guard, not access control — the backend must
      // enforce ownership on getLeads for the same reason.
      skipFilter:
        (!isEmpty(search) && searchAllLeads) ||
        (!!(hasLeadIdInUrl && paramLeadId) && !isRestrictedDeepLink),
      ...(!isEmpty(presetLeadFilter) ? { ...presetFilterJson } : {}),
      // Full page, always. Leads applied from Lead Center used to be unshifted
      // into this list, so the page was shrunk to make room for them; they now
      // live only in their own "Pinned from LC" tab (EAI-1800), and shrinking
      // the page for them just dropped rows off All/Pinned.
      pageSize: variables.pageSize,
    },
    onCompleted: res => {
      setApiCheck(false);
      if (paramLeadId && window.location.search.includes("leadId")) {
        window.history.replaceState(null, "", window.location.pathname);
      }
      let newLeadList = res?.getLeads?.data || [];
      let leadCount = res?.getLeads?.count || 0;
      setLeadCount(leadCount);
      // File the unread total under the tab whose scope this request carried:
      // `isPinned` on the variables is what decides it, not which tab is
      // rendered — "Pinned from LC" rides on the unnarrowed All query.
      const scopeTab = variables?.isPinned ? LEAD_TABS.PINNED : LEAD_TABS.ALL;
      setUnreadLeadsCount(prev => ({
        ...prev,
        [scopeTab]: res?.getLeads?.unreadLeadsCount || 0,
      }));
      dispatch(setLeadsRedux(newLeadList.map(item => ({ ...item, messages: [] }))));
      if (res?.getLeads?.count > 0) {
        // TODO: Why is this filter needed? Is it related to the pinned lead functionality?
        // FIXME: Remove this filtering if not needed
        // leadList = leadList.filter(x => +x.id !== +lead?.id);
        if (
          lead?.id &&
          !variables?.search &&
          variables?.source?.length === 0 &&
          variables?.voi?.length === 0
        ) {
          handleLeadDetailProfile(lead?.id);
        } else if (isFirstLeadSet) {
          setSelectedLead(newLeadList[0]);
        } else {
          let leadDetails = selectedLead;
          if (!selectedLead?.id || isEmpty(selectedLead)) {
            if (activeLeadId) {
              setLeadList([...newLeadList]);
              handleLeadDetailProfile(activeLeadId);
              setApiCheck(true);
              return;
            }
            const currentLead = newLeadList.filter(lead => +lead?.id === +activeLeadId);
            // Use newLeadList[0] instead of stale leadList[0] to ensure fresh data is used
            leadDetails = activeLeadId ? currentLead.length > 0 && currentLead[0] : newLeadList[0];
            setSelectedLead({ ...leadDetails, messages: [] });
          }

          page = 1;
          setMessageFilters({
            ...messageFilters,
            leadId: leadDetails?.id,
            lastId: lastLead,
            page: 1,
          });
        }
        if (!activeLeadId) {
          // The currentLocationId can sometimes be "undefined". This happens
          // when a notification that does not have location information is
          // clicked, usually in cases of DeaerTeam leads.
          // eslint-disable-next-line no-lonely-if

          if (
            crmIntegration !== "DT" &&
            !sessionStorage.getItem("currentLocationId")?.includes(",")
          ) {
            const locationId = locationIdslice || sessionStorage.getItem("currentLocationId");
            const filterArr = newLeadList.filter(item => {
              if (+item?.location?.id === +locationId) {
                return item;
              }
              if (item?.leadOpportunities?.length > 0) {
                const locOpps = item?.leadOpportunities.filter(
                  lo => +lo.location?.id === +locationId
                );
                if (locOpps.length > 0) {
                  return item;
                }
              }
            });
            leadCount = (filterArr || []).length;
            if (leadCount > 0) {
              newLeadList = [...filterArr];
              leadCount > res?.getLeads?.count && setLeadCount(leadCount);
            }
          }
        }
        setAddPhoneModalVisible(false);
        closeDialog("addLeadViaPhone");
        // leadList.findIndex(item => item.id===selectedLead.id)
        if (leadSort !== prevSortOrderRef.current) {
          setSelectedLead(newLeadList[0]);
          prevSortOrderRef.current = leadSort;
        }
        if (uniq([...selectedQuickFilters, ...selectedStatus]) !== prevStatusRef) {
          setSelectedLead(newLeadList[0]);
          prevStatusRef.current = uniq([...selectedQuickFilters, ...selectedStatus]);
        }
      } else if (!isUndefined(queryString) && !isEmpty(queryString)) {
        // queryString comes from url path for notifications and is then sent to the popup window
        setAddPhoneModalVisible(true);
        openDialog("addLeadViaPhone", {
          dialogHeader: lang.addPhone,
          phoneNumber: queryString,
          openModal: openAddModal && modal && apiCheck,
          statusList: statusList,
          setModalVisible: setAddPhoneModalVisible,
          variables: variables,
          data: newLeadList,
          sources: sourcesData?.leadSources || [],
          user: user,
          onSetLead: (item, mode, phoneLead = "") => {
            if (phoneLead === "phoneLead") {
              const itemData = { ...item, messages: [] };
              setSelectedLead(itemData);
              // Mark the pulled lead as the active selected lead across redux
              // consumers (e.g. InputArea) so it is fully selected, not just
              // highlighted in the list.
              setSelectedLeadId(item.id);

              page = 1;
              setMessageFilters({
                ...messageFilters,
                leadId: item.id,
                lastId: lastLead,
                page: 1,
              });
              if (mode === "new") {
                if (!Array.isArray(newLeadList) || !Object.isExtensible(newLeadList)) {
                  // Make a shallow copy of leadList if it's an array
                  const tempLeadList = Array.isArray(newLeadList) ? [...newLeadList] : [];
                  tempLeadList.unshift(itemData);
                  // Replace the original leadList with the new, modified copy
                  setLeadList(structuredClone([...tempLeadList]));
                } else {
                  newLeadList.unshift(itemData);
                }
              }
            } else {
              if (selectedLead?.id === item?.id) {
                setAddPhoneModalVisible(false);
                closeDialog("addLeadViaPhone");
                return;
              }

              if (sessionStorage.getItem("currentLocationId") !== item?.location?.id) {
                localStorage.setItem("changedLocationLeadId", item?.id);
                sessionStorage.setItem("currentLocationId", item?.location?.id);
                dispatch(setLocationIdSlice({ locationId: item?.location?.id }));
                closeDialog("addLeadViaPhone");
                return;
              }

              handleLeadDetailProfile(item?.id);
              handleScrollOnMovement();
            }
          },
          onLeadStatus: LeadStatus,
          onLeadOwners: leadOwners,
          onVehicles: vehicles,
          crmIntegration: crmIntegration,
          refetchLeads: refetchLeads,
        });
      }
      if (res?.getLeads?.count === 0 || leadCount === 0) {
        // when the list is empty, clear the UI
        setLeadList([]);
        setLeadCount(0);
        setSelectedLead();
        setSelectedLeadId();
        setSelectedLeadID();
        setMessageFilters({
          ...messageFilters,
          leadId: undefined,
        });
      }

      // Leads applied from Lead Center are rendered by the "Pinned from LC"
      // tab off page state (EAI-1800) — they are NOT merged into this list,
      // which is exactly what `getLeads` returned for the active tab. Merging
      // them put them on top of All *and* of Pinned, where they don't belong.
      //
      // What this branch still owns is the selection: the applied set is the
      // thing the user asked to look at, so the first applied lead stays the
      // open conversation instead of being replaced by the first row of All on
      // every refetch (which is what the generic branch below does).
      if (Array.isArray(lead) && lead.length > 0 && !search && variables.page === 1) {
        setLeadList([...newLeadList]);
        const [firstAppliedLead] = lead;
        if (+firstAppliedLead?.id === +selectedLead?.id) {
          setSelectedLead({ ...firstAppliedLead, ...selectedLead });
          getMessages({
            variables: {
              ...messageFilters,
              leadId: firstAppliedLead.id,
              lastId: lastLead,
              page: 1,
            },
          });
        } else {
          setSelectedLead({ ...firstAppliedLead, messages: [] });
        }
        setSelectedLeadId(firstAppliedLead.id);
      } else if (newLeadList.length > 0) {
        setLeadList([...newLeadList]);
        if (+newLeadList[0].id === +selectedLead?.id) {
          setSelectedLead({ ...newLeadList[0], ...selectedLead });
        } else {
          setSelectedLead({ ...newLeadList[0], messages: [] });
        }
        setSelectedLeadId(newLeadList[0].id);
        // console.log("EngagementActivity -> GET_EXTENSION_LIST_ACTIVITY_CENTER -> after set leads | calling getLeadDetail...");
        getLeadDetail({
          variables: { leadId: newLeadList[0].id },
        });
      }

      setApiCheck(true);
    },
  });

  // Opened via ?leadId= but the server returned no lead. Which placeholder to
  // show depends on WHY we can explain it:
  //  - restricted user  -> their scope is the reason, so say access.
  //  - anyone else      -> we don't know (bad id, deleted, other location), so
  //                        stay neutral instead of claiming a permission issue.
  // "default" keeps the normal "No conversation yet" for an open, empty lead.
  // A search that matched nothing gets its own copy: the list query clears
  // `selectedLead` when the count is 0, so no thread is open and "No
  // conversation yet" would misdescribe it.
  const isListEmpty = !leadsLoading && (leadList || []).length === 0;
  const isDeepLinkEmpty = !!(hasLeadIdInUrl && paramLeadId) && isListEmpty;
  const isSearchEmpty = !isEmpty(search) && isListEmpty;

  let emptyConversationVariant = EMPTY_CONVERSATION_VARIANT.DEFAULT;
  if (isDeepLinkEmpty) {
    emptyConversationVariant = restrictRemoveDefaultFilter
      ? EMPTY_CONVERSATION_VARIANT.NO_ACCESS
      : EMPTY_CONVERSATION_VARIANT.NOT_FOUND;
  } else if (isSearchEmpty) {
    emptyConversationVariant = EMPTY_CONVERSATION_VARIANT.NO_RESULTS;
  }

  const [messageCount, setMessageCount] = useState(0);
  const [getEngagementTemplateText] = useLazyQuery(GET_CONSENT_TEMPLATE, {
    fetchPolicy: "cache-and-network",
    onCompleted: res => {
      setConsentMessage(res.getEngagementTemplateText.content);
      if (
        res.getEngagementTemplateText.statusCode === 200 &&
        res.getEngagementTemplateText.content !== "" &&
        callConsentMessage
      ) {
        onClickHandler(res.getEngagementTemplateText.content, selectedLead, user.id, true);
      }
    },
  });

  const [getCampaignList, { data: respCampaigns }] = useLazyQuery(GET_CAMPAIGN_LIST_FILTERS, {
    fetchPolicy: "cache-and-network",
    variables: {
      locationIds: isAllLocationSelected() ? null : [+sessionStorage.getItem("currentLocationId")],
    },
    onCompleted: () => {
      dispatch(setAllCampaigns({ campaigns: respCampaigns?.getCampaignsList || [] }));
    },
  });

  const [editLeadDetails] = useLazyQuery(EDIT_LEAD, {
    fetchPolicy: "cache-and-network",
    onCompleted: () => {
      setOpenEditPopup(true);
    },
  });

  const [getUsersByCompany] = useLazyQuery(GET_ALL_USERS_ACTIVITY_CENTER, {
    variables: { companyId: user?.company?.id || 0 },
    fetchPolicy: "cache-and-network",
    skip: !user?.company?.id,
    onCompleted: async res => {
      const data = res?.getUsers?.data || [];
      if (data != null && data.length > 0) {
        dispatch(setUserList({ usersList: data || [], companyId: user.company.id }));
        await parseUserList(data, userIdMap, setUserIdMap);
      }
    },
  });

  const [getMessages, { loading, error, data: leadMessagesData, refetch: refetchMessages }] =
    useLazyQuery(GET_MESSAGES_V2, {
      fetchPolicy: "network-only",
      // Only skip if we don't have a valid selectedLead.id
      // Removed leadList length check to fix race condition on slow networks
      skip: !selectedLead?.id,
      variables: {
        ...messageFilters,
        leadId: selectedLead?.id || messageFilters?.leadId || selectedLeadID,
        campaignIds: (messageFilters.campaignIds || []).map(el => parseInt(el)),
        // Opp-type-scoped tab — root opp_type id of the active tab.
        // BE filters messages to those tied to a LeadOpportunity whose
        // root opp_type matches. null ⇒ no filter (legacy companies).
        selectedOppTypeId: selectedOppTypeId || null,
      },
      onError: () => {
        // Release the pagination guard so a failed older-page fetch can be retried.
        isFetchingOlderRef.current = false;
      },
      onCompleted: res => {
        // Older-page fetch has settled; release the re-entry guard.
        isFetchingOlderRef.current = false;
        // Clean sessionStorage only — don't clear state here because:
        // 1. targetMessageId state is needed by MessagesGroup for auto-scroll to the target message
        // 2. targetMessageId state controls "View all messages" button visibility
        // State is cleared later by user clicking "View all messages" (clearTargetMessageId)
        sessionStorage.removeItem("targetMessageId");
        lastLead = res?.messagesV2?.lastId || "";
        filterApplied && setFilterLastId(lastLead);
        const messageData = (res?.messagesV2?.data || []).filter(
          item => item !== undefined && +item?.leadId === +selectedLead?.id
        );

        // Notification-click flow: if a ``targetMessageId`` brought us
        // here, resolve that message's lead-opportunity → root opp_type
        // and switch the active tab to match. Without this step the
        // user clicks a Service notification, lands on the lead, but
        // the default tab is Sales (most-recent opp) and the message
        // isn't visible until they manually switch tabs.
        //
        // MessageV2 only exposes the scalar ``leadOpportunityId`` (BE
        // doesn't return the full row to avoid a per-message DB lookup),
        // so we join against ``selectedLead.leadOpportunities`` — the
        // leadNew query already loaded those with their full
        // opportunityType parent chain.
        try {
          if (targetMessageId) {
            const targetMsg = messageData.find(m => +m?.id === +targetMessageId);
            if (!targetMsg) {
              // The target message isn't in this lead's returned messages at
              // all (deleted, wrong id, or not accessible). There's nothing to
              // scroll to — exit deep-link mode and fall back to the normal
              // bottom view instead of leaving the thread stuck at the top.
              clearTargetMessageId();
              setTimeout(() => scrollToBottom("auto"), 200);
            } else {
              const targetOppId = targetMsg?.leadOpportunityId;
              if (targetOppId) {
                const targetOpp = (selectedLead?.leadOpportunities || []).find(
                  o => +o.id === +targetOppId
                );
                const targetRoot = getRootOppTypeId(targetOpp?.opportunityType);
                if (targetRoot && Number(targetRoot) !== Number(selectedOppTypeId || 0)) {
                  setSelectedOppTypeId(Number(targetRoot));
                }
              }
            }
          }
        } catch (e) {
          // Defensive — never let a tab-resolve failure block the
          // messages render. The user can still switch tabs manually.
        }

        if (isEmpty(messageData)) {
          // CRITICAL FIX: Don't clear existing messages if we already have some loaded
          // This prevents conversation disappearing during race conditions (e.g. a
          // spurious pagination fetch returning empty, or a stale request arriving
          // after lead switch).
          if ((selectedLead?.messages || []).length === 0) {
            updateLeadMessagesRedux(selectedLead.id, []);
            return setSelectedLead({ ...selectedLead, messages: [] });
          }
          return; // Keep existing messages instead of clearing them
        }
        // setMessageCount(messageData.length);
        setMessageCount(res?.messagesV2?.count);
        let zeroIndexMsg;
        let messagePayload = messageData.map(el => {
          const findIndex = (selectedLead?.messages || []).findIndex(s => +s?.id === +el?.id);
          if (findIndex === 0) {
            zeroIndexMsg = el;
            return el;
          }
          if (findIndex === -1 && !isUndefined(el)) {
            return el;
          }
        });
        messagePayload = messagePayload?.filter(obj => obj !== null && obj !== undefined);

        if (filterApplied && messageData.length > 0 && !activeOpp.includes("#")) {
          setGlobalMessageData(prev => [...prev, ...messageData]);
        }
        let messageList;
        if (
          messageData.length > 0 &&
          messagePayload.length > 0 &&
          isEmpty(messageFilters.campaignIds)
        ) {
          if (activeOpp === "#DEFAULTOPPID") {
            messageList =
              (selectedLead?.messages || []).length > 0 ? [...selectedLead?.messages] : [];
            messagePayload.forEach(el => {
              const existingIndex = messageList.findIndex(item => +item.id === +el.id);
              if (existingIndex > -1) {
                messageList[existingIndex] = { ...messageList[existingIndex], ...el };
              } else {
                messageList.push(el);
              }
            });
            const specificMsg = messageList.findIndex(msg => msg?.id === zeroIndexMsg?.id);
            if (specificMsg !== -1) {
              messageList[specificMsg] = { ...zeroIndexMsg };
            }
          } else {
            messageList = [...messageData];
          }
          const leadDetail = {
            ...selectedLead,
            messages: uniqBy(messageList, message => String(message.id)),
          };
          setSelectedLead({ ...leadDetail });
          updateLeadMessagesRedux(leadDetail?.id, leadDetail.messages);
          setChangeState(!changeState);
        } else if (messageData.length > 0 && !isEmpty(messageFilters.campaignIds)) {
          setSelectedLead({ ...selectedLead, messages: [...messageData] });
          updateLeadMessagesRedux(selectedLead?.id, messageData);
          setChangeState(!changeState);
        } else if (page === 1 || (selectedLead?.messages || []).length === 0) {
          // SAFETY FIX: Only clear messages if this is a legitimate empty state
          // (fresh page-1 fetch or lead that has no messages yet). Don't wipe
          // during race conditions where we already have valid messages loaded.
          setSelectedLead({ ...selectedLead, messages: [] });
          updateLeadMessagesRedux(selectedLead?.id, []);
          setChangeState(!changeState);
        }
        // else: keep existing messages to prevent disappearing conversation

        if (messageData.length === 0 && filterApplied) {
          messageList = isMsgScroll ? [] : [...globalMessageData];
          const leadDetail = {
            ...selectedLead,
            messages: uniqBy(messageList, message => String(message.id)),
          };
          setSelectedLead({ ...leadDetail });
          updateLeadMessagesRedux(leadDetail?.id, leadDetail.messages);
          setChangeState(!changeState);
        }

        // Scroll to bottom after messages are loaded (when opportunity filter changes).
        // Always consume the flag, but skip the actual bottom-scroll when a
        // deep-link target message is active — otherwise the auto tab-switch
        // refetch (which sets this flag) would override the scroll-to-target.
        if (shouldScrollOnMessagesLoadRef.current) {
          shouldScrollOnMessagesLoadRef.current = false;
          if (!targetMessageId) {
            setTimeout(() => {
              scrollToBottom("smooth");
            }, 100);
          }
        }
      },
    });

  const [getLeadDetail, { loading: spinner }] = useLazyQuery(GET_LEAD_DETAIL_ACTIVITY_CENTER_V2, {
    fetchPolicy: "network-only",
    variables: { leadId: selectedLead ? +selectedLead?.id : undefined },
    skip: leadList?.length === 0 || !selectedLead?.id,
    onCompleted: data => {
      setTargetLangForCustomer(data?.leadNew?.preferredLanguageCode || "");
      if (data?.leadNew) {
        // Merge in the reducer so it runs against the LATEST Redux state and
        // never touches ``messages``. Previously this spread the closure's
        // ``selectedLead`` (a stale render snapshot whose messages could be
        // empty), wiping the loaded thread after editing phone/email.
        dispatch(mergeLeadDetail(data.leadNew));
      }
    },
    onError: err => {
      console.log("Error in lead query", err);
    },
  });

  const [getConsentTemplate] = useLazyQuery(GET_COMPANY_CONSENT_TEMPLATES, {
    fetchPolicy: "network-only",
    onCompleted: resp => {
      if (resp?.getConsentTemplateMessage?.statusCode === 200) {
        dispatch(
          setConsentTemplateSlice({ consentTemplate: resp?.getConsentTemplateMessage?.content })
        );
        setConsentTemplate(resp?.getConsentTemplateMessage?.content || null);
      }
    },
  });

  const [getCrmLeadStatusData] = useLazyQuery(GET_CRM_LEAD_STATUS, {
    fetchPolicy: "network-only",
    onCompleted: resp => {
      setcrmIntegrationData(resp?.getCrmLeadStatus?.data);
      const leadStatus = (resp?.getCrmLeadStatus?.data || []).map(e => ({
        status: e?.status?.replace(/_/g, " "),
        statusTypeId: e?.statusTypeId,
        type: e.type,
        crmId: e?.id,
      }));
      setstatusList([...leadStatus]);
      dispatch(
        setCrmLeadStatus({
          crmLeadStatus: leadStatus,
          // crmIntegration: resp?.getCrmLeadStatus?.crmIntegrationType,
          crmIntegrationData: resp?.getCrmLeadStatus?.data,
        })
      );
    },
  });

  const [getLeadSources, { data: leadSourcesData }] = useLazyQuery(GET_EXTENSION_LEAD_SOURCES, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      if (res.leadSources && res.leadSources.length > 0) {
        setSourcesData(leadSourcesData);
        dispatch(setLeadSources({ leadSources: res.leadSources }));
      }
    },
  });

  const [getCompanyConsentTemplateEvent] = useLazyQuery(GET_COMPANY_CONSENT, {
    variables: { companyId: user?.company?.id },
    fetchPolicy: "network-only",
    onCompleted: res => {
      // ``getCompanyConsentTemplateEvent`` can be null/undefined when the
      // BE returns errors or partial data — Apollo 3.14 still fires
      // onCompleted in that case. Guard the .map() so we don't throw
      // "Cannot read properties of undefined (reading 'map')".
      const rows = res?.getCompanyConsentTemplateEvent;
      if (!Array.isArray(rows)) return;
      const consentData = rows.map(item => {
        return {
          code: item?.consentTemplateEvent?.code,
          isActive: item?.companyConsentTemplateEvent?.isActive,
          templatetext: item?.companyConsentTemplateEvent?.templateText,
        };
      });
      setConsent(consentData);
      dispatch(setCompanyConsentTemplate({ companyId: user?.company?.id, consents: consentData }));
    },
  });

  const [getAfterMessageText] = useLazyQuery(GET_COMPANY_AFTER_MESSAGE_CONSENT_TEMPLATE, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      dispatch(setAfterMessageText({ afterMessageText: res?.getAfterMessageText }));
      setAfterMessageConsent(res?.getAfterMessageText?.content);
      setonlyFirstMessage(res?.getAfterMessageText?.onlyFirstMessage);
      setisActive(res?.getAfterMessageText?.isActive);
    },
  });

  const [getWebSocketConnection, { data: connectionData, loading: connectionLoading }] =
    useLazyQuery(GET_WEB_CHAT_WIDGET_CONNECTION, {
      onCompleted: res => {
        // ``getWebSocketConnection`` is undefined when the gated link
        // short-circuits this query during a logout flow (returns
        // ``{ data: {} }``). Skip the setter rather than throwing.
        if (!res?.getWebSocketConnection) return;
        setConnection(res.getWebSocketConnection);
      },
    });

  const [createMMS] = useMutation(CREATE_MMS);
  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);
  const [createLead, { loading: createLeadLoader }] = useMutation(CREATE_LEAD);
  const [createMessage, { loading: messageLoader }] = useMutation(CREATE_MESSAGE);
  const [updateTranslationSetting] = useMutation(UPDATE_TRANSLATION_SETTINGS, {
    onCompleted: res => {
      if (res?.modifyTranslationSetting?.statusCode === 200) {
        setSelectedLead({
          ...selectedLead,
          preferredLanguageCode:
            res?.modifyTranslationSetting?.translationSetting?.customerLanguage,
        });
        setTargetLangForCustomer(
          res?.modifyTranslationSetting?.translationSetting?.customerLanguage
        );
        setTargetLangForEmployee(res?.modifyTranslationSetting?.translationSetting?.userLanguage);
        setIsAutoTranslate(
          res?.modifyTranslationSetting?.translationSetting?.isAutomaticTranslation
        );
        setIsIncludeOriginalMessage(
          res?.modifyTranslationSetting?.translationSetting?.isIncludeOriginalMessage
        );
        setIsTranslatePreviewShow(
          res?.modifyTranslationSetting?.translationSetting?.isTranslationPreview
        );
      }
    },
  });
  const [broadCastUpdateUnreadCount] = useMutation(BROADCAST_UNREAD_COUNT);

  const [retryMessageSend] = useMutation(RETRY_MESSAGE_SEND);
  const [translateMessage, { loading: translateMessageLoader }] = useMutation(TRANSLATE_MESSAGE);

  const [updateLeadConsent, { loading: consentLoader }] = useMutation(UPDATE_LEAD_CONSENT, {
    onCompleted: res => {
      if (res?.updateLeadConsentStatus?.ok) {
        const respLead = res?.updateLeadConsentStatus?.lead || {};
        setSelectedLead({
          ...selectedLead,
          textConsentStatus: respLead?.textConsentStatus || "PENDING",
          textConsentDate: respLead?.textConsentDate || dayjs(),
        });
        // console.log("EngagementActivity -> onCompleted mutation updateLeadConsent | calling getLeadDetail...");
        getLeadDetail({
          variables: { leadId: +selectedLead?.id },
          skip: !selectedLead?.id,
        });
      }
    },
  });

  const refetchLeadDetails = async () => {
    if (!isEmpty(selectedLead) && !Array.isArray(selectedLead)) {
      const res = await getLeadDetail({
        variables: { leadId: +selectedLead?.id },
        skip: !selectedLead?.id,
      });
      const leadRes = res?.data?.leadNew || {};
      setSelectedLead({
        ...selectedLead,
        ...leadRes,
        messages: selectedLead && +selectedLead.id === +leadRes?.id ? selectedLead?.messages : [],
      });

      // Sync updated lead data into the lead list (avoids a full refetchLeads network call)
      if (leadRes?.id && leadList?.length) {
        const idx = leadList.findIndex(el => +el.id === +leadRes.id);
        if (idx > -1) {
          const updatedList = structuredClone(leadList);
          updatedList[idx] = { ...updatedList[idx], leadOpportunities: leadRes.leadOpportunities };
          setLeadList(updatedList);
        }
      }
    }
  };
  const [updateLeadConversionStatus, { loading: updateStatusLoading }] = useMutation(
    UPDATE_LEAD_CONVERSATION_STATUS
  );
  const [updateLeadPhone, { loading: updatePhoneLoading }] = useMutation(UPDATE_LEAD_PHONE);
  const [createLeadPhone, { loading: phoneLoading }] = useMutation(CREATE_LEAD_PHONE);
  const [updateLeadEmail, { loading: updateEmailLoading }] = useMutation(UPDATE_LEAD_EMAIL);
  const [createLeadEmail, { loading: createEmailLoading }] = useMutation(CREATE_LEAD_EMAIL);

  const [updateLead] = useMutation(UPDATE_LEAD);

  useEffect(() => {
    updateMobileResponsive();
    window.addEventListener("resize", updateMobileResponsive);
    return () => {
      window.removeEventListener("resize", updateMobileResponsive);
    };
  }, []);

  useEffect(() => {
    if (leadPresetFilter && Object.keys(leadPresetFilter)?.length > 0) {
      setVariables(prev => {
        const newState = { ...prev };
        newState.leadStatusTypes = leadPresetFilter?.leadStatusTypes;
        newState.orderBy = leadPresetFilter?.orderBy;
        newState.orderDirection = leadPresetFilter?.orderDirection;
        newState.source = leadPresetFilter?.source;
        newState.voi = leadPresetFilter?.voi;
        newState.sourceOriginal = [];
        newState.combinedSource = [];
        newState.page = 1;
        newState.pageSize = 25;
        newState.status = uniq([...selectedQuickFilters, ...selectedStatus]);
        newState.campaignIds = reduxCampaignFilters?.length
          ? reduxCampaignFilters
          : campaignFilters || [];
        newState.dsEntityId = entityId;
        newState.dsEventId = eventId;
        newState.leadId = null;
        if (leadPresetFilter?.userTypesOr?.length > 0) {
          newState.userTypesOr = leadPresetFilter.userTypesOr;
        }

        if (leadPresetFilter?.userTypesAnd?.length > 0) {
          newState.userTypesAnd = leadPresetFilter?.userTypesAnd;
        }

        return newState;
      });
      setSearch("");
      setParamLeadId(null);
    }
  }, [leadPresetFilter]);

  useEffect(() => {
    setVariables(prev => {
      const prevIds = (prev?.campaignIds || []).map(Number).sort().join(",");
      const nextIds = (reduxCampaignFilters || []).map(Number).sort().join(",");
      if (prevIds === nextIds) return prev;
      return { ...prev, campaignIds: reduxCampaignFilters || [], page: 1 };
    });
  }, [reduxCampaignFilters]);

  useEffect(() => {
    selectedLead?.leadOpportunities?.length > 0 && setOppDropdown();
    // ``selectedOppTypeId`` added so the dropdown rebuilds when the
    // user flips Sales / Service tabs — list now shows only opps under
    // the active root opp_type.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLead, selectedOppTypeId]);

  // When the tab changes, the currently-pinned opp may now belong to
  // the OTHER tab (e.g., user clicked into a Sales opp then switched
  // to Service). Reset to "All <new-root>" so the thread doesn't stay
  // scoped to an invisible opp. Two state values describe the pinned
  // opp and must be reset together — otherwise the right-rail tabs +
  // message filters reset to "All" but the toolbar chip continues to
  // show the stale opp name (driven by messageOpportunity in Redux):
  //
  //   - ``activeOpp`` (local) drives messageFilters + the dropdown
  //     selection in TopToolbarJsx.
  //   - ``messageOpportunity`` (Redux) drives the toolbar chip label
  //     + the dropdown's ``selectedKeys``.
  //
  // The dropdown click handler dispatches both via separate paths
  // (changeMessageOpportunity + setActiveOpp); this effect must do
  // the same when the tab switch invalidates the pinned opp.
  useEffect(() => {
    if (!selectedOppTypeId) return;
    const pinnedOpp = activeOpp && activeOpp !== "#DEFAULTOPPID" ? activeOpp : null;
    const pinnedMsg =
      messageOpportunity && messageOpportunity !== "#DEFAULTOPPID" ? messageOpportunity : null;
    if (!pinnedOpp && !pinnedMsg) return;
    const leadOpps = selectedLead?.leadOpportunities || [];
    const stillVisible = id =>
      leadOpps.some(opp => +opp.id === +id && oppMatchesTab(opp, selectedOppTypeId));
    if (pinnedOpp && !stillVisible(pinnedOpp)) {
      setActiveOpp("#DEFAULTOPPID");
    }
    if (pinnedMsg && !stillVisible(pinnedMsg)) {
      dispatch(changeMessageOpportunity("#DEFAULTOPPID"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOppTypeId]);

  // Re-fetch messages when the active tab (selectedOppTypeId) changes.
  // ``useLazyQuery`` doesn't auto-refetch on variable change — without this
  // the first messagesV2 fires with selectedOppTypeId=null (before the
  // default-tab useEffect resolves), Apollo caches that response, and
  // every subsequent tab click reads from cache instead of hitting the
  // BE. Skip the initial null pass so we only refetch when an actual
  // tab is selected.
  //
  // Also wipe ``selectedLead.messages`` before refetch. The ``getMessages``
  // onCompleted handler MERGES new responses into existing messages when
  // ``activeOpp === "#DEFAULTOPPID"`` (preserves pagination scrollback).
  // On a tab switch that merge keeps the previous tab's messages around
  // — so the UI shows Service + Sales mixed. Clearing first forces the
  // handler down its "no existing messages" path → new response replaces
  // cleanly.
  const prevOppTypeIdRef = React.useRef(null);
  const prevOppTypeLeadIdRef = React.useRef(null);
  // Tracks the messageOpportunity (specific-opp pin) we last handled, so the
  // atomic opp/tab effect below can fire when the user picks a specific
  // opportunity — not only when the root tab changes.
  const prevMessageOppRef = React.useRef(null);
  // Set to true when the opp-type-refetch effect fires a getMessages
  // call atomically; ``fetchLeadData`` checks (and clears) this flag
  // on its next run so the setMessageFilters that runs alongside the
  // atomic fetch doesn't cascade into a second identical messagesV2.
  const skipNextLeadDataFetchRef = React.useRef(false);
  // The lead id we last triggered a message fetch for. Used to detect a real
  // lead change synchronously instead of comparing ``selectedLead.id`` against
  // the async ``selectedLeadID`` state, which can desync under React batching
  // (after pagination this occasionally let a lead switch fetch nothing).
  const lastFetchedLeadIdRef = React.useRef();
  useEffect(() => {
    if (!selectedLead?.id) return;
    // Note: selectedOppTypeId may be null here (e.g. "All opportunities"
    // selected, which clears root-tab scoping) — that's a valid state
    // this effect must still handle, not an unresolved/loading state to
    // bail out on. The sameLead/tabChanged/oppChanged checks below
    // correctly detect a transition into or out of that null state via
    // messageOpportunity (which always changes alongside it).
    // The effect runs on both ``selectedOppTypeId`` AND ``selectedLead?.id``
    // changes. When the lead itself changes, the ``fetchLeadData`` effect
    // (lines below) already fires messagesV2 — letting this branch fire
    // again causes a duplicate request with identical variables. Track
    // the lead id we've seen alongside the opp-type id, and only act
    // when the opp-type genuinely changed for the SAME lead. Lead
    // switches reset the refs and exit; the other effect takes over.
    const sameLead = prevOppTypeLeadIdRef.current === selectedLead.id;
    if (!sameLead) {
      prevOppTypeLeadIdRef.current = selectedLead.id;
      prevOppTypeIdRef.current = selectedOppTypeId;
      prevMessageOppRef.current = messageOpportunity;
      return;
    }
    const tabChanged =
      prevOppTypeIdRef.current != null && prevOppTypeIdRef.current !== selectedOppTypeId;
    // A specific-opportunity pick changes messageOpportunity without
    // necessarily changing the root tab, so detect it here too.
    const oppChanged = prevMessageOppRef.current !== messageOpportunity;
    prevOppTypeIdRef.current = selectedOppTypeId;
    prevMessageOppRef.current = messageOpportunity;
    if (!tabChanged && !oppChanged) return;
    // Tab switch on the same lead = fresh conversation context.
    //  - Wipe selectedLead.messages so the getMessages onCompleted
    //    handler goes down its "no existing messages" replace path
    //    instead of merging the previous tab's messages.
    //  - Reset pagination to page=1 / lastId="". ``messageFilters``
    //    carries the scrollback page from the prior tab; without
    //    this reset the first post-switch fetch would request page
    //    2+ and miss the newest messages of the new tab.
    if ((selectedLead?.messages || []).length > 0) {
      const cleared = { ...selectedLead, messages: [] };
      setSelectedLead(cleared);
      updateLeadMessagesRedux(cleared.id, []);
    }
    // Send the CURRENTLY selected opportunity. ``messageOpportunity`` is a
    // dependency of this effect, so when the user picks a specific opp from
    // the dropdown this effect re-runs with the fresh value — no longer the
    // stale-read problem that previously forced us to hardcode ``null`` here.
    //  - "All <root>" pins set messageOpportunity = "#DEFAULTOPPID" -> null
    //    (root-only scope, BE filters by selectedOppTypeId).
    //  - A specific opp pick -> that opp's id, so the FIRST messagesV2 fetch
    //    already carries leadOpportunityId (previously it leaked in only on
    //    the next fetch / pagination, showing the wrong scope at first).
    //  - "All opportunity" (ALL_OPPORTUNITY_TYPES_ID) clears BOTH
    //    leadOpportunityId and selectedOppTypeId — no scoping at all.
    const isAllOpportunity = messageOpportunity === ALL_OPPORTUNITY_TYPES_ID;
    const nextLeadOpportunityId =
      messageOpportunity && messageOpportunity !== "#DEFAULTOPPID" && !isAllOpportunity
        ? +messageOpportunity
        : null;
    const resetFilters = {
      ...messageFilters,
      page: 1,
      lastId: "",
      leadOpportunityId: nextLeadOpportunityId,
    };
    // Signal fetchLeadData to skip the next messagesV2 call: the
    // setMessageFilters below will trigger its [messageFilters] effect,
    // and its isFilterChange branch would otherwise fire an identical
    // duplicate of the getMessages call we're about to make atomically.
    skipNextLeadDataFetchRef.current = true;
    // A tab change is a fresh conversation scope — auto-scroll to
    // bottom after the new messagesV2 batch lands so the user sees
    // the newest messages even if they were scrolled up reading
    // history on the prior tab. The flag is consumed (and unset)
    // inside getMessages.onCompleted. Pagination-driven fetches
    // (scroll-up "load more") never set this flag, so they don't
    // hijack the scroll position.
    shouldScrollOnMessagesLoadRef.current = true;
    setMessageFilters(resetFilters);
    // Fire fetch directly with the reset filters — don't wait for
    // the state update round-trip (which would race with the next
    // render's effect chain).
    getMessages({
      variables: {
        ...resetFilters,
        leadId: selectedLead.id,
        campaignIds: (resetFilters.campaignIds || []).map(el => parseInt(el)),
        selectedOppTypeId: isAllOpportunity ? null : selectedOppTypeId || null,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOppTypeId, messageOpportunity, selectedLead?.id]);

  useEffect(() => {
    socketMsgSelectedLead && handleToasterSelectedLead();
  }, [socketMsgSelectedLead]);

  useEffect(() => {
    const oppName = opportunityList.find(opp => opp.id.toString() === activeOpp.toString());
    setActiveOppName(oppName);
    if (oppName?.id && oppName?.id[0] !== "#") {
      setMessageFilters({
        ...messageFilters,
        leadOpportunityId: +oppName?.id,
        page: 1,
        lastId: filterLastId,
      });
      setFilterApplied(true);
    } else {
      const dummyMsgFilters = {
        ...messageFilters,
        page: 1,
        lastId: filterLastId,
      };
      delete dummyMsgFilters.leadOpportunityId;
      setFilterApplied(true);
      setMessageFilters({ ...dummyMsgFilters });
    }
  }, [activeOpp]);

  useEffect(() => {
    setActiveLeadId(localStorage.getItem("changedLocationLeadId"));
  }, [locaitonLocalId]);

  useEffect(() => {
    setSelectedLead({ ...selectedLead, messages: [] });
    setMessageFilters({
      ...messageFilters,
      leadOpportunityId:
        messageOpportunity === "#DEFAULTOPPID" || messageOpportunity === ALL_OPPORTUNITY_TYPES_ID
          ? null
          : messageOpportunity,
      page: 1,
    });
    // Flag to scroll to bottom after messages are loaded
    shouldScrollOnMessagesLoadRef.current = true;
  }, [messageOpportunity]);

  useEffect(() => {
    localStorage.setItem("fullscreen", fullScreen);
  }, [fullScreen]);

  useEffect(() => {
    if (
      Object.entries(userListReduxData.users).length &&
      +user?.company?.id === +userListReduxData?.companyId
    ) {
      setUserIdMap({ ...userListReduxData.users });
    } else if (
      !Object.entries(userListReduxData.users).length &&
      user?.company?.id &&
      user?.company?.id !== userListReduxData?.companyId
    ) {
      // getAllUsers();
    }

    if (+companyConsentReduxData?.companyId !== +user?.company?.id && user?.company?.id) {
      getCompanyConsentTemplateEvent();
    } else if (
      +companyConsentReduxData?.companyId === +user?.company?.id &&
      companyConsentReduxData?.consents?.length
    ) {
      setConsent(companyConsentReduxData.consents);
    }

    if (allCampaignsReduxData?.length === 0) {
      getCampaignList();
    }
  }, [user?.company?.id, companyConsentReduxData, userListReduxData, allCampaignsReduxData]);

  useEffect(() => {
    getAfterMessageText();
  }, []);

  useEffect(() => {
    if (locationIdslice) {
      // When the page loads with ?leadId=...&loc=..., layout.js dispatches setLocationIdSlice
      // which fires this effect while the leadId query is already in-flight.
      // setVariables here changes dsEntityId (undefined→"") which Apollo treats as new variables → second fetch.
      // Skip the reset exactly once on that initial loc-param-driven location change.
      if (window.location.search.includes("leadId") && !hasSkippedInitialLocEffectRef.current) {
        hasSkippedInitialLocEffectRef.current = true;
        return;
      }
      setSearchKey(location?.split("/")[3] || "");
      setSelectedLead({});
      setSelectedLeadId();
      setSelectedLeadID();
      setLeadList([]);
      setLeadIdClick("");
      localStorage.removeItem("clickLeadId");
      setIsClickonPotentialDuplicate("");
      // Same value as before — only the write is skipped when it would be a
      // no-op. Writing an identical object still handed `useQuery` a new
      // `variables` identity, and that alone re-ran getLeads on every location
      // change. Returning `prev` when nothing actually differs drops that
      // duplicate request without changing what the variables end up as.
      setVariables(prev => {
        const next = {
          ...variables,
          leadId: null,
          page: 1,
          dsEventId: "",
          dsEntityId: "",
          campaignIds: [],
        };
        return isEqual(prev, next) ? prev : next;
      });
      setSearch(location?.split("/")[3] || "");
      setEventId("");
      setEntityId("");
      dispatch(setCampaignFilters([]));
      dispatch(setUserFilters([]));
    }
  }, [locationIdslice]);

  useEffect(() => {
    if (!leadSourcesReduxData.length) {
      getLeadSources();
    } else {
      setSourcesData(leadSourcesReduxData);
    }
    if (!crmLeadStatusReduxData.crmLeadStatus.length) {
      getCrmLeadStatusData();
    } else {
      setstatusList(crmLeadStatusReduxData.crmLeadStatus);
      setcrmIntegrationData(crmLeadStatusReduxData.crmIntegrationData);
    }
  }, [leadSourcesReduxData, crmLeadStatusReduxData]);

  useEffect(() => {
    if (isEmpty(consentTemplateFromRedux)) {
      getConsentTemplate();
    } else {
      setConsentTemplate(consentTemplateFromRedux);
    }
  }, [consentTemplateFromRedux]);

  // Auto-scroll only when new messages are added (not on metadata changes like note count)
  useEffect(() => {
    // Skip while a deep-link target message is active: the bottom-scroll would
    // race/override useScrollToMessage (esp. after the auto tab-switch wipes and
    // refetches), leaving the view at the bottom instead of the target message.
    if (targetMessageId) return;
    if ((selectedLead?.messages || []).length > 0 && page === 1) {
      // Use longer timeout to ensure DOM has fully rendered before scrolling
      setTimeout(() => {
        scrollToBottom("auto");
      }, 200);
    }
  }, [selectedLead?.messages?.length]);

  // Handle unread count clearing and language setting when selectedLead changes
  useEffect(() => {
    if (selectedLead?.unreadCount) {
      // Tell the server the lead was read. The list update below is cosmetic —
      // it only touches local state, so `getLeads` kept returning the old
      // unread_count and any refetch (page refresh, tab switch) brought the
      // badge back. updateUnreadCount was previously only called from the
      // socket handler, and only for a message arriving while the lead was
      // ALREADY open, so simply opening a lead with existing unread never
      // reached the server.
      const isFirstReadReport = reportedReadLeadRef.current !== selectedLead?.id;
      if (isFirstReadReport) {
        reportedReadLeadRef.current = selectedLead?.id;
        const readLeadId = selectedLead?.id;
        broadCastUpdateUnreadCount({ variables: { leadId: +readLeadId } })
          .then(res => applyLeadUnreadCount(readLeadId, res?.data?.updateUnreadCount?.unreadCount))
          .catch(err => {
            console.error("updateUnreadCount failed:", err);
          });
      }

      // Optimistic: show the row as read now and move the All/Pinned badge with
      // it, rather than waiting on the response. Idempotent — re-selecting an
      // already-read lead finds the row at 0 and changes nothing, so the badge
      // can't decrement twice, and the server's own `update_count` echo lands
      // on a row that already reads 0.
      applyLeadUnreadCount(selectedLead?.id, 0);
    }
    setTargetLangForCustomer(selectedLead?.preferredLanguageCode);
  }, [selectedLead]);

  const fetchMessages = () => {
    // Use selectedLead?.id directly - don't block on leadList length
    // This fixes race condition on slow networks where leadList may still be empty
    const leadIdToFetch = selectedLead?.id || selectedLeadID || messageFilters?.leadId;
    if (!leadIdToFetch) return; // Guard: don't fetch without a valid leadId

    // Read sessionStorage as fallback — handles race condition where fetchMessages fires
    // (from lead-change useEffect) before the targetMessageId useEffect updates state
    const effectiveTargetMessageId = targetMessageId || sessionStorage.getItem("targetMessageId");

    // Drop ``leadOpportunityId`` from the outgoing variables when the
    // pinned opp doesn't belong to the active tab. ``messageFilters``
    // is updated by a separate ``[activeOpp]`` effect that can lag a
    // tab switch by one render — so spreading it raw would send the
    // PRIOR tab's opp id alongside the new ``selectedOppTypeId`` on
    // the wire. The BE applies leadOpportunityId as a stronger filter
    // than selectedOppTypeId, so a mismatched pair returns the wrong
    // tab's messages until the user manually re-picks "All".
    const pinnedOppId = messageFilters?.leadOpportunityId;
    const leadOpps = selectedLead?.leadOpportunities || [];
    const pinnedOppMatchesTab =
      pinnedOppId &&
      leadOpps.some(opp => +opp?.id === +pinnedOppId && oppMatchesTab(opp, selectedOppTypeId));
    const variables = {
      ...messageFilters,
      leadId: leadIdToFetch,
      campaignIds: (messageFilters.campaignIds || []).map(el => parseInt(el)),
      // When set, API returns all messages up to that ID (not just page size)
      // This enables auto-scroll to a specific message from notification click
      [QUERY_VAR_TARGET_MESSAGE_ID]: effectiveTargetMessageId,
      // Active opp-type tab — BE filters messages_v2 by root opp_type
      // so a Sales tab doesn't show Service messages on first render.
      // (Pre-fix: the messages query fired without this, the BE
      // returned all messages, and only the FE's post-render filter
      // narrowed it down — leaking other-tab messages briefly.)
      //
      // Deep-link exception: when navigating to a specific message
      // (effectiveTargetMessageId), do NOT scope by the active tab. The
      // target may live on a different opp tab (common for merged leads),
      // and the BE would otherwise filter it out entirely — leaving
      // nothing to scroll to. Fetch its window unscoped; onCompleted then
      // resolves the message's opp and switches to the correct tab.
      selectedOppTypeId: effectiveTargetMessageId ? null : selectedOppTypeId || null,
    };
    if (!pinnedOppMatchesTab || effectiveTargetMessageId) variables.leadOpportunityId = null;
    getMessages({ variables });
  };
  const fetchLeadData = () => {
    // Allow fetching if selectedLead.id exists OR leadList has items
    // This fixes race condition where selectedLead is set before leadList is populated
    if (leadList?.length > 0 || selectedLead?.id) {
      // Check if this is a lead change (not just pagination). Compare against
      // the lead we LAST FETCHED for (a ref updated synchronously below) rather
      // than the async ``selectedLeadID`` state, which can already equal the
      // new lead by the time this runs and let a post-pagination lead switch
      // fall through every branch and fetch nothing.
      const currentLeadId = +(selectedLead?.id || selectedLeadID);
      const isLeadChange =
        Number.isFinite(currentLeadId) && lastFetchedLeadIdRef.current !== currentLeadId;
      const isInitialLoad = isEmpty(prevStateData);

      // Check if messageFilters changed for reasons OTHER than pagination
      // Page changes should ONLY trigger fetchMessages, not getLeadDetail/etc
      const isFilterChange =
        prevStateData &&
        prevStateData.messageFilters !== messageFilters &&
        prevStateData.messageFilters?.page === messageFilters?.page; // Same page = filter changed

      if (isLeadChange || isInitialLoad || isFilterChange) {
        setSelectedLeadID(selectedLead?.id);
        // Skip the messagesV2 dispatch when the opp-type-refetch effect
        // just fired an atomic getMessages call FOR THIS SAME LEAD; the
        // setMessageFilters that ran alongside it would otherwise cascade
        // us into a duplicate request here. Never honor the flag on a
        // genuine lead change though — it only guards against a same-lead
        // tab/opp switch's duplicate fetch, and a stale `true` left over
        // from a tab switch that fired just before the user picked a
        // different lead must not swallow that lead's real messagesV2
        // call. The flag is one-shot — always cleared here regardless of
        // outcome — so the next filter change (search/campaign/etc.)
        // still fetches normally.
        const shouldSkipDuplicateFetch = skipNextLeadDataFetchRef.current && !isLeadChange;
        skipNextLeadDataFetchRef.current = false;
        if (!shouldSkipDuplicateFetch) {
          fetchMessages();
        }

        // Only call these APIs if lead actually changed or it's initial load
        // NOT on pagination (scroll up)
        if (isLeadChange || isInitialLoad) {
          // Record synchronously so repeat runs for the same lead (e.g. an opp
          // filter change) don't re-fire lead-level queries, and the next real
          // lead switch is detected reliably regardless of state batching.
          if (Number.isFinite(currentLeadId)) lastFetchedLeadIdRef.current = currentLeadId;
          getLeadDetail({
            variables: { leadId: +selectedLead?.id || selectedLeadID },
          });
          getWebSocketConnection({
            variables: {
              leadId: selectedLead?.id,
            },
          });

          if (canViewTranslation) {
            getTranslationSettings({ variables: { leadId: selectedLead?.id } });
          }
        }
      } else if (prevStateData && prevStateData.messageFilters?.page !== messageFilters?.page) {
        // Page changed (scroll up/down) - ONLY fetch messages
        fetchMessages();
      }
    }
  };

  // useEffect ensures side effects run reliably on every dependency change
  // (useMemo may be skipped by React for performance optimization)
  useEffect(() => {
    if (!isUndefined(selectedLead?.id)) {
      fetchLeadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLead?.id, messageFilters]);

  useEffect(() => {
    if (reviewInfo && reviewInfo.isActive) {
      setShowReviewRequestButton(true);
    } else {
      setShowReviewRequestButton(false);
    }
  }, [reviewInfo]);

  const updateLeftLeadList = async lead => {
    let updatedLead = { ...lead };
    const newList = structuredClone(leadList);
    // console.log("TEST LEAD NOT IN FOUND CASE refresh updatedLead===>", updatedLead);
    if (!isUndefined(updatedLead?.id)) {
      const notificationMessage = (notificationData?.lead_messages || []).find(
        el => +el.lead_id === +updatedLead.id
      );
      if (notificationMessage) {
        updatedLead = {
          ...updatedLead,
          messages: [
            {
              id: notificationMessage?.id,
              content: notificationMessage?.content || "",
              dateReceived: notificationMessage?.date_received,
              dateSent: notificationMessage?.date_sent,
              direction: notificationMessage?.direction,
            },
          ],
        };
      }
      if (notificationData?.active_appointment) {
        updatedLead = {
          ...updatedLead,
          activeAppointment: {
            id: notificationData?.active_appointment?.id,
            startDatetime: notificationData?.active_appointment?.start_datetime,
            isConfirmed: notificationData?.active_appointment?.is_confirmed,
            appointmentStatus: notificationData?.active_appointment?.appointment_status,
            summary: notificationData?.active_appointment?.summary || "",
            description: notificationData?.active_appointment?.description || "",
          },
        };
      }
      // console.log("TEST LEAD NOT IN FOUND CASE newList===>", newList);
      newList.unshift(updatedLead);
      if (newList.length > variables.pageSize) {
        newList.splice(newList.length - 1, 1);
      }
      setLeadList(newList);
    }
  };

  useEffect(() => {
    if (notificationData) {
      // console.log("TEST notificationData useEffect notificationData===>", notificationData);
      const prevValue = text?.current?.value || "";
      const isNotificationLeadExistInLocation = checkLocation(notificationData?.location_id);
      // console.log(
      //   "TEST notificationData isNotificationLeadExistInLocation===>",
      //   isNotificationLeadExistInLocation
      // );
      if (!isNotificationLeadExistInLocation) {
        return;
      }
      if (notificationData.refresh) {
        // console.log(
        //   "TEST refresh notificationData?.user_id === +user?.id===>",
        //   notificationData?.user_id === +user?.id
        // );
        if (notificationData?.lead_id) {
          // console.log("TEST refresh INNN===>");
          const newList = structuredClone(leadList);
          const findIndex = newList.findIndex(el => +el.id === +notificationData?.lead_id);
          // console.log("TEST refresh INNN findIndex===>", findIndex);
          if (findIndex > -1) {
            let existingLead = { ...newList[findIndex] };
            const notificationMessage = (notificationData?.lead_messages || []).find(
              el => +el.lead_id === +existingLead.id
            );
            const unReadCount = existingLead?.unreadCount || 0;
            existingLead = {
              ...existingLead,
              unreadCount: unReadCount + 1,
              messages: [
                {
                  id: notificationMessage?.id,
                  content: notificationMessage?.content || "",
                  dateReceived: notificationMessage?.date_received,
                  dateSent: notificationMessage?.date_sent,
                  direction: notificationMessage?.direction,
                },
              ],
            };
            if (notificationData?.active_appointment) {
              existingLead = {
                ...existingLead,
                activeAppointment: {
                  id: notificationData?.active_appointment?.id,
                  startDatetime: notificationData?.active_appointment?.start_datetime,
                  isConfirmed: notificationData?.active_appointment?.is_confirmed,
                  appointmentStatus: notificationData?.active_appointment?.appointment_status,
                  summary: notificationData?.active_appointment?.summary || "",
                  description: notificationData?.active_appointment?.description || "",
                },
              };
            }
            if (
              +notificationData?.lead_id === +selectedLead?.id &&
              +notificationData?.user_id === +user?.id
            ) {
              // console.log("TEST refresh unreadCount ===>", existingLead);
              existingLead = {
                ...existingLead,
                unreadCount: 0,
              };
            }
            // Badge bookkeeping goes here, not next to `unReadCount + 1`
            // above: the "message for the lead I already have open" branch
            // re-zeroes the row afterwards, so only the settled value says
            // whether this lead joined the unread set. Only the 0 -> unread
            // crossing adds a LEAD; a second unread message on an
            // already-unread lead does not.
            if (unReadCount === 0 && (existingLead?.unreadCount || 0) > 0) {
              adjustUnreadLeadsCount(existingLead?.id, 1);
            }
            newList.splice(findIndex, 1);
            newList.unshift(existingLead);
            // console.log("TEST refresh Final existingLead ===>", existingLead);
            // console.log("TEST refresh Final newList ===>", newList);
            setLeadList(newList);
          } else {
            // Only lock here — this is the only branch that does an async
            // fetch, so the flag only needs to be true during this window.
            setRefetching(true);
            // console.log("TEST refreshLeadList API call ===============>");
            refreshLeadList({
              variables: {
                ...variables,
                search: !isEmpty(search) ? search.trim() : "",
                status: isEmpty(search) ? uniq([...selectedQuickFilters, ...selectedStatus]) : [],
                campaignIds:
                  isEmpty(search) && !isEmpty(variables?.campaignIds)
                    ? variables?.campaignIds?.map(el => parseInt(el))
                    : [],
                excludeDuplicate: true,
                userIds: isEmpty(search) && !isEmpty(userFilters) ? [...userFilters] : [],
                opportunityTypeIds:
                  opportunityTypeFilters.length > 0
                    ? opportunityTypeFilters.map(Number)
                    : undefined,
                opportunityStatusIds:
                  opportunityStatusFilters.length > 0
                    ? opportunityStatusFilters.map(Number)
                    : undefined,
                opportunitySourceIds:
                  opportunitySourceFilters.length > 0
                    ? opportunitySourceFilters.map(Number)
                    : undefined,
                prioritySortOrder: leadSort,
                skipFilter: !isEmpty(search) && searchAllLeads,
                leadId: notificationData?.lead_id,
              },
            })
              .then(res => {
                // console.log("refreshLeadList Resp ===============>", res);
                const getLeadsData = res?.getLeads?.data || res?.data?.getLeads?.data || [];
                // console.log("refreshLeadList getLeadsData ===============>", getLeadsData);
                if (getLeadsData.length > 0) {
                  updateLeftLeadList(getLeadsData[0]);
                }
              })
              .catch(err => {
                console.error("refreshLeadList failed:", err);
              })
              .finally(() => {
                setRefetching(false);
              });
          }
        }
      }

      if (+notificationData?.lead_id === +selectedLead?.id) {
        const readLeadId = selectedLead?.id;
        broadCastUpdateUnreadCount({
          variables: {
            leadId: readLeadId,
          },
        })
          .then(res => applyLeadUnreadCount(readLeadId, res?.data?.updateUnreadCount?.unreadCount))
          .catch(err => {
            console.error("updateUnreadCount failed:", err);
          });
      }

      // Helper function to transform notification to message object
      const transformNotificationToMessage = (notification, options = {}) => {
        const { messageLogAsArray = false, userOverride = null } = options;

        const messageLogData = {
          id: notification?.message_log?.id,
          messageId: notification?.message_log?.message_id,
          toPhone: notification?.message_log?.to_phone,
          fromPhone: notification?.message_log?.from_phone,
        };

        const userData =
          userOverride ||
          (notification?.user
            ? {
                firstName: notification?.user?.first_name,
                lastName: notification?.user?.last_name,
                fullName: notification?.user?.full_name,
                profilePic: notification?.user?.profile_pic,
              }
            : undefined);

        return {
          id: `${notification?.id}`,
          campaignId: notification?.campaign_id,
          content: notification?.content,
          translatedContent: notification?.translated_content,
          dateReceived: notification?.date_received,
          dateSent: notification?.date_sent,
          direction: notification?.direction,
          leadId: notification?.lead_id,
          userId: notification?.user_id,
          ...(userData && { user: userData }),
          systemUserId: notification?.system_user_id,
          messageType: notification?.message_type || "",
          messageStatus: notification?.message_status || "",
          statusCode: notification?.status_code || "",
          errorCode: notification?.error_code || "",
          errorMessage: notification?.error_message || "",
          messageLog: messageLogAsArray ? [messageLogData] : messageLogData,
          mmsObjects: (notification?.mms_objects || [])?.map(item => ({
            id: item.id,
            mediaType: item?.media_type,
            mediaUrl: item?.media_url || item?.url,
            thumbnailUrl:
              item?.thumbnail && !isEmpty(item?.thumbnail)
                ? item.thumbnail
                : item?.media_url || item?.url,
            size: item.size,
          })),
          leadOpportunity: { ...notification?.lead_opportunity },
          contentType: notification?.content_type,
          email: notification.email,
        };
      };

      // Update selected lead with all notification messages
      if (+notificationData?.lead_id === +selectedLead?.id) {
        const notificationMessages = notificationData?.lead_messages || [];
        console.log("🚀 ~ useEffect ~ notificationMessages:", notificationMessages);

        if (notificationMessages.length > 0) {
          const newMessages = [];

          notificationMessages.forEach(notification => {
            if (HIDDEN_MESSAGE_CONTENT_TYPES.includes(notification?.content_type)) {
              return;
            }

            // Opp-type-scoped tab filter: skip messages whose
            // ``lead_opportunity.opportunity_type`` root doesn't match
            // the active tab. Without this, a Service-tab user opens
            // a Sales lead and an incoming Service message would
            // still APPEND to the visible (Sales-scoped) timeline —
            // exactly the leak QA reported. Also bumps the off-tab
            // unread counter so the user sees the red dot. Messages
            // with no opp (legacy / consent / system) skip the gate
            // and stay visible across tabs.
            //
            // Socket payloads use snake_case (``parent_type``,
            // ``parent_type_id``) — distinct from GraphQL camelCase
            // — so walk both keys defensively up to 5 hops.
            const walkToRoot = ot => {
              let cursor = ot;
              for (let i = 0; i < 5; i += 1) {
                if (!cursor) return null;
                const parent = cursor.parent_type || cursor.parentType;
                const parentId = cursor.parent_type_id || cursor.parentTypeId;
                if (parent && parent.id) {
                  cursor = parent;
                } else if (parentId) {
                  return Number(parentId);
                } else {
                  return Number(cursor.id);
                }
              }
              return cursor && cursor.id ? Number(cursor.id) : null;
            };
            const notifOppType = notification?.lead_opportunity?.opportunity_type;
            const notifRoot = notifOppType ? walkToRoot(notifOppType) : null;
            if (selectedOppTypeId && notifRoot && Number(notifRoot) !== Number(selectedOppTypeId)) {
              setUnreadByRoot(prev => ({
                ...prev,
                [Number(notifRoot)]: (prev[Number(notifRoot)] || 0) + 1,
              }));
              return;
            }

            const messageExists = (selectedLead?.messages || []).some(
              msg => +msg?.id === +notification?.id
            );

            if (!messageExists) {
              const newMessage = transformNotificationToMessage(notification, {
                messageLogAsArray: true,
              });
              newMessages.push(newMessage);
            }
          });

          if (newMessages.length > 0) {
            // console.log(
            //   "🚀 ~ useEffect ~ newMessages:===============================>>>>>",
            //   newMessages
            // );

            const newObj = {
              ...selectedLead,
              messages: [...(selectedLead?.messages || []), ...newMessages],
              ...(notificationData?.text_consent_status
                ? { textConsentStatus: notificationData?.text_consent_status }
                : {}),
            };

            if (!selectedLead?.textConsentStatus) {
              getLeadDetail({ variables: { leadId: selectedLead?.id } });
            }

            // console.log("🚀 ~ useEffect ~ newObj:===============================>>>>>", newObj);
            setSelectedLead(newObj);
            updateLeadMessagesRedux(selectedLead?.id, newObj.messages);

            if (text?.current) {
              setTimeout(() => {
                text.current.value = prevValue;
                text.current.focus();
                text.current.style.height = "inherit";
                text.current.style.height = `${text.current.scrollHeight}px`;
              }, 50);
            }
          }
        }
      }

      // Push to Leads list in Redux
      if (notificationData?.lead_messages?.length > 0) {
        notificationData.lead_messages.forEach(notification => {
          const newMessage = transformNotificationToMessage(notification, {
            userOverride: {
              id: user?.id,
              firstName: user?.firstName,
              lastName: user?.lastName,
            },
          });
          dispatch(addMessage({ id: newMessage.leadId, messages: newMessage }));
        });
      }
    }
  }, [notificationData]);
  useEffect(() => {
    if (
      !isUndefined(queryString) &&
      searchKey !== "" &&
      searchKey !== "remove" &&
      searchKey &&
      search !== searchKey
    ) {
      handleSearch(searchKey);
    }
    setSummaryVisible({ visible: false, count: 0 });
  }, [searchKey]);

  const handleSocketMessage = async event => {
    const event_data_obj = JSON.parse(event.data);
    if (event_data_obj.event_name === "message_send_status") {
      const event_data = event_data_obj.data;
      let selectedLeadDetail = {
        ...selectedLead,
        textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
      };
      if ((selectedLead?.messages || []).length <= 0) {
        selectedLeadDetail = { ...selectedLeadDetail, messages: [] };
      }
      const messagePayload = {
        leadId: +lead?.id,
        userId: event_data.lead_message.user_id,
        direction: "TO_LEAD",
        content: event_data.message,
      };
      selectedLeadDetail.messages.push({
        ...messagePayload,
        type: "new",
      });
      if (selectedLeadDetail?.leadSource?.name === "Web Chat Widget") {
        const leadDetails = { ...selectedLeadDetail };
        const findIndex = leadDetails.messages.findIndex(el => el?.type === "new");
        if (findIndex > -1) {
          leadDetails.messages[findIndex].type = "";
          leadDetails.messages[findIndex].id = event_data.lead_message?.id;
          leadDetails.messages[findIndex].dateSent = event_data.lead_message?.date_sent;
          leadDetails.messages[findIndex].messageStatus = event_data.lead_message?.message_status;
          leadDetails.messages[findIndex].messageType = event_data.lead_message?.message_type;
          leadDetails.messages[findIndex].errorMessage = event_data.lead_message?.error_message;
          leadDetails.messages[findIndex].errorCode = event_data.lead_message?.error_code;
          leadDetails.messages[findIndex].leadOpportunity = event_data.lead_message
            ?.leadOpportunity ||
            event_data.lead_message?.lead_opportunity || { name: "", id: "" };
        }
        setSelectedLead({ ...leadDetails });

        setChangeState(!changeState);
        setbtnClicked(true);
      }
    }
  };

  useEffect(() => {
    if (socket) {
      // Add the event listener
      socket.addEventListener("message", handleSocketMessage);

      // Clean up function to remove the event listener.
      // This prevents multiple event listeners from being added every time the component re-renders.
      return () => {
        socket.removeEventListener("message", handleSocketMessage);
      };
    }
  }, [socket, lead, selectedLead, changeState]);

  // Phase 3a: when the SocketIO ``sent_message`` event arrives carrying the
  // persisted Message produced by the messaging_service lambda, update the
  // currently-displayed lead's message list directly. ``replaceQueuedMessage``
  // updates Redux but EngagementActivity holds the timeline in component
  // state (``selectedLead.messages``); we have to merge here too.
  // Phase 3a: keep selectedLead in a ref so the SocketIO handler can match
  // against the LATEST selected lead (not the stale closure value).
  const phase3aSelectedLeadRef = useRef(selectedLead);
  useEffect(() => {
    phase3aSelectedLeadRef.current = selectedLead;
  }, [selectedLead]);

  useEffect(() => {
    if (!socket || typeof socket.on !== "function") return;
    const onSentMessage = data => {
      const liveSelectedLead = phase3aSelectedLeadRef.current;
      try {
        const payloadLeadId = data?.lead_id;
        const persisted = (data?.lead_messages || [])[0];
        if (!payloadLeadId || !persisted) return;
        if (!liveSelectedLead || +payloadLeadId !== +liveSelectedLead?.id) return;

        // Opp-type-scoped activity center — drop the merge when the
        // incoming message's root opp_type doesn't match the active
        // tab. Without this, sending a Sales message would replace
        // the optimistic bubble in the Service-tab thread too.
        // Legacy-safe: keep the merge when the payload has no
        // root_opp_type_id (opp-less message) OR no tab is active.
        // When we drop, bump the off-tab's unread counter so the tab
        // strip can render a red dot — silent drops would otherwise
        // leave the user unaware that activity arrived elsewhere.
        const incomingRoot = data?.root_opp_type_id;
        if (
          selectedOppTypeId &&
          incomingRoot != null &&
          Number(incomingRoot) !== Number(selectedOppTypeId)
        ) {
          const offTabRoot = Number(incomingRoot);
          setUnreadByRoot(prev => ({
            ...prev,
            [offTabRoot]: (prev[offTabRoot] || 0) + 1,
          }));
          return;
        }

        const incomingContent = String(persisted.content || "").trim();
        const newMsg = {
          id: persisted.id,
          systemUserId: persisted.system_user_id,
          leadOpportunityId: persisted.lead_opportunity_id,
          leadId: persisted.lead_id,
          userId: persisted.user_id,
          channelId: persisted.channel_id,
          campaignId: persisted.campaign_id,
          campaignTemplateId: persisted.campaign_template_id,
          messageSid: persisted.message_sid,
          direction: persisted.direction,
          dateSent: persisted.date_sent,
          dateReceived: persisted.date_received,
          content: persisted.content,
          messageType: persisted.message_type,
          contentType: persisted.content_type,
          errorCode: persisted.error_code,
          errorMessage: persisted.error_message,
          statusCode: persisted.status_code,
          messageStatus: persisted.message_status,
          messageLog: persisted.message_log || [],
          translatedContent: persisted.translated_content,
          user: persisted.user,
          campaign: persisted.campaign,
          leadOpportunity: persisted.lead_opportunity,
          // Email metadata (subject, body_html, from_/to, ses ids…). The email
          // bubble reads `message.email.subject`, so omitting this rendered
          // "No Subject" on the live socket append while a hard refresh — which
          // reloads from GraphQL — showed it correctly.
          email: persisted?.email,
          // Map snake_case mms_objects from the SocketIO payload to the
          // camelCase mmsObjects shape the timeline component expects.
          mmsObjects: (persisted.mms_objects || []).map(m => ({
            id: m.id,
            mediaUrl: m.media_url || m.mediaUrl,
            mediaType: m.media_type || m.mediaType,
            size: m.size,
            thumbnail: m.thumbnail,
            compressedMediaUrl: m.compressed_media_url || m.compressedMediaUrl || null,
            compressedThumbnail: m.compressed_thumbnail || m.compressedThumbnail || null,
          })),
        };

        // NOTE: setSelectedLead in this file is NOT React's useState setter
        // (see line ~902). It's a manual wrapper that dispatches a Redux
        // action and does NOT support the (prev) => ... callback form.
        // Pass the merged lead value directly.
        const prev = liveSelectedLead;
        const messages = Array.isArray(prev.messages) ? [...prev.messages] : [];
        // For MMS, match on first mediaUrl — the lambda's oversize fallback
        // rewrites content (appends a gallery short URL), so content equality
        // is unreliable. Media URLs are uniquely identifying since the FE
        // just uploaded them.
        const incomingFirstMediaUrl = (newMsg.mmsObjects && newMsg.mmsObjects[0]?.mediaUrl) || null;
        // Retry path: when the same message_id is already in the timeline
        // (originally FAILED, user clicked Retry, lambda re-sent and now
        // emits sent_message for the SAME row), replace in place. Without
        // this branch the queued-bubble matcher below skips rows with an
        // id, and the fallback `messages.push` is a no-op when the id is
        // already present — leaving the old FAILED state stuck in the UI.
        const existingByIdIdx = messages.findIndex(m => m?.id && +m.id === +newMsg.id);
        let queuedIdx = -1;
        if (existingByIdIdx >= 0) {
          messages[existingByIdIdx] = newMsg;
        } else {
          queuedIdx = messages.findIndex(m => {
            if (!m) return false;
            if (m.id) return false;
            if (m.type !== "new" && m.type !== "queued") return false;
            const mDir = m.direction || "TO_LEAD";
            const evDir = newMsg.direction || "TO_LEAD";
            if (mDir !== evDir) return false;
            const mFirstMediaUrl = (m.mmsObjects && m.mmsObjects[0]?.mediaUrl) || null;
            if (incomingFirstMediaUrl && mFirstMediaUrl) {
              return mFirstMediaUrl === incomingFirstMediaUrl;
            }
            return String(m.content || "").trim() === incomingContent;
          });
          if (queuedIdx >= 0) {
            messages[queuedIdx] = newMsg;
          } else {
            messages.push(newMsg);
          }
        }
        // eslint-disable-next-line no-console
        console.log("[Phase3a] sent_message merged", {
          persistedId: newMsg.id,
          messageType: newMsg.messageType,
          replacedById: existingByIdIdx >= 0,
          replacedQueuedIdx: queuedIdx,
          totalMessages: messages.length,
        });
        // Dispatch directly to Redux instead of going through the
        // ``setSelectedLead`` wrapper. The wrapper closes over the
        // ``selectedLead`` value from the render in which the SocketIO
        // listener was registered (deps: [socket]), which can be stale —
        // its inner ``{...selectedLead, ...lead}`` merge would overwrite
        // our updated ``messages`` array with the stale one.
        dispatch(setSelectedLeadRedux({ ...prev, messages }));
      } catch (err) {
        console.warn("engagementActivity onSentMessage merge failed", err);
      }
    };

    socket.on("sent_message", onSentMessage);
    return () => {
      socket.off("sent_message", onSentMessage);
    };
    // ``selectedOppTypeId`` is read inside ``onSentMessage`` for the
    // tab-scope drop check — re-bind the listener whenever the active
    // tab changes so the closure sees the current value.
  }, [socket, selectedOppTypeId]);

  // Phase 3a: ``send_failed`` arrives when the messaging_service lambda
  // aborted a send BEFORE persisting a Message row (lead-not-found,
  // missing appointment_id, top-level crash). No persisted id exists,
  // so we can't match by id — match the optimistic bubble by
  // ``lead_id + content + dateSent within window``. On match, mark the
  // bubble FAILED so the rep sees the inline error chip instead of an
  // indefinitely-spinning "Sending…" state.
  useEffect(() => {
    if (!socket || typeof socket.on !== "function") return;
    const MATCH_WINDOW_MS = 30000;
    const onSendFailed = data => {
      const liveSelectedLead = phase3aSelectedLeadRef.current;
      try {
        const payloadLeadId = data?.lead_id;
        if (!payloadLeadId) return;
        if (!liveSelectedLead || +payloadLeadId !== +liveSelectedLead?.id) return;

        // ``broadcast_sent_message`` on webapp flattens the lambda's
        // extra_data into trigger_obj, so content/sent_at_ms/error are
        // top-level keys on ``data`` rather than nested under extra_data.
        const incomingContent = String(data?.content || "").trim();
        const sentAtMs = Number(data?.sent_at_ms || 0);
        const errorMessage = data?.error || "Send failed";

        const prev = liveSelectedLead;
        const messages = Array.isArray(prev.messages) ? [...prev.messages] : [];
        const queuedIdx = messages.findIndex(m => {
          if (!m) return false;
          if (m.id) return false;
          if (m.type !== "new" && m.type !== "queued") return false;
          const mDir = m.direction || "TO_LEAD";
          if (mDir !== "TO_LEAD") return false;
          if (String(m.content || "").trim() !== incomingContent) return false;
          // Time-window match: lambda's sent_at_ms vs the bubble's
          // client-side dateSent. Tolerates skew + queue lag.
          if (!sentAtMs || !m.dateSent) return true;
          const bubbleMs = new Date(m.dateSent).getTime();
          if (!Number.isFinite(bubbleMs)) return true;
          return Math.abs(sentAtMs - bubbleMs) <= MATCH_WINDOW_MS;
        });
        if (queuedIdx < 0) {
          // eslint-disable-next-line no-console
          console.warn("[Phase3a] send_failed: no matching optimistic bubble", {
            leadId: payloadLeadId,
            content: incomingContent.slice(0, 40),
            sentAtMs,
          });
          return;
        }
        messages[queuedIdx] = {
          ...messages[queuedIdx],
          messageStatus: "FAILED",
          errorMessage,
          // Strip the ``queued``/``new`` marker so the timeline renderer
          // treats the row as a real (failed) message instead of a
          // sending-in-flight one.
          type: undefined,
        };
        // eslint-disable-next-line no-console
        console.log("[Phase3a] send_failed marked bubble FAILED", {
          replacedQueuedIdx: queuedIdx,
          error: errorMessage,
        });
        dispatch(setSelectedLeadRedux({ ...prev, messages }));
      } catch (err) {
        console.warn("engagementActivity onSendFailed merge failed", err);
      }
    };

    socket.on("send_failed", onSendFailed);
    return () => {
      socket.off("send_failed", onSendFailed);
    };
  }, [socket]);

  useEffect(() => {
    const slug = window.location.pathname;
    const phoneNumber =
      `${slug?.split("/")[3]}`.replace("/", "") === "undefined" ||
      `${slug?.split("/")[3]}`.replace("/", "") === "remove"
        ? ""
        : `${slug?.split("/")[3]}`.replace("/", "") || "";

    const currentUrlParams = new URLSearchParams(window.location.search);
    const urlLeadId = currentUrlParams.get("leadId");

    if (urlLeadId) {
      // LeadId-based navigation: clear phone search and set leadId
      setSearchKey("");
      setSearch("");
      setParamLeadId(urlLeadId);
      setIsSingleLeadView(true);
      // See above: single-lead view drops the Pinned narrowing.
      setVariables(prev => ({ ...prev, page: 1, leadId: urlLeadId, isPinned: undefined }));
    } else if (phoneNumber) {
      // Phone-based navigation
      setSearchKey(phoneNumber);
      setParamLeadId(null);
      setVariables(prev => ({ ...prev, leadId: null }));
    }
  }, [window.location.href]);

  useEffect(() => {
    setimplicit(
      consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_OFF")?.isActive
    );
    setexplicit(
      consent.find(item => item.code === "CONSENT_MESSAGE_FOR_OPTIN_CONSENT_METHOD_ON")?.isActive
    );
    setcosentAtEnd(consent.find(item => item.code === "CONSENT_MESSAGE_FOR_MESSAGE")?.isActive);
  }, [consent]);

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // Expire cached data periodically to fetch latest from server
  useInterval(() => {
    dispatch(resetApiCacheStore({}));
  }, parseInt(actionDispatchTime));

  const updateLoading =
    updatePhoneLoading || phoneLoading || updateEmailLoading || createEmailLoading;

  const handleLeadListDrawer = () => {
    setLeadListDrawer(prev => !prev);
  };

  const refreshLeadListData = () => {
    refreshLeadList({
      variables: {
        ...variables,
        search: search?.trim(),
        status: isEmpty(variables.search) ? uniq([...selectedQuickFilters, ...selectedStatus]) : [],
        campaignIds: variables?.campaignIds?.map(el => parseInt(el)),
        excludeDuplicate: true,
        userIds: [...userFilters],
        opportunityTypeIds:
          opportunityTypeFilters.length > 0 ? opportunityTypeFilters.map(Number) : undefined,
        opportunityStatusIds:
          opportunityStatusFilters.length > 0 ? opportunityStatusFilters.map(Number) : undefined,
        opportunitySourceIds:
          opportunitySourceFilters.length > 0 ? opportunitySourceFilters.map(Number) : undefined,
        prioritySortOrder: leadSort,
        skipFilter: !isEmpty(variables.search) && searchAllLeads,
        leadId: null,
      },
    }).then(res => {
      setLeadList(res?.data?.getLeads?.data);
      fetchMessages();
    });
  };

  const handleLeadProfileDrawer = () => {
    setLeadProfileDrawer(prev => !prev);
  };

  const [IsLeadListVisible, setIsLeadListVisible] = useState(true);
  const [isLeadProfileVisible, setisLeadProfileVisible] = useState(true);

  const handleLeadListVisible = () => {
    setIsLeadListVisible(prev => !prev);
  };

  const renderConsentNote = () => {
    if (afterMessageFromRedux?.content) {
      if (!onlyFirstMessage) {
        return true;
      } else {
        if (selectedLead?.messages?.length) {
          return false;
        }
        return true;
      }
    }
    return false;
  };
  const handleRefetchAndCloseDrawer = flag => {
    try {
      setRefetchAppointment(true);
      setOpenAppointmentDrawer(flag);
    } catch (err) {
      console.log(err.message);
    }
  };
  // Ref always holds the latest selectedLead so callbacks captured into imperative
  // dialog payloads (openDialog) can read the live value instead of a stale closure.
  const selectedLeadRef = useRef(selectedLead);
  useEffect(() => {
    selectedLeadRef.current = selectedLead;
  }, [selectedLead]);

  // Avoids re-pinning the lead after appointment save by skipping the leads-list refetch.
  // Instead, merges the new appointment into the leads list so the calendar label updates,
  // and (only if the appointment is for the currently open lead) updates selectedLead and
  // refetches its messages. The appointmentLeadId arg is passed from appointmentForm to
  // sidestep stale-closure issues where selectedLead may have changed since this dialog
  // was opened (e.g. user clicked the calendar icon on a non-selected lead).
  const refetchAfterAppointmentSave = (appointment, appointmentLeadId) => {
    const liveSelectedLead = selectedLeadRef.current;
    const leadId = appointmentLeadId || liveSelectedLead?.id;
    if (!leadId) return;

    if (appointment) {
      // Locate the lead in the list so we can patch its per-tab
      // appointment map alongside the legacy ``activeAppointment``
      // field. The lead list / lead profile read
      // ``activeAppointmentsByRootOppType`` first (so the Service tab
      // shows the Service appointment, not the most-recent overall),
      // so updating only ``activeAppointment`` post-save would leave
      // the tab-scoped widgets showing stale data.
      const targetLead =
        (leadList || []).find(l => +l?.id === +leadId) ||
        (+leadId === +liveSelectedLead?.id ? liveSelectedLead : null);

      const apptOppId = appointment?.leadOpportunityId;
      let rootIdForUpdate = null;
      if (apptOppId && targetLead?.leadOpportunities) {
        const apptOpp = targetLead.leadOpportunities.find(o => +o?.id === +apptOppId);
        if (apptOpp?.opportunityType) {
          rootIdForUpdate = getRootOppTypeId(apptOpp.opportunityType);
        }
      }

      // Synthesize the per-tab entry the BE dataloader would have
      // returned: ``{rootOppTypeId, appointment}``. Replace any
      // existing entry under the same root; append otherwise.
      const mergePerTab = (existing, newAppt, rootId) => {
        if (!rootId) return existing || [];
        const next = [...(existing || [])].filter(e => +e?.rootOppTypeId !== +rootId);
        next.push({
          rootOppTypeId: Number(rootId),
          appointment: newAppt,
        });
        return next;
      };

      const patch = {
        id: leadId,
        activeAppointment: appointment,
      };
      if (rootIdForUpdate && targetLead) {
        patch.activeAppointmentsByRootOppType = mergePerTab(
          targetLead.activeAppointmentsByRootOppType,
          appointment,
          rootIdForUpdate
        );
      }
      dispatch(updateLeadInList(patch));

      if (+leadId === +liveSelectedLead?.id) {
        const selectedPatch = {
          ...liveSelectedLead,
          activeAppointment: appointment,
        };
        if (rootIdForUpdate) {
          selectedPatch.activeAppointmentsByRootOppType = mergePerTab(
            liveSelectedLead.activeAppointmentsByRootOppType,
            appointment,
            rootIdForUpdate
          );
        }
        dispatch(setSelectedLeadRedux(selectedPatch));
      }
    }

    if (+leadId === +liveSelectedLead?.id) {
      getMessages({
        variables: {
          ...messageFilters,
          leadId: liveSelectedLead.id,
          page: 1,
        },
      });
    }
  };
  const handleKeyDown = event => {
    if (event.keyCode === 16) {
      // 16 is the key code for the Shift key
      event.preventDefault();
      event.stopPropagation();
    }
    // Enter without Shift = Send. Intercept on keydown (not keyup) so the
    // browser never inserts the newline into the textarea — otherwise the
    // sent body ends with a trailing "\n" (visible in the persisted
    // Message row). Shift+Enter still inserts a newline for multi-line
    // composition; the actual send flow runs in handleKeyUp's shift+Enter
    // branch (scroll-to-bottom only) and the Enter-without-shift block
    // below.
    if (event.keyCode === 13 && !event.shiftKey) {
      event.preventDefault();
    }
    event.target.style.height = "inherit";
    event.target.style.height = `${event.target.scrollHeight}px`;
  };
  useEffect(() => {
    if (text.current) {
      text.current.style.height = "inherit";
    }
  }, [text, selectedLead]);

  const fetchUsers = async companyId => {
    if ((users || []).length === 0) {
      getUsersByCompany({
        variables: {
          companyId: companyId,
        },
      });
    } else {
      await parseUserList(users, userIdMap, setUserIdMap);
    }
  };

  const fetchTeams = async companyId => {
    if (isUndefined(isUserTeamLeader) || isUserTeamLeader === "") {
      getTeamsByCompany({
        variables: {
          companyId: companyId,
        },
      });
    } else {
      await setFilterStatusForTeamLeader(isUserTeamLeader);
    }
  };

  useEffect(() => {
    if (user && user?.company?.id) {
      setTargetLangForEmployee(user?.preferredLanguageCode);
      fetchTeams(user?.company.id);
      fetchUsers(user?.company.id);
      getReviewInfo();
    }
  }, [user]);

  const handleMMS = async mmsArr => {
    // Definitive sync re-entry guard. Blocks duplicate createMms regardless
    // of which entry point fires (Send click, Enter key, scheduled send,
    // legacy oldInputArea, etc.).
    if (sendingMMSRef.current) return;
    sendingMMSRef.current = true;
    setmmsLoader(true);

    const messagePayload = {
      leadId: +selectedLead?.id,
      // Reply-as (EAI-1530): userId = signer (display); replyByUserId = actual
      // sender when on-behalf. Recipient stays the lead.
      // userId: +(replyAsSigner?.id || user.id),
      userId: +user.id,
      replyAsUserId: replyAsSigner?.id || null,
      direction: "TO_LEAD",
      content: textMode === 0 ? text.current.value.trim() : richTextValue.trim(),
      toPhone: getLeadToPhone(selectedLead, { withPlusPrefix: true }),
      mmsObjects: mmsArr,
      // Active Sales / Service / Parts tab — BE uses this to pick
      // the right opportunity for this MMS when no explicit
      // leadOpportunityId is supplied.
      selectedOppTypeId:
        messageOpportunity === ALL_OPPORTUNITY_TYPES_ID ? null : selectedOppTypeId || null,
      aiResponseHistoryId: textAiResponseHistoryId ?? null,
      attachmentSource: AttachmentSource.GALLERY,
      leadOpportunityId: resolveLeadOpportunityId(messageOpportunity),
    };

    try {
      const res = await createMMS({ variables: messagePayload });
      const code = res?.data?.createMms?.statusCode;
      if (code === 202) {
        // Phase 3a (lambda cutover): mutation returned 202 Accepted —
        // lambda will create the Message + MMSObject rows asynchronously
        // and emit a SocketIO sent_message event. Show an optimistic
        // queued bubble using the already-uploaded media URLs so the
        // user sees their attachment immediately.
        const messages = structuredClone(selectedLead.messages);
        const optimisticMmsObjects = (mmsArr || []).map(media => ({
          mediaUrl: media?.mediaUrl,
          mediaType: media?.mediaType,
          size: media?.size,
          thumbnail:
            media?.thumbnail && !isEmpty(media?.thumbnail)
              ? media?.thumbnail
              : media?.mediaUrl || null,
          compressedThumbnail: null,
          compressedMediaUrl: null,
        }));
        messages.push({
          leadId: selectedLead.id,
          // Mirror the server shape: userId = display (reply-as) user; originalUserId
          // = actual sender (login) when replying on behalf of someone else.
          userId: +(replyAsSigner?.id || user.id),
          originalUserId: replyAsSigner?.id && +replyAsSigner.id !== +user.id ? +user.id : null,
          user: {
            id: replyAsSigner?.id || user.id,
            fullName: replyAsSigner?.fullName || user?.fullName,
            profilePic: replyAsSigner?.profilePic ?? user?.profilePic,
          },
          direction: "TO_LEAD",
          content: messagePayload.content || "",
          dateSent: dayjs().utc().toISOString(),
          messageType: "MMS",
          contentType: "Sent Message to Lead",
          mmsObjects: optimisticMmsObjects,
          type: "queued",
        });
        setSelectedLead({
          ...selectedLead,
          messages: [...messages],
        });
        updateLeadMessagesRedux(selectedLead?.id, messages);
        textMode === 0 ? (text.current.value = "") : setrichTextValue("");
        setAttachments([]);
        setmessageText("");
        text.current.value = "";
        dispatch(setTextAiResponseHistoryId(null));
      } else if (code === 200) {
        const messages = structuredClone(selectedLead.messages);
        const mmsObjects = res?.data?.createMms.leadMessage.mmsObjects.map(media => ({
          compressedMediaUrl: media?.compressedMediaUrl || null,
          mediaUrl: media?.mediaUrl,
          mediaType: media?.mediaType,
          size: media?.size,
          thumbnail:
            media?.thumbnail && !isEmpty(media?.thumbnail)
              ? media?.thumbnail
              : media?.mediaUrl || null,
          compressedThumbnail: media?.compressedThumbnail || null,
        }));
        messages.push({
          ...res?.data?.createMms.leadMessage,
          mmsObjects: mmsObjects,
        });
        setSelectedLead({
          ...selectedLead,
          messages: [...messages],
        });
        updateLeadMessagesRedux(selectedLead?.id, messages);
        textMode === 0 ? (text.current.value = "") : setrichTextValue("");
        message.success(res?.data?.createMms?.message);
        setAttachments([]);
        setmessageText("");
        text.current.value = "";
        dispatch(setTextAiResponseHistoryId(null));
      }
    } catch (err) {
      console.error("createMMS failed:", err);
      message.error("Failed to send message. Please try again.");
    } finally {
      // Always release the in-flight lock and the loader, including on
      // network errors / GraphQL exceptions (the previous .then-only path
      // left mmsLoader stuck at true on failure).
      sendingMMSRef.current = false;
      setmmsLoader(false);
    }
  };
  const handleEmail = async () => {
    // if(emailTextRef.current){
    if (isEmpty(emailTextRef.current.innerText.replace(/\s/g, ""))) {
      return message.error("Please enter a content");
    }
    // }
    let mmsArr = [];
    if (attachments.length > 0) {
      setmmsLoader(true);
      mmsArr = await handleFiles(attachments, user, selectedLead, fetchData, setMediaUploadLoader);
      setmmsLoader(false);
    }
    const {
      attachments: inlineAttachments,
      content: contentWithLinks,
      linkedCount,
    } = buildEmailAttachmentsPayload(
      mmsArr,
      emailTextRef.current.innerHTML,
      EMAIL_ATTACHMENT_LIMITS.MAX_RAW_BYTES
    );
    const payload = {
      attachments: inlineAttachments,
      leadId: selectedLead.id,
      ...emailForm.getFieldsValue(),
      content: contentWithLinks,
      // Reply-as (EAI-1530): userId = signer (display); replyByUserId = actual
      // sender when on-behalf. Recipient stays the lead's email.
      userId: +user.id,
      replyAsUserId: replyAsSigner?.id || null,
      ...(messageOpportunity !== "#DEFAULTOPPID" ? { leadOpportunityId: messageOpportunity } : {}),
      aiResponseHistoryId: emailAiResponseHistoryId ?? null,
    };
    if (linkedCount > 0) {
      message.info(
        `${linkedCount} large file${linkedCount > 1 ? "s" : ""} sent as download link${
          linkedCount > 1 ? "s" : ""
        }.`
      );
    }
    const res = await createEmail({
      variables: payload,
    });
    if (res?.data?.createEmail?.statusCode === 200) {
      emailTextRef.current.innerHTML = "";
      emailForm.resetFields();
      // Replying reads the lead. Route it through the shared helper so the
      // All/Pinned badge follows the row — zeroing the row alone left the
      // tab pill counting a lead that no longer shows as unread.
      applyLeadUnreadCount(selectedLead?.id, 0);
      const resMessage = res?.data?.createEmail?.leadMessage || {};
      const id = parseInt(resMessage?.id);
      const selectedLeadDetails = structuredClone({
        ...selectedLead,
        textConsentStatus: lead?.textConsentStatus || selectedLead?.textConsentStatus,
      });
      selectedLeadDetails.messages.push({
        ...resMessage,
      });
      setSelectedLead(selectedLeadDetails);
      setAttachments([]);
      message.success(res?.data?.createEmail?.message);
      dispatch(setEmailAiResponseHistoryId(null));
    } else {
      message.error(res?.data?.createEmail?.message);
    }
  };
  const handleKeyUp = async event => {
    if (event.keyCode === 13 && event.shiftKey) {
      // 13 is the key code for the Enter key
      event.preventDefault();
      text.current.scrollTop = text.current.scrollHeight;
    } else if (event.keyCode === 13) {
      // Block re-entry when an MMS send is already in flight. This is what
      // closed the actual EAI-1124 duplicate: previously the Enter handler
      // had no guard and no setmmsLoader(true), so a user who pressed Enter
      // and then clicked Send 1-2s later would hit a Send button that still
      // showed mmsLoader=false and trigger a second createMms.
      if (sendingMMSRef.current || mmsLoader) {
        event.preventDefault();
        return;
      }
      let mmsArr = [];
      if (attachments.length > 0) {
        // Mirror the Send-button click handler: surface "in flight" state
        // immediately so the click handler's existing mmsLoader check (and
        // the antd Button loading/disabled state) blocks a follow-up click.
        setmmsLoader(true);
        try {
          mmsArr = await handleFiles(
            attachments,
            user,
            selectedLead,
            fetchData,
            setMediaUploadLoader
          );
        } catch (err) {
          console.error("handleFiles failed in Enter path:", err);
          setmmsLoader(false);
          message.error("Failed to upload attachment. Please try again.");
          return;
        }
        if (!mmsArr || mmsArr.length === 0) {
          // handleFiles swallowed an error and returned undefined/empty;
          // don't proceed to handleMMS, but make sure to release the loader.
          setmmsLoader(false);
          message.error("Failed to upload attachment. Please try again.");
          return;
        }
      }
      if ((mmsArr || []).length > 0) {
        // handleMMS owns the loader/ref reset from here on (try/finally).
        handleMMS(mmsArr);
      } else {
        if (
          isEmpty(messageText.trim()) &&
          isEmpty(textMode === 0 ? text.current?.value?.trim() : richTextValue)
        ) {
          // setmessageText(messageText.trim());
          return message.error(lang.pleaseEnterMessageToSend);
        }
        setmessageText(textMode === 0 ? text.current.value : richTextValue);

        if (!textDisabled()) {
          // Trim everywhere we read the raw textarea/state value. Even
          // though keydown preventDefault stops the Enter-newline, paste
          // and IME composition can still leave trailing whitespace —
          // the persisted Message body should match what's visible.
          const rawText = (text.current?.value || "").trim();
          const richText = (richTextValue || "").trim();
          const bodyText = textMode === 0 ? rawText : richText;
          const stateText = (messageText || "").trim();

          let msg;
          if (onlyFirstMessage) {
            // Consent text to be added only on the first message to lead
            if (selectedLead?.messages?.length > 0) {
              // Not the first message to lead, so consent text not required to be added.
              msg = bodyText || stateText;
            } else {
              // Append consent text to the message
              const base = stateText || bodyText;
              msg =
                afterMessageConsent !== "" &&
                selectedLead?.leadSource?.name !== "EngagedAi - Webchat"
                  ? `${base} ${afterMessageConsent}`
                  : base;
            }
          } else {
            // Consent text to be added on every message to lead
            const base = stateText || bodyText;
            msg =
              afterMessageConsent !== "" && selectedLead?.leadSource?.name !== "EngagedAi - Webchat"
                ? `${base} ${afterMessageConsent}`
                : base;
          }
          // Clear the textarea immediately on Send so the user knows the
          // send is in flight — matches the Send-button click flow which
          // also clears via onClickHandler's .then callback.
          text.current.value = "";
          text.current.style.height = "inherit";
          setmessageText("");
          if (textMode !== 0) {
            setrichTextValue("");
          }
          onClickHandler(msg, selectedLead, user?.id);
        } else {
          event.preventDefault();
        }
      }
    } else if (event.keyCode === 46) {
      // if (text?.current) {
      //   const start = text.current.selectionStart;
      //   const end = text.current.selectionEnd;
      //   if (start !== end) {
      //     // If text is selected, remove the selected text
      //     const { value } = text.current;
      //     text.current.value = value.slice(0, start) + value.slice(end);
      //     text.current.setSelectionRange(start, start); // Set cursor position
      //   } else {
      //     // If no text is selected, remove the character at the cursor position
      //     const { value } = text.current;
      //     text.current.value = value.slice(0, start) + value.slice(start + 1);
      //     text.current.setSelectionRange(start, start); // Set cursor position
      //   }
      // }
    }
  };

  function getIdsBySelectedField(data, fieldName) {
    return data.filter(item => item[fieldName]?.selected === true).map(item => item.id);
  }

  const findLeadById = id => {
    return duplicateRecord.find(lead => lead.id === id);
  };

  const handleMerge = async () => {
    const phones =
      findLeadById(getIdsBySelectedField(records, "Phone number")[0])?.phoneNumbers ||
      findLeadById(records[0]?.id)?.phoneNumbers;
    const email =
      findLeadById(getIdsBySelectedField(records, "Email")[0])?.email ||
      findLeadById(records[0]?.id)?.email;

    // Validate that at least phone or email is available
    if ((!phones || phones?.length === 0) && !email) {
      message.error("At least one phone number or email is required to merge leads");
      return;
    }

    await createLead({
      variables: {
        firstName:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.firstName ||
          findLeadById(records[0]?.id)?.firstName,
        lastName:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.lastName ||
          findLeadById(records[0]?.id)?.lastName,
        fullName:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.fullName ||
          findLeadById(records[0]?.id)?.fullName,
        phones,
        locationId:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.location?.id ||
          findLeadById(records[0]?.id)?.location?.id,
        email,
        leadStatusTypeId: findLeadById(records[0].id)?.leadStatusType,
        leadSourceOriginalId:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.leadSourceOriginalId ||
          findLeadById(records[0]?.id)?.leadSourceOriginalId,
        vehicleOfInterests:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.vehicleOfInterest ||
          findLeadById(records[0]?.id)?.vehicleOfInterest,
        textConsent:
          findLeadById(getIdsBySelectedField(records, "Name")[0])?.textConsentStatus ||
          findLeadById(records[0]?.id)?.textConsentStatus,
        potentialLeads: [...findLeadById(records[0]?.id)?.potentialLeads, +records[0]?.id],
        // leadAddressObj: {
        //   addressLine1:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.addressLine1,
        //   addressLine2:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.firstName,
        //   city:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.firstName,
        //   state:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.firstName,
        //   country:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.firstName,
        //   postalCode:
        //     findLeadById(getIdsBySelectedField(records, "Address")[0])?.addresses?.addressLine1 ||
        //     findLeadById(records[0]?.id)?.firstName,
        // },
        leadSourceType:
          findLeadById(getIdsBySelectedField(records, "Source")[0])?.leadSourceType ||
          findLeadById(records[0]?.id)?.leadSourceType,
        leadOpportunityUsers: findLeadById(records[0]?.id)?.leadUsers?.map(item => ({
          ...item,
          userType: item?.userType?.name,
        })),
      },
      onCompleted: res => {
        if (res?.createLead?.statusCode === 200) {
          setVisibleMergeLeadModal(false);
          refetchLeads();
        } else {
          message.error(res?.createLead?.message);
        }
      },
    });
  };

  const convertLeadsToFormattedArray = leadsArray => {
    return leadsArray?.map((lead, index) => ({
      id: lead?.id,
      Name: {
        value: lead.fullName,
        selected: false,
      },
      "Phone number": {
        value:
          [...lead?.phoneNumbers]
            ?.sort((a, b) => (b?.isPrimary ? 1 : 0) - (a?.isPrimary ? 1 : 0)) // Sort to move primary phone number to the top
            .map(item => item?.phone)
            .join(", ") || "",
        phoneNumbers: [...lead?.phoneNumbers]?.sort(
          (a, b) => (b?.isPrimary ? 1 : 0) - (a?.isPrimary ? 1 : 0)
        ),
        selected: false,
      },
      Email: {
        value:
          [...lead?.emails]
            ?.sort((a, b) => (b?.isPrimary ? 1 : 0) - (a?.isPrimary ? 1 : 0)) // Sort to move primary email to the top
            .map(item => item?.email)
            .join(", ") || "",
        selected: false,
      },
      Address: {
        value: lead?.addresses?.addressLine1,
        selected: false,
      },
      Location: {
        value: lead?.location?.title,
        selected: false,
      },
      Owners: {
        value:
          [...lead?.leadUsers]
            ?.map(item => `${item?.user?.firstName || "N/A"} ${item?.user?.lastName || "N/A"}`)
            .join(", ") || "",
        selected: false,
        Owners: [...lead?.leadUsers],
      },
      "Lead status": {
        value: lead?.leadStatusType?.status,
        selected: false,
      },
      Source: {
        value: lead?.leadSource?.name,
        selected: false,
      },
      Vehicle: {
        value: null,
        selected: false,
      },
    }));
  };
  const getDuplicateLeads = async (item, ids) => {
    setVisibleMergeLeadModal(true);
    const duplicateLeads = await getLeadsById({
      variables: {
        leadIds: ids,
      },
    });
    const temp = [...(duplicateLeads.data?.getLeadsById || [])];
    temp.unshift(item);
    setDuplicateRecord(temp);
    setRecords(convertLeadsToFormattedArray(temp));
  };

  const removeMergedLead = (ids, leads) => {
    const updatedLeads = leads?.filter(lead => !ids.includes(+lead.id));
    setLeadList(updatedLeads);
  };

  const getMergedLead = async (item, ids, leads) => {
    const duplicateLeads = await getLeadsById({
      variables: {
        leadIds: ids,
      },
    });

    const temp = [...(duplicateLeads.data?.getLeadsById || [])];

    // Find the index of the lead that matches the item id
    let index = -1;
    try {
      index = (leads || []).findIndex(lead => +lead.id === +item.id);
    } catch (error) {
      console.error("Error finding index in leads array:", error);
      return;
    }

    if (index === -1) {
      // If no match is found, return the original leads without modification
      return;
    }

    // Create a new array with the temp array added after the matching lead
    const updatedLeads = [
      ...leads.slice(0, index + 1), // All leads up to the matching lead (inclusive)
      ...temp, // Add the temp array after the matching lead
      ...leads.slice(index + 1), // The rest of the leads
    ];

    // Dispatch the updated leads list
    setLeadList(updatedLeads);
  };

  const removeSelectedLeadFromLeadCenter = item => {
    onUnpinLead(item);
    refetchLeads();
  };

  const placeholder = () => {
    return buttonStyle()?.background === "#F59E0B"
      ? `${lang.clickOnYellowSendIcon}`
      : buttonStyle().background === "#EF4444"
      ? "Customer has opted out, you don’t have consent!"
      : `Use Otto AI bot to write your message or type your message here...`;
  };
  function SuggestAMessage({ createSuggestedResponse, misc }) {
    return misc.loading ? (
      <Spin size="small" className="mr-2" />
    ) : (
      <Tooltip title="Generate Response">
        <Icon
          className="text-sm mr-2"
          onClick={() => createSuggestedResponse()}
          component={EngagedAI}
          alt="EngagedAi"
        />
      </Tooltip>
    );
  }
  const findOpp = () => {
    return opportunityList.find(item => +item.id === +activeOpp);
  };
  const opportunityObj = useMemo(findOpp, [activeOpp, opportunityList]);
  const canDisabledConversation = checkAccessPermission(
    AccessPermissionAction.LEAD_MANAGEMENT_DISABLED_CONVERSATION
  );

  const groupedMessages = useMemo(
    () => groupMessagesByDate(selectedLead.messages),
    [selectedLead, selectedLead.messages]
  );
  const totalSize = useMemo(() => {
    return sumBy(
      attachments.map(item => item.file),
      "size"
    );
  }, [attachments]);
  const [emailCursor, setemailCursor] = useState(null);

  const hasLoadedinRedux =
    leadList.find(el => +el.id === +selectedLead?.id)?.hasLoadedinRedux || false;
  useEffect(() => {
    if (selectedLead) {
      dispatch(resetEmail());
    }
  }, [selectedLead]);

  const handleBackButtonClick = () => {
    // "View all messages" reloads the CURRENTLY selected lead's full thread with
    // normal pagination, dropping only the target-message deep-link filter.
    // It intentionally does NOT reset the leads list or switch the selected lead —
    // that is handled separately by onLoadAllLeads ("Load all leads").
    setMessageFilters(prev => ({
      ...prev,
      page: 1,
      pageSize: 20,
      leadId: selectedLead?.id || prev.leadId,
      campaignIds: [],
      lastId: "",
      internalMessageId: null,
    }));
    dispatch(resetSelectedLeadMessages());

    // Force scroll to bottom after data refetch with sufficient delay using auto behavior
    setTimeout(() => {
      scrollToBottom("auto");
    }, 300);

    // Clear targetMessageId (state + sessionStorage) to:
    // 1. Hide "View all messages" button
    // 2. Next fetchMessages() call will use normal pagination (no messageId in payload)
    clearTargetMessageId();

    // Strip only the message deep-link param so a refresh doesn't re-scroll; keep
    // leadId so the user stays on this lead.
    const params = new URLSearchParams(window.location.search);
    if (params.has(URL_PARAM_MESSAGE_ID)) {
      params.delete(URL_PARAM_MESSAGE_ID);
      const qs = params.toString();
      window.history.replaceState(null, "", `${window.location.pathname}${qs ? `?${qs}` : ""}`);
    }
  };

  return (
    <>
      {/* <Spin
        spinning={mediaUploadLoader}
        tip={mediaUploadLoader ? `${lang.uploadingMedia}...` : ""}
        className="fixed top-[50%] left-[50%] z-50 font-bold bg-white py-[15px] px-[30px] translate-x-[-50%] translate-y-[50%]"
      /> */}
      <div className="flex w-full p-2 headerBackground items-center xl:hidden">
        <AntdIconV4
          onClick={() => handleLeadListDrawer()}
          className="basis-1/4 text-lg text-start font-medium"
          type="MenuOutlined"
        />
        <div className="basis-1/2 text-center">
          <CustomLabel labelClass="text-lg font-semibold" label={selectedLead?.fullName || ""} />
          <CustomLabel
            labelClass="text-sm text-cener font-meduim"
            label={ShowConsent(selectedLead, user, null, null, "justify-center")}
          />
        </div>
        <AntdIconV4
          onClick={() => handleLeadProfileDrawer()}
          className="basis-1/4 w-full text-lg flex justify-end font-medium mr-2"
          type="UserOutlined"
        />

        <Tooltip placement="top" title={!fullScreen ? "Minimize screen" : "Maximize screen"}>
          {!fullScreen ? (
            <FullscreenExitOutlined
              onClick={() => {
                setFullScreen(!fullScreen);
                onSetfull(!fullScreen);
                onFullScreen(!fullScreen);
                setMaximizeScreen(!fullScreen);
              }}
            />
          ) : (
            <FullscreenOutlined
              onClick={() => {
                setFullScreen(!fullScreen);
                onSetfull(!fullScreen);
                onFullScreen(!fullScreen);
                setMaximizeScreen(!fullScreen);
              }}
            />
          )}
        </Tooltip>
      </div>
      <MergeLeadOpportunityModal
        visible={visibleMergeLeadModal}
        setVisible={setVisibleMergeLeadModal}
        handleMerge={handleMerge}
        loading={createLeadLoader}
        dataLoader={potentialLeadLoader}
        columns={columns}
        tableData={tableData}
      />
      <div
        className={
          !isMobileView
            ? "flex items-start gap-1 h-[80vh] md:h-[80vh] lg:h-[86vh] xl:h-[86vh] 2xl:h-[81vh] 3xl:h-[86vh] 4xl:h-[88vh]"
            : isFullScreen
            ? "flex items-start gap-1"
            : "flex items-start gap-1 h-[86vh]"
        }
      >
        <div className="relative h-full mt-2.5">
          <div
            className={`hidden h-full overflow-hidden w-[25vw] antdList ${
              IsLeadListVisible ? "xl:block" : "xl:hidden"
            } transition-all ease-in-out delay-150 pl-2`}
          >
            <LeadListContainer
              showSidebar={showSidebar}
              setShowSideBar={setShowSideBar}
              selectedLead={selectedLead}
              setSummaryVisible={setSummaryVisible}
              leadsError={leadsError}
              leadsLoading={leadsLoading || refreshLeadsLoader}
              setShowLeadSection={setShowLeadSection}
              leadList={leadList}
              setLeadList={setLeadList}
              variables={variables}
              setmessageText={setmessageText}
              leadCount={leadCount}
              unreadLeadsCount={unreadLeadsCount}
              onPinsChanged={handlePinsChanged}
              lastLead={lastLead}
              setVariables={updatedVariables => {
                if (updatedVariables?.leadId === null) {
                  setParamLeadId(null);
                  hasSkippedInitialLocEffectRef.current = false;
                }
                setVariables({ ...updatedVariables, leadId: null });
              }}
              setSelectedLead={lead => {
                setSelectedLead(lead);
              }}
              setMessageFilters={payload => {
                setMessageFilters({ ...payload });
              }}
              messageFilters={messageFilters}
              sourcesData={sourcesData}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              handleSearch={handleSearch}
              activeOpp={activeOpp}
              setActiveOpp={setActiveOpp}
              opportunityList={opportunityList}
              activeOppName={activeOppName}
              timeReference={timeReference}
              setOpportunityList={setOpportunityList}
              setFilterApplied={setFilterApplied}
              handleOppFilter={handleOppFilter}
              setShowProfileSection={setShowProfileSection}
              selectedStatus={uniq([...selectedQuickFilters, ...selectedStatus])}
              setSelectedStatus={setSelectedStatus}
              leadStatus={leadStatus}
              handleStatusFilter={handleStatusFilter}
              handleAppointmentModalClose={handleAppointmentModalClose}
              openAppointmentPopup={openAppointmentPopup}
              getLeadDetail={getLeadDetail}
              setSelectedLeadId={setSelectedLeadId}
              setbtnClicked={setbtnClicked}
              setRefetchAppointment={setRefetchAppointment}
              setActiveLeadId={setActiveLeadId}
              handleScrollOnMovement={handleScrollOnMovement}
              eventId={eventId}
              handleLeadListVisible={handleLeadListVisible}
              IsLeadListVisible={IsLeadListVisible}
              changePage={() => {
                page = 1;
              }}
              spinner={spinner}
              campaignFilters={campaignFilters}
              queryString={queryString}
              entityId={entityId}
              setAttachments={setAttachments}
              refetchLeads={refetchLeads}
              handleUnpinLead={item => removeSelectedLeadFromLeadCenter(item)}
              selectedLeadsFromLeadCenter={lead && Array.isArray(lead) ? lead : [lead]}
              isLeadCenterApply={isLeadCenterApply}
              onLeadCenterApplyConsumed={onLeadCenterApplyConsumed}
              visibleMergeLeadModal={visibleMergeLeadModal}
              setVisibleMergeLeadModal={setVisibleMergeLeadModal}
              getDuplicateLeads={getDuplicateLeads}
              getMergedLead={getMergedLead}
              removeMergedLead={removeMergedLead}
              isSingleLeadView={isSingleLeadView}
              onClearAllFilters={exitSingleLeadView}
              onLoadAllLeads={() => {
                exitSingleLeadView();
                setVariables({ ...variables, leadId: null });
                dispatch(setSearchRedux(""));
              }}
              selectedOppTypeId={selectedOppTypeId}
              setSelectedOppTypeId={setSelectedOppTypeId}
              listFilterRootOppTypeIds={listFilterRootOppTypeIds}
            />
            <span
              onClick={() => setIsLeadListVisible(!IsLeadListVisible)}
              className={`absolute cursor-pointer left-[98%] z-[999] top-[100px] ${
                IsLeadListVisible ? "rotate-180" : "rotate-0"
              }`}
            >
              <RightBlackIcon />
            </span>
          </div>
        </div>
        <div
          className="flex-1 pt-2.5 flex flex-col h-full overflow-y-auto overflow-x-hidden relative chatContainer"
          style={{
            borderLeft: `2px solid ${colorConfig.greyLightest}`,
            borderRight: `2px solid ${colorConfig.greyLightest}`,
          }}
        >
          <TopToolbarJsx
            selectedLead={selectedLead}
            messageFilters={messageFilters}
            page={page}
            setMessageFilters={setMessageFilters}
            opportunityList={opportunityList}
            // Unfiltered enriched opp list — used by the nested
            // dropdown to label cross-root rows and to validate the
            // selected opp during a tab switch.
            fullOpportunityList={fullOpportunityList}
            activeOpp={activeOpp}
            setActiveOpp={setActiveOpp}
            handleOppFilter={handleOppFilter}
            activeOppName={activeOppName}
            // Active root opp_type tab — drives the "All sales" / "All
            // service" label prefix and the icon-chip color on the
            // message-pane opp dropdown.
            selectedOppTypeId={selectedOppTypeId}
            // Lets the nested opp dropdown switch the active root tab
            // when the user picks an opp from a different root.
            setSelectedOppTypeId={setSelectedOppTypeId}
            refetchLeadDetails={refetchLeadDetails}
            // Shows "View all messages" button when navigated to a specific message (e.g. notification click)
            renderBackToNormalModeButton={!!targetMessageId}
            disabled={
              !selectedLead?.id ||
              messageLoader ||
              loading ||
              spinner ||
              leadsLoading ||
              emailLoader
            }
            handleBackButtonClick={handleBackButtonClick}
            visibleTranslationSettings={visibleTranslationSettings}
            setVisibleTranslationSetting={setVisibleTranslationSetting}
            targetLangForCustomer={targetLangForCustomer}
            setTargetLangForCustomer={setTargetLangForCustomer}
            updateTranslationSetting={updateTranslationSetting}
            targetLangForEmployee={targetLangForEmployee}
            isAutoTranslate={isAutoTranslate}
            isIncludeOriginalMessage={isIncludeOriginalMessage}
            isTranslatePreviewShow={isTranslatePreviewShow}
            languages={languages}
            setTargetLangForEmployee={setTargetLangForEmployee}
            setIsAutoTranslate={setIsAutoTranslate}
            setIsIncludeOriginalMessage={setIsIncludeOriginalMessage}
            setIsTranslatePreviewShow={setIsTranslatePreviewShow}
          />
          <div
            id="msgEndDiv"
            // pb-3 adds a small bottom buffer so ``scrollToBottom``
            // (which scrolls to ``scrollHeight``) clears the message
            // input bar instead of letting the last bubble sit ~1% behind
            // it. Cheaper than measuring the input bar dynamically and
            // works regardless of which input variant is rendered.
            className="bg-[#F5F5F5] grow overflow-auto h-[55vh] px-1 pb-3"
            ref={msgContainerRef}
            onScroll={onMsgScroll}
            // onWheel={handleWheel}
            // onTouchMove={handleTouchMove}
            // onTouchStart={handleTouchStart}
          >
            {/* Sticky loader for pagination */}
            <PaginationLoader
              isLoading={loading && hasLoadedinRedux}
              loadingText={`${lang.loadingMoreMessages}...`}
            />

            <Spin
              spinning={loading && !hasLoadedinRedux}
              className="mt-5 z-[999]"
              tip={loading ? `${lang.loadingMessages}...` : `${lang.loadingMoreMessages}...`}
            >
              <div className="pb-1 overflow-x-hidden">
                {/* getLeads still in flight: no lead is resolved yet, so any
                    empty-state copy would be a guess. Show the chat shape
                    instead and let it resolve. */}
                {Object.keys(groupedMessages)?.length === 0 && leadsLoading ? (
                  <ChatSkeleton />
                ) : Object.keys(groupedMessages).length === 0 && !loading ? (
                  <EmptyConversationState variant={emptyConversationVariant} />
                ) : (
                  Object.keys(groupedMessages)
                    .sort((a, b) => {
                      const dateA = dayjs(a);
                      const dateB = dayjs(b);
                      // Sort in descending order, so the latest date is at the bottom
                      return dateA.isBefore(dateB) ? -1 : 1;
                    })
                    .map((date, index) => {
                      const messageProps = {
                        targetLangForCustomer,
                        targetLangForEmployee,
                        canViewTranslation,
                        date,
                        isIncludeOriginalMessage,
                        isAutoTranslate,
                        userIdMap,
                        handleRetry,
                        hasAnyForwardOption,
                      };
                      return (
                        <MessagesGroup
                          key={date}
                          dateMessages={groupedMessages[date]}
                          handleOpportunityId={handleOpportunityId}
                          targetMessageId={targetMessageId}
                          {...messageProps}
                        />
                      );
                    })
                )}
              </div>
            </Spin>
            <div ref={messagesEndRef} />
          </div>

          {!isMobileView && <CustomDivider className="my-0" />}
          <div>
            {!recording.visible ? (
              <>
                {attachments.length > 0 && (
                  <div className="w-full">
                    <Collapse
                      className="reverse-collapse transparent-collapse border-none"
                      defaultActiveKey={["1"]}
                      accordion
                    >
                      {attachments.length > 0 && (
                        <Collapse.Panel
                          key="1"
                          header={
                            <div className="flex-row-centered gap-0.5 items-center justify-between">
                              <div className="flex-row-centered gap-0.5 items-center">
                                <span className="text-xs font-[600] text-grey-700">
                                  {attachments.length} attachment
                                </span>
                                <i className="text-xs font-[400] text-grey-700">
                                  {" "}
                                  <span className="my-1  flex flex-row items-center gap-1 ">
                                    ({formatBytes(totalSize, 2)})
                                  </span>
                                </i>
                              </div>
                              <span
                                className="text-red-500 text-xs font-[600] cursor-pointer"
                                onClick={e => {
                                  e.stopPropagation();
                                  // Clean up blob URLs to prevent memory leaks
                                  attachments.forEach(attachment => {
                                    if (
                                      attachment?.preview &&
                                      attachment.preview.startsWith("blob:")
                                    ) {
                                      URL.revokeObjectURL(attachment.preview);
                                    }
                                  });
                                  setAttachments([]);
                                }}
                              >
                                Remove all
                              </span>
                            </div>
                          }
                        >
                          <Attachments
                            key={selectedLead?.id}
                            attachments={attachments}
                            setAttachments={setAttachments}
                          />
                        </Collapse.Panel>
                      )}
                    </Collapse>
                  </div>
                )}
                {summaryVisible.visible && (
                  <ConversationSummary
                    key={selectedLead?.id}
                    isDisabled={
                      !selectedLead?.id ||
                      messageLoader ||
                      loading ||
                      spinner ||
                      leadsLoading ||
                      emailLoader
                    }
                    selectedLead={selectedLead}
                    user={user}
                    summaryVisible={summaryVisible}
                    setSummaryVisible={setSummaryVisible}
                  />
                )}

                <div>
                  {messageOpportunity !== ALL_OPPORTUNITY_TYPES_ID && (
                    <ResizableContainer
                      defaultHeight={
                        textModeRedux === "Email"
                          ? INPUT_TAB_HEIGHT.DEFAULT_EMAIL
                          : INPUT_TAB_HEIGHT.DEFAULT_TEXT_MESSAGE
                      }
                      minHeight={
                        textModeRedux === "Email"
                          ? INPUT_TAB_HEIGHT.MIN_EMAIL
                          : INPUT_TAB_HEIGHT.MIN_TEXT_MESSAGE
                      }
                      maxHeight={
                        textModeRedux === "Email"
                          ? INPUT_TAB_HEIGHT.MAX_EMAIL
                          : INPUT_TAB_HEIGHT.MAX_TEXT_MESSAGE
                      }
                    >
                      <InputArea
                        textMode={textMode}
                        buttonStyle={buttonStyle}
                        text={text}
                        selectedLead={selectedLead}
                        handleKeyDown={handleKeyDown}
                        handleKeyUp={handleKeyUp}
                        textDisabled={textDisabled}
                        messageLoader={messageLoader || emailLoader}
                        loading={loading}
                        spinner={spinner}
                        leadsLoading={leadsLoading}
                        lang={lang}
                        setmessageText={setmessageText}
                        placeholder={placeholder}
                        messageText={messageText}
                        richTextValue={richTextValue}
                        setrichTextValue={setrichTextValue}
                        renderConsentNote={renderConsentNote}
                        afterMessageFromRedux={afterMessageFromRedux}
                        handleSetDefinedTemplate={handleSetDefinedTemplate}
                        isEmojiOpen={isEmojiOpen}
                        setIsEmojiOpen={setIsEmojiOpen}
                        scheduledMessages={scheduledMessages}
                        getMessages={getMessages}
                        user={user}
                        SuggestAMessage={SuggestAMessage}
                        tooltipTitle={tooltipTitle}
                        buttonDisabled={buttonDisabled}
                        mmsLoader={mmsLoader}
                        attachments={attachments}
                        setAttachments={setAttachments}
                        setmmsLoader={setmmsLoader}
                        fetchData={fetchData}
                        setMediaUploadLoader={setMediaUploadLoader}
                        handleMMS={handleMMS}
                        onlyFirstMessage={onlyFirstMessage}
                        afterMessageConsent={afterMessageConsent}
                        onClickHandler={onClickHandler}
                        setCallConsentMessage={setCallConsentMessage}
                        sendConsentMessage={sendConsentMessage}
                        translateMessage={translateMessage}
                        languages={languages}
                        originalText={originalText}
                        setOriginalText={setOriginalText}
                        isTranslatePreviewShow={isTranslatePreviewShow}
                        setisReview={setisReview}
                        setEmailCursor={value => setemailCursor(value)}
                        emailTextRef={emailTextRef}
                        emailForm={emailForm}
                        handleEmail={handleEmail}
                        hideBottom={hideBottom}
                        setHideBottom={setHideBottom}
                        messageFilters={messageFilters}
                        selectedOppTypeId={selectedOppTypeId}
                        isReplyAsManager={isReplyAsManager}
                        replyAsSigner={replyAsSigner}
                        replyAsRoleOptions={replyAsRoleOptions}
                        replyAsSelectedRole={replyAsSelectedValue}
                        replyAsRoleLoading={replyAsRoleLoading}
                        replyAsLeadRows={replyAsLeadRows}
                        replyAsHasOverride={replyAsOverrideUserId != null}
                        onReplyAsSelectRole={onReplyAsSelectRole}
                        onReplyAsSelectUser={onReplyAsSelectUser}
                        onReplyAsClear={onReplyAsClear}
                      />
                    </ResizableContainer>
                  )}
                </div>
              </>
            ) : (
              <div style={{ display: "flex" }}>
                <h1>Record View</h1>
              </div>
            )}

            <div className="w-full">
              {(!user?.phone || (user?.phone === "" && showLeadSection)) && (
                <Alert
                  className="sm:w-2/4 w-full "
                  style={{ fontSize: 11 }}
                  message={
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <div className="secondaryColorTheme" onClick={() => setOpenEditUserPhone(true)}>
                      {lang.dontHaveValidNumber}
                      <AntdIconV4 type="EditOutlined" />
                    </div>
                  }
                  type="error"
                />
              )}
            </div>
            <div className="w-full h-[1px] bg-grey-200" />
            {(!isMobileView || hideBottom) &&
              (messageOpportunity === ALL_OPPORTUNITY_TYPES_ID ? (
                <AllOpportunityReplyAlert />
              ) : (
                <BottomActions
                  key={selectedLead.id}
                  attachments={attachments}
                  handleMediaSharing={handleMediaSharing}
                  mediaRef={mediaRef}
                  videoRef={videoRef}
                  documentRef={documentRef}
                  setAttachments={setAttachments}
                  textMode={textMode}
                  handleSetDefinedTemplate={handleSetDefinedTemplate}
                  text={text}
                  messageText={messageText}
                  textDisabled={textDisabled}
                  setIsEmojiOpen={setIsEmojiOpen}
                  isEmojiOpen={isEmojiOpen}
                  selectedLead={selectedLead}
                  user={user}
                  setTemplateModal={setTemplateModal}
                  handleSendReviewClick={handleSendReviewClick}
                  handleAddAppointment={handleAddAppointment}
                  richTextValue={richTextValue}
                  setrichTextValue={setrichTextValue}
                  SuggestAMessage={SuggestAMessage}
                  showReviewRequestButton={showReviewRequestButton}
                  refetchLeads={refetchLeads}
                  setmessageText={setmessageText}
                  setisReview={setisReview}
                  activeOppName={activeOppName}
                  getMessages={getMessages}
                  scheduledMessages={scheduledMessages}
                  buttonDisabled={buttonDisabled}
                  leadsLoading={leadsLoading}
                  loading={loading}
                  messageLoader={messageLoader || emailLoader}
                  mmsLoader={mmsLoader}
                  buttonStyle={buttonStyle}
                  afterMessageConsent={afterMessageConsent}
                  fetchData={fetchData}
                  handleFiles={handleFiles}
                  handleMMS={handleMMS}
                  emailForm={emailForm}
                  isConsentStatusEnable={isConsentStatusEnable}
                  onlyFirstMessage={onlyFirstMessage}
                  sendConsentMessage={sendConsentMessage}
                  setCallConsentMessage={setCallConsentMessage}
                  setMediaUploadLoader={setMediaUploadLoader}
                  setmmsLoader={setmmsLoader}
                  spinner={spinner}
                  onClickHandler={onClickHandler}
                  tooltipTitle={tooltipTitle}
                  setSummaryVisible={setSummaryVisible}
                  summaryVisible={summaryVisible}
                  scheduledMessageDrawer={scheduledMessageDrawer}
                  setscheduledMessageDrawer={setscheduledMessageDrawer}
                  crmIntegrationType={crmIntegration}
                  opportunityList={opportunityList}
                  addSignature={addSignature}
                  emailCursor={emailCursor}
                  setEmailCursor={setemailCursor}
                  emailTextRef={emailTextRef}
                  selectedOppTypeId={selectedOppTypeId}
                />
              ))}
          </div>
        </div>
        <div className="relative h-full mt-2.5">
          <div
            className={`hidden w-[23vw] overflow-auto h-full ${
              isLeadProfileVisible ? "xl:block" : "xl:hidden"
            } transition-all ease-in-out delay-150`}
          >
            <LeadProfile
              handleAddAppointment={handleAddAppointment}
              connection={connection}
              setConnection={setConnection}
              setLeadList={setLeadList}
              socket={socket}
              canEditPhone={canEdit}
              handleAddPhoneClick={handleAddPhoneClick}
              handleSendReviewInviteClick={handleSendReviewInviteClick}
              handleBackClick={handleBackClick}
              selectedLead={selectedLead}
              showDetails={showDetails}
              setPushToCrmModalVisible={setPushToCrmModalVisible}
              setOpenEditPopup={setOpenEditPopup}
              handleUpdate={handleUpdate}
              refetchAppointment={refetchAppointment}
              handleSendConsentClick={handleSendConsentClick}
              disableConcentClick={disableConcentClick}
              consentLoader={consentLoader}
              handleActiveToggle={handleActiveToggle}
              setInlineEditField={setInlineEditField}
              updateLoading={updateLoading}
              inlineField={inlineField}
              user={user}
              isUserBDC={isUserBDC}
              updateStatusLoading={updateStatusLoading}
              setFilters={id => {
                page = 1;
                setMessageFilters({
                  ...messageFilters,
                  page: 1,
                  campaignIds: id ? [id] : [],
                });
              }}
              refetchLeadDetails={refetchLeadDetails}
              handleEditLead={lead => handleEditLead(lead)}
              setRefetchAppointment={setRefetchAppointment}
              setSelectedLead={setSelectedLead}
              setMessageFilters={setMessageFilters}
              messageFilters={messageFilters}
              refetchLeads={refetchLeads}
              crmLeadObj={selectedLead?.crmLeadObj}
              isAppointmentChangeFromLead={isAppointmentChangeFromLead}
              spinner={spinner}
              statusList={statusList}
              setstatusList={setstatusList}
              leadList={leadList}
              setShowLeadSection={setShowLeadSection}
              setOpportunityList={setOpportunityList}
              setFilterApplied={setFilterApplied}
              setSelectedLeadId={setSelectedLeadId}
              setActiveOpp={setActiveOpp}
              timeReference={timeReference}
              crmIntegration={crmIntegration}
              crmIntegrationData={crmIntegrationData}
              handleLeadDetailProfile={handleLeadDetailProfile}
              setIsClickonPotentialDuplicate={setIsClickonPotentialDuplicate}
              getLeadDetail={getLeadDetail}
              eventId={eventId}
              userIdMap={userIdMap}
              getMessages={getMessages}
              activeOpportunity={activeOpp}
              languages={languages}
              refreshLeadListData={refetchAfterAppointmentSave}
              selectedOppTypeId={selectedOppTypeId}
              setSelectedOppTypeId={setSelectedOppTypeId}
              unreadByRoot={unreadByRoot}
            />
          </div>
          <span
            className={`cursor-pointer absolute left-[-18px] top-[100px] ${
              isLeadProfileVisible ? "rotate-0" : "rotate-180"
            } transition-all duration-300`}
            onClick={() => setisLeadProfileVisible(prev => !prev)}
          >
            <RightBlackIcon />
          </span>
        </div>
        {!IsLeadListVisible && (
          <span
            onClick={() => setIsLeadListVisible(!IsLeadListVisible)}
            className={`absolute cursor-pointer left-0 z-[999] top-10 ${
              IsLeadListVisible ? "rotate-180" : "rotate-0"
            }`}
          >
            <RightBlackIcon />
          </span>
        )}
      </div>
      <Drawer
        title={lang.leadList}
        placement="left"
        onClose={handleLeadListDrawer}
        bodyStyle={{ padding: 0 }}
        open={leadListDrawer}
        width="100%"
      >
        <LeadListContainer
          setSummaryVisible={setSummaryVisible}
          showSidebar={showSidebar}
          setShowSideBar={setShowSideBar}
          selectedLead={selectedLead}
          leadsError={leadsError}
          leadsLoading={leadsLoading}
          setmessageText={setmessageText}
          setShowLeadSection={setShowLeadSection}
          leadList={leadList}
          setLeadList={setLeadList}
          variables={variables}
          leadCount={leadCount}
          unreadLeadsCount={unreadLeadsCount}
          onPinsChanged={handlePinsChanged}
          lastLead={lastLead}
          handleLeadListDrawer={handleLeadListDrawer}
          setVariables={setVariables}
          setSelectedLead={setSelectedLead}
          setMessageFilters={payload => {
            textMode === 0 ? (text.current.value = "") : setrichTextValue("");
            setMessageFilters({ ...payload });
          }}
          messageFilters={messageFilters}
          sourcesData={sourcesData}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          handleSearch={handleSearch}
          activeOpp={activeOpp}
          setActiveOpp={setActiveOpp}
          opportunityList={opportunityList}
          activeOppName={activeOppName}
          timeReference={timeReference}
          setOpportunityList={setOpportunityList}
          setFilterApplied={setFilterApplied}
          handleOppFilter={handleOppFilter}
          setShowProfileSection={setShowProfileSection}
          selectedStatus={uniq([...selectedQuickFilters, ...selectedStatus])}
          setSelectedStatus={setSelectedStatus}
          leadStatus={leadStatus}
          handleStatusFilter={handleStatusFilter}
          handleAppointmentModalClose={handleAppointmentModalClose}
          openAppointmentPopup={openAppointmentPopup}
          getLeadDetail={getLeadDetail}
          setSelectedLeadId={setSelectedLeadId}
          setbtnClicked={setbtnClicked}
          setRefetchAppointment={setRefetchAppointment}
          setActiveLeadId={setActiveLeadId}
          handleScrollOnMovement={handleScrollOnMovement}
          eventId={eventId}
          // eslint-disable-next-line no-return-assign
          changePage={() => {
            page = 1;
          }}
          spinner={spinner}
          campaignFilters={campaignFilters}
          queryString={queryString}
          entityId={entityId}
          setAttachments={setAttachments}
          refetchLeads={refetchLeads}
          getDuplicateLeads={getDuplicateLeads}
          getMergedLead={getMergedLead}
          removeMergedLead={removeMergedLead}
          isSingleLeadView={isSingleLeadView}
          onClearAllFilters={exitSingleLeadView}
          onLoadAllLeads={() => {
            exitSingleLeadView();
            setVariables({ ...variables, leadId: null });
            dispatch(setSearchRedux(""));
          }}
          selectedOppTypeId={selectedOppTypeId}
          setSelectedOppTypeId={setSelectedOppTypeId}
          listFilterRootOppTypeIds={listFilterRootOppTypeIds}
        />
      </Drawer>
      <Drawer
        title={lang.leadProfile}
        placement="right"
        bodyStyle={{ padding: 5 }}
        onClose={handleLeadProfileDrawer}
        open={leadProfileDrawer}
        width="100%"
      >
        <LeadProfile
          handleAddAppointment={handleAddAppointment}
          connection={connection}
          setConnection={setConnection}
          setLeadList={setLeadList}
          socket={socket}
          canEditPhone={canEdit}
          handleAddPhoneClick={handleAddPhoneClick}
          handleSendReviewInviteClick={handleSendReviewInviteClick}
          handleBackClick={handleBackClick}
          selectedLead={selectedLead}
          showDetails={showDetails}
          setPushToCrmModalVisible={setPushToCrmModalVisible}
          setOpenEditPopup={setOpenEditPopup}
          handleUpdate={handleUpdate}
          refetchAppointment={refetchAppointment}
          handleSendConsentClick={handleSendConsentClick}
          disableConcentClick={disableConcentClick}
          consentLoader={consentLoader}
          handleActiveToggle={handleActiveToggle}
          setInlineEditField={setInlineEditField}
          updateLoading={updateLoading}
          inlineField={inlineField}
          user={user}
          isUserBDC={isUserBDC}
          updateStatusLoading={updateStatusLoading}
          setFilters={id => {
            page = 1;
            setMessageFilters({
              ...messageFilters,
              page: 1,
              campaignIds: id ? [id] : [],
            });
          }}
          refetchLeadDetails={refetchLeadDetails}
          handleEditLead={lead => handleEditLead(lead)}
          setRefetchAppointment={setRefetchAppointment}
          setSelectedLead={setSelectedLead}
          setMessageFilters={setMessageFilters}
          messageFilters={messageFilters}
          refetchLeads={refetchLeads}
          crmLeadObj={selectedLead?.crmLeadObj}
          isAppointmentChangeFromLead={isAppointmentChangeFromLead}
          spinner={spinner}
          statusList={statusList}
          setstatusList={setstatusList}
          leadList={leadList}
          setShowLeadSection={setShowLeadSection}
          setOpportunityList={setOpportunityList}
          setFilterApplied={setFilterApplied}
          setSelectedLeadId={setSelectedLeadId}
          setActiveOpp={setActiveOpp}
          timeReference={timeReference}
          crmIntegration={crmIntegration}
          crmIntegrationData={crmIntegrationData}
          handleLeadDetailProfile={handleLeadDetailProfile}
          setIsClickonPotentialDuplicate={setIsClickonPotentialDuplicate}
          getLeadDetail={getLeadDetail}
          eventId={eventId}
          userIdMap={userIdMap}
          getMessages={getMessages}
          activeOpportunity={activeOpp}
          languages={languages}
          refreshLeadListData={refetchAfterAppointmentSave}
          selectedOppTypeId={selectedOppTypeId}
          setSelectedOppTypeId={setSelectedOppTypeId}
          unreadByRoot={unreadByRoot}
        />
      </Drawer>
      {openAppointmentDrawer && (
        <AppointmentModal
          lead={selectedLead}
          openAppointmentDrawer={openAppointmentDrawer}
          refetchLeads={refetchAfterAppointmentSave}
          eventId={eventId}
          selectedOppTypeId={selectedOppTypeId}
          assignedUserId={
            (selectedLead?.activeAppointment && selectedLead?.activeAppointment?.user?.id) ||
            user.id
          }
          setOpenDrawer={flag => {
            handleRefetchAndCloseDrawer(flag);
          }}
          leadOpportunities={selectedLead?.leadOpportunities}
          onClick={async (item, flag, updateDate, isClickOnName) => {
            // Use the live selectedLead via ref. This onClick is captured into the
            // appointmentForm dialog payload (via openDialog inside Appointments), so
            // its closure can be stale by the time save fires.
            const liveSelectedLeadId = selectedLeadRef.current?.id;
            if (+item?.id === +liveSelectedLeadId && isClickOnName) {
              setOpenAppointmentDrawer(false);
              return;
            }
            if (isClickOnName) {
              setOpenAppointmentDrawer(false);
              handleLeadDetailProfile(item?.id);
              handleScrollOnMovement();
              return;
            }

            // Same-lead save (typical flow): no scroll-to-top, no profile reload — the lead
            // hasn't moved and is already loaded. Just close the drawer and notify listeners.
            if (+item?.id === +liveSelectedLeadId) {
              setOpenAppointmentDrawer(false);
              setIsAppointmentChangeFromLead(prev => !prev);
              return;
            }

            // Cross-lead save (e.g. lead-changer used inside the form). Skip
            // handleLeadDetailProfile to avoid the localStorage cascade in
            // engagements.js → getLeads refetch → unshift pin. The lead-level
            // updates already happened in refetchAfterAppointmentSave.
            setOpenAppointmentDrawer(false);
            setIsAppointmentChangeFromLead(prev => !prev);
          }}
          refreshLeadListData={refetchAfterAppointmentSave}
        />
      )}
      {openTemplateModal && (
        <TemplateDrawer
          openTemplateDrawer={openTemplateModal}
          setOpenTemplateDrawer={setTemplateModal}
          onApply={handleSetDefinedTemplate}
          leadId={selectedLead?.id}
          showManage
        />
      )}
      <ViewScheduledMessagesPopup
        getMessages={getMessages}
        selectedLead={selectedLead}
        messageText={messageText}
        scheduledMessageDrawer={scheduledMessageDrawer}
        setscheduledMessageDrawer={setscheduledMessageDrawer}
      />
      <style jsx>{`
        .chatContainer::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </>
  );
};

export default EngagementActivity;
